{
  "brand": {
    "entity": "Heraion",
    "product": "Metria"
  },
  "createHub": {
    "title": "Erstellen",
    "open": "Erstellen",
    "close": "Schließen",
    "actionsHeader": "Starten",
    "todayHeader": "Heute",
    "newWorkout": {
      "title": "Neues Workout",
      "sub": "Jetzt ein leeres Workout starten"
    },
    "repeatWorkout": {
      "title": "Workout wiederholen",
      "sub": "Aus einem früheren Workout erneut loggen"
    },
    "buildToday": {
      "title": "Heutige Einheit zusammenstellen",
      "sub": "Übungen für die Muskeln unter dem Mindestvolumen",
      "subInstead": "Statt des heutigen Plans: die Muskeln unter dem Mindestvolumen"
    },
    "planProgram": {
      "title": "Programm planen",
      "sub": "Ein mehrwöchiges Trainingsprogramm erstellen"
    },
    "planWorkout": {
      "title": "Workout planen",
      "sub": "Eine einzelne Einheit für später vorbereiten"
    }
  },
  "library": {
    "header": "Stöbern",
    "tabPrograms": "Programme",
    "tabWorkouts": "Workouts",
    "tabPersonal": "Meine",
    "tabCoach": "Coach",
    "tabFavorites": "Favoriten",
    "favoriteA11y": "Favorit",
    "errFavorite": "Favoriten konnten nicht aktualisiert werden.",
    "emptyFavoritesTitle": "Noch keine Favoriten",
    "emptyFavoritesSub": "Markiere ein Programm oder Workout mit einem Stern, um es hier zu behalten.",
    "sectionOfficial": "Von $t(brand.product)",
    "sectionPersonal": "Meine",
    "clone": "Klonen",
    "copySuffix": "(Kopie)",
    "following": "Wird gefolgt…",
    "alreadyYours": "Bereits vorhanden",
    "cloneFollowed": "Übernehmen",
    "followed": "„{{name}}\" ist jetzt in Laufend.",
    "searchPlaceholder": "Nach Name suchen…",
    "filters": "Filter",
    "clearFilters": "Zurücksetzen",
    "axisLevel": "Niveau",
    "axisPerWeek": "Einheiten / Woche",
    "noResultsTitle": "Keine Treffer",
    "noResultsSub": "Passe Suche oder Filter an.",
    "loading": "Bibliothek wird geladen…",
    "errLoad": "Bibliothek konnte nicht geladen werden.",
    "errClone": "Klonen fehlgeschlagen. Versuch es erneut.",
    "errDelete": "Löschen fehlgeschlagen. Versuch es erneut.",
    "leaveTitle": "Aus deiner Bibliothek entfernen?",
    "leaveBody_one": "{{name}} ist noch {{count}} weiterer Person zugewiesen. Sie behält den Zugriff: das entfernt nur deine Kopie aus der Bibliothek.",
    "leaveBody_other": "{{name}} ist noch {{count}} weiteren Personen zugewiesen. Sie behalten den Zugriff: das entfernt nur deine Kopie aus der Bibliothek.",
    "leaveConfirm": "Entfernen",
    "errLeave": "Entfernen fehlgeschlagen. Versuch es erneut.",
    "unfollow": "Nicht mehr folgen",
    "unfollowHint": "Aus deiner Bibliothek entfernen. Der Autor behält es.",
    "unfollowTitle": "Nicht mehr folgen?",
    "unfollowBody": "{{name}} bleibt bei seinem Autor. Das entfernt es nur aus deiner Bibliothek.",
    "errUnfollow": "Konnte das Folgen nicht beenden. Versuch es erneut.",
    "errFollow": "Programm konnte nicht gefolgt werden.",
    "errStatus": "Programm konnte nicht aktualisiert werden.",
    "errAssign": "Zuweisungen konnten nicht aktualisiert werden.",
    "assignSent": "Gesendet — alle Neuen auf der Liste erhalten eine Anfrage, die sie annehmen oder ablehnen können.",
    "assignSentSelf": "Gesendet — da es von einem Coach verfasst wurde, sieh auch in deinem eigenen Athleten-Posteingang nach, um es anzunehmen oder abzulehnen.",
    "emptyTitle": "Noch nichts hier",
    "emptySub": "Programme und Workouts, die du erstellst oder klonst, erscheinen hier.",
    "emptyCoachTitle": "Noch nichts zugewiesen",
    "emptyCoachSub": "Dir wurde noch kein Programm oder Workout zugewiesen.",
    "assignedBy": "Zugewiesen von {{name}}",
    "followingVersion": "Du folgst {{name}}s Version",
    "followingVersionUnknown": "Du folgst der Version einer anderen Person",
    "saveAsModel": "Als Modell speichern",
    "modelName": "Name des Modells",
    "modelHint": "Lasten werden als % deines MAX gespeichert.",
    "modelSaveError": "Das Modell konnte nicht gespeichert werden. Versuch es noch einmal.",
    "modelSavedTitle": "Modell gespeichert",
    "modelSavedBody": "„{{name}}“ steht unter Neues Programm, Meine Modelle.",
    "modelQueued": "Es wird gespeichert, sobald du wieder online bist.",
    "modelAllKept": "Jede Zeile behält ihre Progression.",
    "modelWarmUps_one": "{{count}} Aufwärmsatz weggelassen.",
    "modelWarmUps_other": "{{count}} Aufwärmsätze weggelassen.",
    "modelToHistory": "Last aus dem Verlauf",
    "modelNoLoad": "Keine Last",
    "modelDone": "Fertig",
    "modelPlan": "Programm planen",
    "modelRow": "{{exercise}}, {{day}}",
    "modelDescFallback": "{{days}}, {{rounds}}.",
    "modelChanged": "Im Modell geändert",
    "modelChangedByHand": "von Hand gesetzte Zellen entfallen",
    "modelChangedEveryRound": "läuft in jeder Runde",
    "modelToHistoryWhy": "Kein MAX, oder Zusatzgewicht bei einer Körpergewichtsübung. Sie steigt nicht.",
    "modelNoLoadWhy": "Das Gewicht wird im neuen Programm gewählt.",
    "saveAsModelHint": "Nutze seine Tage in Neues Programm. Lasten werden zu % deines MAX.",
    "modelShapeDays_one": "{{count}} Tag",
    "modelShapeDays_other": "{{count}} Tage",
    "modelNameEmpty": "Gib ihm einen Namen, um es zu speichern.",
    "modelWaitCatalog": "Übungen werden geladen…",
    "modelMaxesError": "Zum Lesen deiner MAX brauchst du eine Verbindung. Versuch es online noch einmal.",
    "modelCapError": "Du hast 100 Modelle, das Maximum. Lösche eins unter Neues Programm, Meine Modelle."
  },
  "common": {
    "weightUnit_kg": "kg",
    "weightUnit_lb": "lb",
    "lastDataAt": "Letzter Wert {{at}}",
    "noData": "Keine Daten",
    "lastDataOn": "Letzter Wert: {{date}}",
    "languageA11y": "Sprache",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Änderungen verwerfen?",
      "body": "Die nicht gespeicherten Änderungen gehen verloren.",
      "keepEditing": "Weiter bearbeiten",
      "discard": "Verwerfen",
      "exitTitle": "Nicht gespeicherte Änderungen",
      "exitBody": "Diese Änderungen sind nicht gespeichert. Speichere sie, behalte sie als Entwurf auf diesem Gerät oder verwirf sie.",
      "exitBodyNoDraft": "Diese Änderungen sind nicht gespeichert. Speichere sie oder verwirf sie.",
      "save": "Speichern",
      "keepDraft": "Entwurf behalten"
    },
    "relativeAge": {
      "today": "heute",
      "days": "vor {{count}}T",
      "weeks": "vor {{count}} Wo.",
      "months": "vor {{count}} Mon."
    },
    "loadMore": "Mehr laden",
    "loadingMore": "Wird geladen…",
    "pageOf": "{{current}} von {{total}}",
    "weekInProgress": "Laufende Woche",
    "weekDaysToGo_one": "noch {{count}} Tag",
    "weekDaysToGo_other": "noch {{count}} Tage",
    "weekLastDay": "letzter Tag",
    "noFullWeekYet": "Noch keine volle Woche"
  },
  "bodymap": {
    "viewBack": "Rücken",
    "viewFront": "Vorne",
    "workedTitle": "Belastete Muskeln",
    "workedPrimary": "primär",
    "workedSecondary": "sekundär",
    "heatmapTitle": "Meistbelastete Muskeln",
    "heatmapLow": "wenig",
    "heatmapHigh": "viel",
    "window7d": "7 Tage",
    "window30d": "30 Tage",
    "painTitle": "Schmerzkarte",
    "painHelp": "Tippe einen Muskel, um ihn zu markieren, jede Seite für sich: rot (keine schweren Lasten), gelb (Vorsicht). Wird automatisch gespeichert.",
    "painRed": "meiden",
    "painYellow": "Vorsicht",
    "painClearAll": "Alles löschen",
    "painSaving": "Speichern…",
    "painSaveError": "Speichern fehlgeschlagen. Verbindung prüfen.",
    "painRiskA11y": "Schmerzrisiko: {{severity}}",
    "painRiskSideA11y": "Schmerzrisiko: {{severity}}, {{side}}",
    "painBannerMuscleSide": "{{muscle}} (<side>{{side}}</side>)",
    "painSideOnly": {
      "left": "nur linke Seite",
      "right": "nur rechte Seite"
    },
    "painSeverity": {
      "red": "hoch",
      "yellow": "mittel",
      "green": "gering"
    },
    "painPart": {
      "chest": "deine Brust",
      "chest_left": "die linke Seite deiner Brust",
      "chest_right": "die rechte Seite deiner Brust",
      "biceps": "deine Bizepse",
      "biceps_left": "deinen linken Bizeps",
      "biceps_right": "deinen rechten Bizeps",
      "triceps": "deine Trizepse",
      "triceps_left": "deinen linken Trizeps",
      "triceps_right": "deinen rechten Trizeps",
      "forearm": "deine Unterarme",
      "forearm_left": "deinen linken Unterarm",
      "forearm_right": "deinen rechten Unterarm",
      "front-deltoids": "deine Schultern",
      "front-deltoids_left": "deine linke Schulter",
      "front-deltoids_right": "deine rechte Schulter",
      "back-deltoids": "deine Schultern",
      "back-deltoids_left": "deine linke Schulter",
      "back-deltoids_right": "deine rechte Schulter",
      "trapezius": "deinen Trapezmuskel",
      "trapezius_left": "die linke Seite deines Trapezmuskels",
      "trapezius_right": "die rechte Seite deines Trapezmuskels",
      "upper-back": "deinen oberen Rücken",
      "upper-back_left": "die linke Seite deines oberen Rückens",
      "upper-back_right": "die rechte Seite deines oberen Rückens",
      "lower-back": "deinen unteren Rücken",
      "lower-back_left": "die linke Seite deines unteren Rückens",
      "lower-back_right": "die rechte Seite deines unteren Rückens",
      "abs": "deine Bauchmuskeln",
      "abs_left": "die linke Seite deiner Bauchmuskeln",
      "abs_right": "die rechte Seite deiner Bauchmuskeln",
      "obliques": "deine schrägen Bauchmuskeln",
      "obliques_left": "deine linken schrägen Bauchmuskeln",
      "obliques_right": "deine rechten schrägen Bauchmuskeln",
      "quadriceps": "deine Quadrizepse",
      "quadriceps_left": "deinen linken Quadrizeps",
      "quadriceps_right": "deinen rechten Quadrizeps",
      "hamstring": "deine Beinbeuger",
      "hamstring_left": "deinen linken Beinbeuger",
      "hamstring_right": "deinen rechten Beinbeuger",
      "gluteal": "dein Gesäß",
      "gluteal_left": "deine linke Gesäßhälfte",
      "gluteal_right": "deine rechte Gesäßhälfte",
      "adductors": "deine Adduktoren",
      "adductors_left": "deine linken Adduktoren",
      "adductors_right": "deine rechten Adduktoren",
      "abductors": "deine Abduktoren",
      "abductors_left": "deine linken Abduktoren",
      "abductors_right": "deine rechten Abduktoren",
      "calves": "deine Waden",
      "calves_left": "deine linke Wade",
      "calves_right": "deine rechte Wade",
      "tibialis": "deine Schienbeine",
      "tibialis_left": "dein linkes Schienbein",
      "tibialis_right": "dein rechtes Schienbein",
      "neck": "deinen Nacken",
      "neck_left": "die linke Seite deines Nackens",
      "neck_right": "die rechte Seite deines Nackens",
      "head": "deinen Kopf",
      "head_left": "die linke Seite deines Kopfes",
      "head_right": "die rechte Seite deines Kopfes"
    },
    "painSummaryAvoid": "Meiden: {{parts}}",
    "painSummaryCaution": "Vorsicht: {{parts}}",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "zoomReset": "Zoom zurücksetzen",
    "zoomPinchHint": "Mit zwei Fingern zoomen oder die Tasten nutzen.",
    "painListToggle": "Muskeln als Liste",
    "painListLeft": "{{muscle}} (links)",
    "painListRight": "{{muscle}} (rechts)",
    "painStateRed": "Keine schweren Lasten",
    "painStateYellow": "Vorsicht",
    "painStateNone": "Nicht markiert",
    "painListRowA11y": "{{muscle}}, {{state}}"
  },
  "plates": {
    "title": "Hantelscheiben",
    "openHint": "Scheibenverteilung anzeigen",
    "close": "Schließen",
    "targetLabel": "Ziel",
    "barLabel": "Stange",
    "barAria": "Stangengewicht",
    "barNone": "Ohne Stange",
    "perSide": "Pro Seite",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Nur die Stange — keine Scheiben nötig.",
    "belowBar": "Das Ziel ist leichter als die Stange.",
    "invalidInput": "Erst ein gültiges Gewicht eingeben.",
    "remainder": "+{{weight}} unter dem Ziel mit dem aktuellen Bestand.",
    "fallbackPill": "höchstmöglich",
    "inventoryLegend": "Verfügbare Paare",
    "inventoryHint": "Paare jeder Scheibe, die gerade verfügbar sind. 0 setzen, wenn das Studio sie nicht hat oder das Rack leer ist. Sitzungsübergreifend gespeichert.",
    "pairsAria": "Paare {{plate}} verfügbar",
    "loadedSide": "Beladene Seite",
    "singleSideHint": "Nur eine Seite: Die Scheiben kommen auf eine einzige Seite. Landmine, T-Bar, Schlitten und Hebel pro Arm werden so beladen."
  },
  "app": {
    "title": "$t(brand.product)",
    "tagline": "Krafttraining, schlicht protokolliert.",
    "signedInAs": "Angemeldet als <bold>{{email}}</bold>.",
    "signOut": "Abmelden",
    "loading": "Lädt…",
    "checking": "wird geprüft…"
  },
  "auth": {
    "signIn": "Anmelden",
    "signInFailed": "Anmeldung fehlgeschlagen. Prüfe E-Mail und Passwort.",
    "email": "E-Mail",
    "emailPlaceholder": "email@beispiel.com",
    "password": "Passwort",
    "passwordRules": {
      "length": "Mindestens 10 Zeichen",
      "uppercase": "Ein Grossbuchstabe",
      "lowercase": "Ein Kleinbuchstabe",
      "number": "Eine Ziffer",
      "met": "erledigt",
      "unmet": "fehlt noch"
    },
    "revealPassword_one": "Passwort anzeigen",
    "revealPassword_other": "Passwörter anzeigen",
    "hidePassword_one": "Passwort verbergen",
    "hidePassword_other": "Passwörter verbergen",
    "passwordHint": "Mindestens 10 Zeichen mit Gross- und Kleinbuchstaben sowie einer Ziffer.",
    "invitedOnly": "Konten werden auf Einladung erstellt. Wenn du eingeladen wurdest, melde dich mit der Adresse und dem temporären Passwort an, die du per E-Mail bekommen hast.",
    "submitting": "Wird verarbeitet…",
    "confirmTitle": "E-Mail bestätigen",
    "confirmHelp": "Wir haben einen Code an <bold>{{email}}</bold> gesendet. Fügen Sie ihn unten ein, um die Registrierung abzuschliessen.",
    "confirmCode": "Bestätigungscode",
    "confirmSubmit": "Bestätigen",
    "confirming": "Wird bestätigt…",
    "resendCode": "Code erneut senden",
    "resentInfo": "Code erneut gesendet. Schau in dein Postfach.",
    "confirmedNowSignIn": "Konto bestätigt. Melden Sie sich an, um fortzufahren.",
    "forgotEmailRequired": "Gib die E-Mail-Adresse ein, mit der du dich anmeldest.",
    "forgotCodeRequired": "Gib den Code ein, den wir dir geschickt haben.",
    "forgotLink": "Passwort vergessen?",
    "forgotTitle": "Passwort zurücksetzen",
    "forgotIntro": "Gib deine E-Mail-Adresse an. Wir senden dir einen Code, um das Passwort zurückzusetzen.",
    "forgotSendCode": "Code senden",
    "forgotCodeSent": "Code gesendet. Bitte das Postfach prüfen.",
    "forgotConfirmHelp": "Code an <bold>{{email}}</bold> gesendet. Gib ihn unten ein.",
    "forgotResetSubmit": "Passwort zurücksetzen",
    "forgotResetDone": "Passwort aktualisiert. Bitte mit dem neuen Passwort anmelden.",
    "newPassword": "Neues Passwort",
    "backToSignIn": "Zurück zur Anmeldung",
    "welcome": {
      "title": "Willkommen bei $t(brand.product)",
      "help": "Du wurdest eingeladen. Wähle das Passwort, das du ab jetzt verwendest, und sag uns, wie wir dich nennen sollen.",
      "name": "Wie sollen wir dich nennen?",
      "namePlaceholder": "Dein Name",
      "nameRequired": "Gib einen Namen an — so begrüsst dich die App.",
      "submit": "Eintreten"
    },
    "confirmPassword": "Passwort bestätigen",
    "passwordsMatch": "Die beiden stimmen überein.",
    "passwordMismatch": "Die beiden Passwörter stimmen nicht überein.",
    "forgotCodeSubmit": "Weiter",
    "forgotCodeIncomplete": "Gib alle sechs Ziffern des Codes ein.",
    "forgotPasswordHelp": "Wähle das Passwort, das du ab jetzt verwendest.",
    "backStep": "Zurück",
    "forgotStep": "Schritt {{n}} von 3",
    "forgotCodeWrong": "Der Code stimmt nicht. Prüf ihn und versuch es erneut.",
    "forgotCodeExpired": "Der Code ist abgelaufen. Fordere einen neuen an.",
    "forgotTooManyAttempts": "Zu viele Versuche. Warte ein paar Minuten und versuch es erneut.",
    "forgotTooManyRequests": "Zu viele Codes angefordert. Warte ein paar Minuten.",
    "resendCodeIn": "Code erneut senden ({{seconds}} s)"
  },
  "dashboard": {
    "meTitle": "Authentifizierter Round-Trip — /api/me",
    "healthTitle": "API-Status",
    "exportData": "Meine Daten exportieren",
    "deleteAccount": "Mein Konto löschen",
    "exporting": "Export wird vorbereitet…",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Damit werden Ihr Konto und alle Ihre Daten dauerhaft gelöscht. Geben Sie LÖSCHEN zur Bestätigung ein.",
    "deleteCancel": "Abbrechen",
    "deletePlaceholder": "LÖSCHEN",
    "deleteSuccess": "Konto gelöscht.",
    "exportFilename": "metria-export-{{date}}.json",
    "privacyTitle": "Datenschutz",
    "privacyHelp": "Alle Daten als JSON exportieren oder das Konto vollständig löschen. Löschungen sind endgültig."
  },
  "privacy": {
    "linkLabel": "Datenschutz",
    "title": "Datenschutzerklärung",
    "lastUpdated": "Zuletzt aktualisiert: 9. September 2026 (Verantwortlicher, Aufbewahrung, Health Connect, Trainerinnen und Trainer)",
    "intro": "Metria ist eine Trainings-App, die unter dem Namen Heraion von Antenore Gatta in der Schweiz herausgegeben wird. Heraion ist keine eingetragene Gesellschaft: Verantwortlicher für Ihre Daten ist eine natürliche Person, und mit ihr haben Sie es zu tun. Diese Erklärung beschreibt, was wir erheben, wozu, wo die Daten liegen, wie lange sie bleiben und was Sie von uns verlangen können.",
    "section1Title": "Was wir erheben",
    "section1Body": "Nur das, was die App zum Funktionieren braucht, und das, was Sie selbst hineingeben. Für ein Konto: Ihre E-Mail-Adresse, die zugleich der Konto-Identifikator ist, und ein Passwort, das Amazon Cognito nur als kryptografischen Hash speichert — der Klartext erreicht uns nie. Im Profil: ein Anzeigename, der erforderlich ist und durchaus ein Spitzname statt Ihres bürgerlichen Namens sein darf, sowie, wenn Sie sie ausfüllen, eine Altersspanne und das biologische Geschlecht, die die App für die Körperfettformeln und für die gezeichnete Körperfigur verwendet. Dann alles, was Sie beim Training eingeben: Trainings, Sätze, Lasten, Programme, Notizen, persönliche Rekorde und, wenn Sie diese Teile der App nutzen, Körpermasse, Körpergewicht, Schmerzmarkierungen und Gesundheitswerte. Wir fragen weder nach Postadresse noch Telefonnummer, Geburtsdatum oder Zahlungsdaten, und wir setzen weder Analyse- noch Werbe- noch Tracking-Dienste ein: Es gibt nirgends ein Verhaltensprofil von Ihnen. Körpergewicht, Körpermasse, Schmerzmarkierungen und alles, was aus Health Connect gelesen wird, sind Gesundheitsdaten — besondere Kategorie nach Art. 9 DSGVO und besonders schützenswerte Personendaten nach Art. 5 lit. c revDSG — sie werden daher nie aggregiert, nie geloggt, und sie gehen mit Ihrem Konto.",
    "section2Title": "Wo die Daten liegen, und wer sie sonst berührt",
    "section2Body": "Alle Daten werden in der AWS-Region eu-central-2 (Zürich, Schweiz) gespeichert. Amazon Web Services ist der einzige Auftragsverarbeiter, den wir einsetzen: Die Authentifizierung läuft auf Amazon Cognito, strukturierte Daten auf Amazon DynamoDB, der Servercode auf AWS Lambda, und die statischen Dateien der App werden über Amazon CloudFront ausgeliefert. Wir verwenden keinerlei Analyse-, Werbe- oder Tracking-Dienste, wir verkaufen und vermieten Ihre Daten nicht, und wir geben sie an niemanden sonst weiter. Die einzigen zwei Wege, auf denen Ihre Daten weiter reisen, sind die beiden, die Sie selbst einschalten: Health Connect auf Ihrem Telefon und eine Trainerin oder ein Trainer, die oder den Sie einladen. Beide haben unten ihren eigenen Abschnitt.",
    "section3Title": "Ihre Rechte",
    "section3Body": "In der App können Sie Ihren gesamten Datensatz als JSON exportieren und Ihr Konto endgültig löschen; die Löschung entfernt den Authentifizierungseintrag und alles, was unter Ihrem Konto gespeichert ist, ohne Soft-Delete dahinter. Über diese beiden Schaltflächen hinaus haben Sie die Rechte, die Ihnen das Gesetz gibt: zu erfahren, was wir über Sie haben, es berichtigen zu lassen, es löschen zu lassen, eine Kopie in einem übertragbaren Format zu erhalten, einer Bearbeitung zu widersprechen oder deren Einschränkung zu verlangen und eine erteilte Einwilligung zu widerrufen — der Widerruf hält uns für die Zukunft an und macht nicht rechtswidrig, was geschah, solange die Einwilligung galt. Schreiben Sie an {{email}}, es antwortet ein Mensch. Wenn Sie meinen, wir seien mit Ihren Daten falsch umgegangen, können Sie sich auch an eine Aufsichtsbehörde wenden: in der Schweiz an den Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten, in der Europäischen Union an die Behörde des Landes, in dem Sie leben.",
    "section4Title": "Wer verantwortlich ist, und wie Sie uns erreichen",
    "section4Body": "Verantwortlicher für Ihre Daten ist Antenore Gatta, der Metria unter dem Namen Heraion aus der Schweiz herausgibt. Heraion ist ein Projektname, keine eingetragene Gesellschaft, die Verantwortung ist hier also persönlich und nicht die eines Unternehmens. Fragen, Anfragen und Beschwerden: {{email}}.",
    "section5Title": "Rechtsgrundlage",
    "section5Body": "Ihr Konto und Ihre Trainingsdaten werden bearbeitet, um Ihnen den angeforderten Dienst zu erbringen — die Erfüllung der Vereinbarung zwischen uns, Art. 6 Abs. 1 lit. b DSGVO, und derselbe Zweck nach dem schweizerischen Datenschutzgesetz. Gesundheitsdaten — Körpergewicht, Körpermasse, Schmerzmarkierungen und alles, was aus Health Connect gelesen wird — werden nur auf Ihre ausdrückliche Einwilligung hin bearbeitet, Art. 9 Abs. 2 lit. a DSGVO; Sie erteilen sie, indem Sie diesen Teil der App einschalten, und widerrufen sie, indem Sie ihn ausschalten oder die Daten löschen. Wir dehnen kein berechtigtes Interesse auf etwas aus, womit Sie nicht rechnen würden, und wir aktualisieren diese Erklärung, bevor ein neuer Zweck hinzukommt.",
    "section6Title": "Wer Metria nutzen darf",
    "section6Body": "Metria richtet sich nicht an Kinder. Für ein Konto müssen Sie mindestens 13 Jahre alt sein oder älter, wenn das Recht Ihres Landes ein höheres Alter verlangt. Unterhalb dieses Alters muss ein Elternteil oder eine erziehungsberechtigte Person für Sie zustimmen und die Nutzung begleiten. Konten entstehen nicht durch eine öffentliche Registrierung: Jemand, der schon in Metria ist, lädt Sie ein, und das Konto wird für Sie angelegt — eine an eine minderjährige Person gerichtete Einladung muss daher von einem Elternteil oder einer erziehungsberechtigten Person angenommen werden.",
    "section7Title": "Wie lange wir aufbewahren, und was die Löschung entfernt",
    "section7Body": "Solange Ihr Konto besteht, bleibt, was Sie eingegeben haben: Wir lassen Ihre Historie nicht verfallen und schieben sie nicht anderswohin, wenn Sie aufhören zu trainieren. Einiges dauert absichtlich kürzer. Wenn Sie ein Training löschen, tritt für 30 Tage eine Markierung an seine Stelle, damit ein Gerät, das offline war, vom Wegfall der Einheit erfährt; danach verschwindet auch die Markierung. Ein Zwischenspeicher, der verhindert, dass eine Anfrage zweimal ausgeführt wird, behält seinen Eintrag 24 Stunden. Unsere Datenbank wird laufend gesichert und lässt sich auf jeden Zeitpunkt der vorangegangenen 35 Tage zurückspielen; ein von Ihnen gelöschter Datensatz kann also für diese Dauer noch in einer Sicherung existieren, bevor er endgültig weg ist — eine Sicherung spielen wir nur zurück, um einen Ausfall zu beheben, nie um ein von jemandem gelöschtes Konto wiederzubringen. Das Löschen Ihres Kontos entfernt den Authentifizierungseintrag und jeden darunter gespeicherten Datensatz, einschliesslich dessen, was aus Health Connect importiert wurde, und der Trainerverbindung auf beiden Seiten; nach Ablauf des Sicherungsfensters bleibt davon nichts übrig. Eine Sache wird bewusst behalten und abgetrennt statt gelöscht: Eine Rückmeldung, die Sie uns aus der App geschickt haben, bleibt, weil sie von der App handelt und nicht von Ihnen — wer sie geschrieben hat, wird jedoch daraus entfernt.",
    "section8Title": "Health Connect",
    "section8Body": "Unter Android kann Metria sich mit Health Connect verbinden. Es ist aus, bis Sie es in den Einstellungen einschalten, Health Connect fragt jede Datenart einzeln ab, und die App funktioniert auch ohne. Ist es eingeschaltet, liest Metria Ihre Trainings samt Herzfrequenz, Aktivkalorien und Distanz, damit eine von Ihrer Uhr aufgezeichnete Einheit mit ihrer Belastung in Ihrer Timeline erscheint; Ihr Körpergewicht, Ihren Körperfettanteil und Ihre Magermasse, damit der Körperbereich eine Historie statt zweier zeigt; und Ihre Blutzucker- und Ernährungseinträge, damit die Stoffwechselkarte die heutigen Kohlenhydrate und Ihre Blutzuckerwerte neben Ihr Training stellen kann. Zurück nach Health Connect schreibt Metria nur zwei Dinge, und nur solche, die Sie hier selbst eingegeben haben: eine Gewichtsmessung und einen Blutzuckerwert, damit ein in Metria eingetippter Wert nicht in Metria festsitzt. Was wir lesen, verlässt Ihr Telefon: Es liegt auf unseren Servern in Zürich beim Rest Ihrer Daten und unter denselben Regeln — nie für Werbung verwendet, nie verkauft, nie an Dritte weitergegeben, nie zum Trainieren eines Modells benutzt. Es bleibt, bis Sie diese Daten oder Ihr Konto löschen, wie im vorigen Abschnitt beschrieben. Sie können die Verbindung jederzeit in den Einstellungen von Metria trennen oder die Berechtigungen in Health Connect selbst widerrufen; beides beendet jedes weitere Lesen, und die bereits importierten Werte bleiben Ihre und lassen sich in Metria löschen.",
    "section9Title": "Wenn Sie eine Trainerin oder einen Trainer haben",
    "section9Body": "Metria kann Athletin oder Athlet und Trainerin oder Trainer verbinden. Die Verbindung beginnt mit einer Einladung an eine E-Mail-Adresse, die wir auf der Einladung speichern, damit nur die Person mit dieser Adresse sie annehmen kann, und die gelöscht wird, sobald die Verbindung aktiv ist. Solange sie aktiv ist, kann die Trainerin oder der Trainer die Trainingsseite lesen — Einheiten und ihre Ergebnisse, Programme und Ziele, Maximalwerte und Rekorde sowie das Profil — und nichts ändern, ausser die Athletin oder der Athlet hat das Recht erteilt, Ziele zu setzen; selbst erteilen kann sich eine Trainerin oder ein Trainer das nicht. Beide Seiten können die Verbindung jederzeit in der App beenden, und das Beenden stoppt den Zugriff. Wer eine Athletin oder einen Athleten unter dem im vorigen Abschnitt genannten Alter einlädt, braucht das Einverständnis eines Elternteils oder einer erziehungsberechtigten Person: dafür verantwortlich ist die einladende Person, und Metria fragt dieses Einverständnis weder ab noch prüft es.",
    "back": "Zurück"
  },
  "terms": {
    "linkLabel": "Bedingungen",
    "title": "Nutzungsbedingungen",
    "lastUpdated": "Zuletzt aktualisiert: 9. September 2026 (wer wir sind, wie Sie annehmen, Sprachen)",
    "intro": "Diese Bedingungen sind die Vereinbarung zwischen Ihnen und uns über die Nutzung von Metria. Mit der Nutzung der App akzeptieren Sie sie. Wenn Sie sie nicht akzeptieren, nutzen Sie Metria bitte nicht.",
    "section1Title": "Wer wir sind",
    "section1Body": "Metria wird unter dem Namen Heraion von Antenore Gatta in der Schweiz herausgegeben. Heraion ist der Name des Projekts, keine eingetragene Gesellschaft: Ihr Vertragspartner ist eine natürliche Person. Sie erreichen uns unter {{email}}.",
    "section2Title": "Diese Bedingungen",
    "section2Body": "Konten entstehen nicht durch eine öffentliche Registrierung: Jemand, der schon in Metria ist, lädt Sie ein, und das Konto wird für Sie angelegt. Mit der Nutzung von Metria, sobald das Konto besteht — Anmelden, ein Training erfassen —, akzeptieren Sie diese Bedingungen; sie werden damit zur Vereinbarung zwischen Ihnen und uns. Wenn Sie sie nicht akzeptieren, nutzen Sie Metria nicht und bitten Sie uns, das Konto zu löschen. Sind Sie Verbraucherin oder Verbraucher, nimmt Ihnen nichts von dem hier Geschriebenen ein Recht, das Ihnen das Recht Ihres Landes zwingend gewährt.",
    "section3Title": "Wer Metria nutzen darf",
    "section3Body": "Für ein Konto müssen Sie mindestens 13 Jahre alt sein oder älter, wenn das Recht Ihres Landes ein höheres Alter verlangt. Unterhalb dieses Alters muss ein Elternteil oder eine erziehungsberechtigte Person diese Bedingungen für Sie annehmen und die Nutzung begleiten. Das Konto ist persönlich: Behalten Sie Ihr Passwort für sich und sagen Sie uns Bescheid, wenn Sie glauben, dass es jemand anderes kennt.",
    "section4Title": "Metria gibt keine medizinischen Ratschläge",
    "section4Body": "Metria ist ein Trainingswerkzeug. Sie ist kein Medizinprodukt und gibt keine medizinischen Ratschläge. Die angezeigten Gewichte, Wiederholungen und Pausenzeiten sind Vorschläge, berechnet aus den Zahlen, die Sie eingegeben haben — keine Verordnung: Sie entscheiden, was Sie heben, und Sie trainieren auf eigenes Risiko. Krafttraining kann zu Verletzungen führen. Wenn Sie eine Erkrankung oder eine Verletzung haben, schwanger sind oder nach einer langen Pause wieder einsteigen, sprechen Sie vorher mit einer Ärztin oder einem Arzt — und hören Sie auf, sobald etwas wehtut. Jede Schmerzmarkierung, Körpermessung oder jeder Gesundheitswert in der App, auch alles aus Health Connect Importierte, ist die Aufzeichnung dessen, was Sie oder Ihr Gerät eingegeben haben, niemals eine Diagnose: Metria erkennt und überwacht keine Erkrankung.",
    "section5Title": "Was Sie eingeben, bleibt Ihres",
    "section5Body": "Die Trainings, Programme, Messwerte und Notizen, die Sie eingeben, gehören Ihnen. Für den Betrieb des Dienstes brauchen wir eine begrenzte Lizenz, um sie zu speichern, zu sichern, zu verarbeiten und anzuzeigen — Ihnen und den Personen, mit denen Sie sie teilen wollten. Mehr nicht, und sie endet, wenn Sie die Daten oder das Konto löschen. Was wir erheben und warum, steht in der Datenschutzerklärung.",
    "section6Title": "Trainerinnen, Trainer und Athletinnen, Athleten",
    "section6Body": "Wenn Sie jemanden als deren Trainer einladen, brauchen Sie vorher deren Einverständnis — auch dazu, was Sie sehen können. Die Daten bleiben deren Daten: Ihr Zugriff hängt von der Rolle ab, die sie in der App haben, und sie können ihn entziehen. Ist die Athletin oder der Athlet jünger als das im vorigen Abschnitt genannte Alter, brauchen Sie vor der Einladung das Einverständnis eines Elternteils oder einer erziehungsberechtigten Person.",
    "section7Title": "Faire Nutzung",
    "section7Body": "Nutzen Sie Metria im Rahmen des Rechts. Versuchen Sie nicht, auf Konten, Daten oder Teile des Dienstes zuzugreifen, die nicht Ihnen gehören, extrahieren oder verkaufen Sie die Inhalte nicht weiter, laden Sie nichts Rechtswidriges hoch und geben Sie keine Daten einer anderen Person ohne deren Einverständnis ein.",
    "section8Title": "Preis",
    "section8Body": "Metria ist heute kostenlos. Wenn wir kostenpflichtige Funktionen einführen, sagen wir das klar und im Voraus, und die Abrechnung läuft über den Store von Apple oder Google, dessen Regeln Zahlung, Verlängerung und Erstattung bestimmen. Digitale Inhalte, die auf Ihren Wunsch sofort beginnen, können ohne Widerrufsrecht sein; wo das Recht Ihnen eines gibt, bleibt es Ihnen.",
    "section9Title": "Verfügbarkeit und Änderungen",
    "section9Body": "Wir stellen Metria so bereit, wie sie ist und wie sie verfügbar ist: Wir versprechen keinen unterbrechungsfreien oder fehlerfreien Betrieb. Wir können Funktionen hinzufügen, ändern oder entfernen, und vor einer Änderung, die etwas spürbar einschränkt, worauf Sie sich verlassen haben, sagen wir es Ihnen in der App.",
    "section10Title": "Wie es endet",
    "section10Body": "Sie können jederzeit aufhören: Löschen Sie Ihre Daten oder Ihr Konto in der App. Wir können ein Konto sperren oder schliessen, das gegen diese Bedingungen verstösst oder das wir von Rechts wegen schliessen müssen, und sofern es nicht rechtswidrig oder unzumutbar ist, nennen wir Ihnen vorher den Grund. Das Löschen des Kontos entfernt Ihre Daten wie in der Datenschutzerklärung beschrieben.",
    "section11Title": "Haftung",
    "section11Body": "Wir haften für Schäden aus Vorsatz oder grober Fahrlässigkeit, für Verletzungen von Leben, Körper oder Gesundheit und für alles, was das Recht uns nicht zu beschränken erlaubt — einschliesslich Ihrer zwingenden Verbraucherrechte. Darüber hinaus haften wir nicht für mittelbare oder unvorhersehbare Schäden, für Verletzungen aus einem Training, das Sie selbst gewählt haben, oder für Daten, die verloren gingen, weil sie nie exportiert wurden.",
    "section12Title": "Apps von Apple und Google",
    "section12Body": "Wenn Sie die iOS-App nutzen, besteht diese Vereinbarung zwischen Ihnen und uns, nicht mit Apple. Apple ist weder für die App noch für Ansprüche in Bezug auf sie verantwortlich und leistet keinen Support; Apple und seine Tochtergesellschaften können diese Vereinbarung als begünstigte Dritte durchsetzen. Wenn Sie die Android-App nutzen, gelten daneben die Regeln des Stores, aus dem Sie sie installiert haben.",
    "section13Title": "Änderungen dieser Bedingungen",
    "section13Body": "Wir können diese Bedingungen ändern. Die neue Fassung wird hier mit ihrem Datum veröffentlicht, und bei Änderungen, die Sie wirklich betreffen, sagen wir es Ihnen in der App, bevor sie wirksam werden. Nutzen Sie Metria danach weiter, gilt die neue Fassung.",
    "section14Title": "Recht und Streitigkeiten",
    "section14Body": "Es gilt schweizerisches Recht. Sind Sie Verbraucherin oder Verbraucher, behalten Sie zusätzlich den Schutz der zwingenden Vorschriften des Landes, in dem Sie leben, und können die dortigen Gerichte anrufen. Verbraucherinnen und Verbraucher in der Europäischen Union können ausserdem die europäische Online-Streitbeilegungsplattform unter ec.europa.eu/consumers/odr nutzen.",
    "section15Title": "Sprachen",
    "section15Body": "Diese Bedingungen werden auf Englisch, Italienisch, Französisch, Deutsch und Russisch veröffentlicht. Englisch ist die Sprache, in der sie verfasst wurden, und die Fassung, die vorgeht, wenn eine Übersetzung etwas anderes sagt — ausser dort, wo das Recht Ihres Landes der Fassung in Ihrer eigenen Sprache den Vorrang gibt; dann gilt für Sie diese. Die Datenschutzerklärung wird in denselben fünf Sprachen und mit demselben Rang veröffentlicht.",
    "back": "Zurück"
  },
  "errors": {
    "generic": "Etwas ist schiefgelaufen."
  },
  "feedback": {
    "title": "Feedback senden",
    "help": "Bug gefunden, Wunschfunktion, etwas anderes? Hier eintragen. Einreichungen erscheinen im Admin-Posteingang.",
    "kindLabel": "Art",
    "kind_bug": "Fehler",
    "kind_feature": "Funktionswunsch",
    "kind_other": "Sonstiges",
    "kind_crash": "Absturzbericht",
    "bodyLabel": "Was ist passiert?",
    "bodyPlaceholder": "Beschreibe, was du gesehen hast, was du erwartet hast und wie es reproduzierbar ist.",
    "send": "Senden",
    "sending": "Senden…",
    "sentFlash": "Danke — gesendet.",
    "sentHint": "Wir kümmern uns in der nächsten Session darum. Du kannst schliessen.",
    "close": "Schliessen",
    "errEmpty": "Bitte etwas eingeben, bevor du sendest.",
    "errSubmit": "Senden fehlgeschlagen. Bitte gleich erneut versuchen.",
    "errRateLimit": "Zu viele Einsendungen in der letzten Stunde. Bitte später erneut versuchen.",
    "inboxTitle": "Feedback-Posteingang",
    "loading": "Feedback wird geladen…",
    "empty": "Kein Feedback vorhanden.",
    "filterAll": "Alle",
    "loadMore": "Mehr laden",
    "status_open": "Offen",
    "status_in_progress": "In Bearbeitung",
    "status_shipped": "Behoben",
    "status_wontfix": "Nicht behoben",
    "priorityLabel": "Priorität",
    "priorityNone": "Keine",
    "statusLabel": "Status",
    "head_open": "{{count}} offen",
    "head_in_progress": "{{count}} in Bearbeitung",
    "head_shipped": "{{count}} behoben",
    "head_wontfix": "{{count}} nicht behoben",
    "headTotal": "{{count}} insgesamt"
  },
  "profile": {
    "title": "Profil",
    "loading": "Profil wird geladen…",
    "name": "Anzeigename",
    "namePlaceholder": "Wie sollen wir Sie ansprechen?",
    "role": "Rolle",
    "roleCoach": "Coach",
    "roleAthlete": "Athletin/Athlet",
    "roleBoth": "Beides",
    "ageBucket": "Altersgruppe (optional)",
    "ageBucketHelp": "Wird nur für freiwillige anonyme Gruppenstatistiken verwendet. Bleibt leer, wenn Sie nichts angeben.",
    "ageBucketNone": "Keine Angabe",
    "unitsPreference": "Bevorzugte Einheit",
    "unitsPreferenceHelp": "Gewichte werden immer in Kilogramm gespeichert. Pro Trainingseintrag können Sie die Eingabeeinheit jederzeit umstellen.",
    "preferredFigure": "Körperfigur auf der Bodymap",
    "preferredFigureHelp": "Wähle die Figur für die Muskelkarten.",
    "figure_masculine": "Maskulin",
    "figure_feminine": "Feminin",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Profil gespeichert.",
    "agePrefix_under_18": "Unter 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Körpergewicht (optional)",
    "bodyweightPlaceholder": "z. B. 78",
    "bodyweightHelp": "Wird nur zur Berechnung der effektiven Last bei Eigengewichtsübungen verwendet. Niemals aggregiert, niemals geloggt, beim Kontolöschen entfernt.",
    "errBodyweight": "Geben Sie ein Körpergewicht zwischen 20 und 300 kg (oder den Gegenwert in lb) ein.",
    "apk": {
      "title": "Android-APK (Test-Build)",
      "hint": "Test-Build ausschließlich für die Familie. Aktivieren Sie unter Android im Browser „Installation aus unbekannten Quellen“ und öffnen Sie anschließend die Datei.",
      "download": "APK herunterladen"
    },
    "email": "E-Mail",
    "metaTitle": "Sitzung"
  },
  "workout": {
    "title": "Trainings",
    "loading": "Trainings werden geladen…",
    "empty": "Noch keine Trainings erfasst.",
    "logNew": "Training erfassen",
    "startedAt": "Wann",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung auswählen",
    "errPickExercise": "Wählen Sie eine Übung aus dem Katalog.",
    "catalogEmptyCoach": "Der Katalog ist leer. Fügen Sie mindestens eine Übung hinzu, bevor Sie ein Training erfassen.",
    "catalogEmptyAthlete": "Der Katalog ist leer. Eine Ihrer Coaches muss zuerst Übungen anlegen, bevor Sie ein Training erfassen können.",
    "setsLegend": "Sätze",
    "set": "Satz",
    "reps": "Wdh.",
    "amrapHint": "AMRAP — den vorgegebenen Mindestwert übertreffen",
    "weight": "Gewicht",
    "extra": "Zusatz (+/−)",
    "unit": "Einheit",
    "rpe": "RPE",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "notes": "Notizen (optional)",
    "setNoteToggle": "Notiz zu diesem Satz hinzufügen",
    "setNotePlaceholder": "Was an diesem Satz anders war",
    "prefillFromDate": "Aus dem Training vom {{date}} vorausfüllen?",
    "prefillAccept": "Übernehmen",
    "savePromptTitle": "Vor dem Speichern prüfen",
    "savePromptContinue": "Zurück zum Training",
    "savePromptAnyway": "Trotzdem speichern",
    "unmarkedPromptBody": "{{count}} Sätze mit Werten, aber ohne Abschluss-Markierung.",
    "unmarkedPromptFail": "Als fehlgeschlagen markieren und speichern",
    "unmarkedPromptComplete": "Als erledigt markieren und speichern",
    "outlierPromptBody": "{{count}} Einträge wirken ungewöhnlich:",
    "outlierItem": "{{exercise}}: {{weight}} (historisches Max {{expected}})",
    "outlierE1rmItem": "{{exercise}}: geschätztes 1RM {{e1rm}} (historisches Max {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} ist etwa das Doppelte deines üblichen {{expected}} — hast du das Gewicht EINER Hantel eingetragen oder das von beiden zusammen?",
    "outlierRepsItem": "{{exercise}}: {{reps}} Wiederholungen — wirkt zu hoch",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} Wiederholungen ohne Gewicht",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Training gespeichert.",
    "savedEdit": "Training aktualisiert.",
    "deleted": "Training gelöscht.",
    "cancel": "Abbrechen",
    "errNoSets": "Fügen Sie mindestens einen gültigen Satz hinzu.",
    "creatingTitle": "Neues Training",
    "editingTitle": "Training bearbeiten",
    "exerciseN": "Übung {{n}}",
    "addExercise": "Weitere Übung hinzufügen",
    "removeExercise": "Übung entfernen",
    "removeExerciseConfirm": "{{name}} aus diesem Training entfernen? Bereits eingetragene Sätze gehen verloren.",
    "groupAlignTitle": "Unterschiedliche Satzanzahl",
    "groupAlignBody": "Die Mitglieder dieser Gruppe haben zwischen {{shortest}} und {{longest}} Sätzen. Aneinander angleichen, damit die Runden zusammenpassen?",
    "groupAlignPad": "+ Auf {{n}} erweitern",
    "groupAlignTrim": "− Auf {{n}} kürzen",
    "groupAlignTrimWarning": "Kürzen löscht bereits erfasste Sätze, und das lässt sich nicht rückgängig machen.",
    "groupAlignTrimHint": "Löscht die überzähligen Sätze bei jedem Mitglied der Gruppe. Nicht rückgängig zu machen.",
    "groupAlignKeep": "So lassen",
    "splitGroup": "Auflösen",
    "splitGroupTitle": "Gruppe auflösen?",
    "splitGroupBody": "Die Übungen behalten ihre Sätze und bleiben im Workout, sind nur nicht mehr verknüpft. Du kannst sie jederzeit wieder gruppieren.",
    "splitGroupConfirm": "Auflösen",
    "removeRoundConfirmTitle": "Diese Runde entfernen?",
    "removeRoundConfirmBody": "Runde {{n}} von {{names}} wird gemeinsam entfernt.",
    "bilateral": "Bilateral",
    "unilateral": "Unilateral",
    "edit": "Bearbeiten",
    "repeat": "Wiederholen",
    "delete": "Löschen",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Dieses Training löschen?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Dauer",
    "cardioDistance": "Distanz",
    "cardioWeight": "Gewicht",
    "cardioHr": "Ø Puls",
    "cardioCalories": "Kalorien",
    "cardioOptionalsShow": "Weitere Felder",
    "cardioOptionalsHide": "Weitere Felder",
    "dateEditor": "Datum & Dauer",
    "dateLabel": "Datum",
    "startTimeLabel": "Start",
    "endTimeLabel": "Ende",
    "durationLabel": "Dauer",
    "side": "Seite",
    "sideLeft": "Links",
    "sideRight": "Rechts",
    "sideBoth": "Beide",
    "showRpe": "RPE erfassen",
    "showDuration": "Dauer erfassen",
    "rir": "RIR {{n}}",
    "swap": "Tauschen",
    "swapHint": "Bank besetzt? Wählen Sie eine ähnliche Übung.",
    "descriptionToggle": "Beschreibung ein-/ausblenden",
    "failShort": "F",
    "failToggle": "Satz als gescheitert markieren",
    "failHint": "Letzte Wiederholung verfehlt. Zählt im Volumen, von PR ausgeschlossen.",
    "startRest": "Pausentimer starten",
    "restStartDefault": "Pause starten ({{n}}s)",
    "restStartCustom": "Pause starten ({{n}}s, Übungsstandard)",
    "setComplete": "Satz als erledigt markieren",
    "setCompleteHint": "Satz abstempeln und {{n}} s Pause starten.",
    "setCompleteHintCustom": "Satz abstempeln und {{n}} s Pause starten (Übungsstandard).",
    "setUndo": "Markierung zurücknehmen",
    "setUndoHint": "Erneut tippen, um zurückzunehmen und den Pausentimer zurückzusetzen.",
    "restLeft": "Pause",
    "restDone": "Zeit abgelaufen",
    "restStop": "Stopp",
    "restPause": "Anhalten",
    "restResume": "Fortsetzen",
    "restSound": "Signal am Pausenende",
    "instructions": "Hinweise des Coaches (optional)",
    "instructionsPlaceholder": "Fokus der Einheit, was bei Zeitnot weggelassen werden darf, Absicht.",
    "lastTime": "Letztes",
    "lastToday": "heute",
    "lastDaysAgo": "vor {{n}} T",
    "dropsetShort": "Drop",
    "dropsetToggle": "Dropset-Kette hinzufügen",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Klassisch (Last reduzieren)",
    "dropsetMyorep": "Myo-Rep (gleiche Last)",
    "dropsetHintClassical": "Last um 10–30 % senken und bis zum Versagen weiterführen. Keine Pause.",
    "dropsetHintMyorep": "Gleiche Last, weniger Wiederholungen, 10–20 s Atempause, wiederholen.",
    "dropsetSameLoad": "= oben",
    "dropsetAddStep": "Drop hinzufügen",
    "dropsetRemove": "Entfernen",
    "dropsetRemoveConfirm": "Du hast {{n}} Drop-Steps. Zurück in einen normalen Satz konvertieren und sie verwerfen?",
    "dropsetRemoveStep": "Drop entfernen",
    "groupLabel": "Gruppe",
    "groupNone": "(keine)",
    "groupCreate": "Neu anlegen",
    "groupNewSuperset": "Neues Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupLeave": "Gruppe auflösen",
    "groupSharedHint": "Geteilt. Öffnen Sie eine weitere Übung und wählen Sie dieselbe Gruppe aus der Liste, um sie zu verknüpfen.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Zirkel {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Erkannt aus dem Wechsel der Sätze in dieser Einheit",
    "playActiveTitle": "Aktive Übung — zuletzt abgeschlossener Satz",
    "errGroupKindMixed": "Eine Gruppe darf Superset und Zirkel nicht mischen. Wählen Sie einen Typ.",
    "exerciseNew": "Neue Übung",
    "cardMenu": "Übungsoptionen",
    "menuReplace": "Übung ersetzen",
    "menuGroup": "Gruppe / Superset",
    "menuMoveUp": "Nach oben verschieben",
    "menuMoveDown": "Nach unten verschieben",
    "menuShowNotes": "Notizen anzeigen",
    "menuHideNotes": "Notizen ausblenden",
    "menuShowDescription": "Beschreibung anzeigen",
    "menuHideDescription": "Beschreibung ausblenden",
    "tipAlternatives": "Alternative Übungen",
    "tipCoachNote": "Coach-Notiz",
    "perImplementHint": "Zwei im Einsatz, oder eine Seite nach der anderen? Trag das Gewicht von einem ein. Die App zählt beide (×2).",
    "tipProgramNote": "In diesem Training",
    "tipNoAlternatives": "Keine ähnlichen Übungen im Katalog",
    "tipClose": "Schließen",
    "painBanner": {
      "red": "Belastet einen schmerzhaften Muskel",
      "yellow": "Vorsicht: belastet einen markierten Muskel",
      "green": "Kein Schmerzrisiko"
    },
    "setCycleHint": "Tippen: erledigt · erneut: gescheitert · erneut: zurück",
    "setStatePending": "Satz offen",
    "setStateDone": "Satz erledigt",
    "setStatePr": "Satz erledigt, persönliche Bestleistung",
    "setStateFailed": "Satz als gescheitert markiert",
    "prShort": "🏆",
    "addDrop": "+ Drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "ZIRKEL",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Sperren",
    "groupAutoConfirmAria": "Gruppe sperren: Erkennung beenden und Übungen verbunden halten",
    "groupAutoDismissAria": "Erkennung ignorieren: Übungen zurück zu Einzelübungen",
    "groupAddSetAll": "Satz zu allen hinzufügen",
    "nameLabel": "Name (optional)",
    "namePlaceholder": "z. B. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "Dauer-Stepper",
    "rirLabel": "RIR",
    "showRir": "RIR erfassen",
    "maxDownA11y": "MAX ist möglicherweise gesunken",
    "animationOf": "Animation von {{name}}",
    "animationZoomHint": "Öffnet die Animation im Vollbild",
    "closeAnimation": "Animation schließen",
    "showAnimation": "Animation anzeigen",
    "showBodyMap": "Beanspruchte Muskeln anzeigen",
    "pagerDot": "{{target}}, {{current}} von {{total}}",
    "pagePrev": "Vorherige Seite",
    "pageNext": "Nächste Seite",
    "editUnsupportedTitle": "Bearbeiten noch nicht unterstützt",
    "editUnsupportedBody": "Dieses Workout enthält Übungstypen (P1RM, Loaded Carry), die der Logger noch nicht bearbeiten kann."
  },
  "program": {
    "title": "Programme",
    "help": "Mehrwöchige Trainingszyklen. Phase 5.1 liefert das Gerüst: Name, Wochen, Einheiten pro Woche. Der Slot- und Progressions-Builder folgt.",
    "new": "Neues Programm",
    "newTitle": "Neues Programm",
    "name": "Name",
    "namePlaceholder": "z.B. Powerbuilding 6 Wochen",
    "cycleWeeks": "Wochen pro Zyklus",
    "sessionsPerWeek": "Einheiten pro Woche",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Wofür der Zyklus dient, an wen er sich richtet, Hinweise für die Athleten.",
    "create": "Erstellen",
    "creating": "Neues Programm: {{name}}",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "deleteConfirm": "Bestätigen?",
    "deleteConfirmYes": "Ja, löschen",
    "loading": "Programme werden geladen…",
    "empty": "Noch keine Programme. Erstellen Sie eines, um einen mehrwöchigen Zyklus zu planen.",
    "statusDraft": "Entwurf",
    "statusActive": "Aktiv",
    "statusArchived": "Archiviert",
    "cycleWeeksLabel": "{{n}}-Wochen-Zyklus",
    "sessionsPerWeekLabel": "{{n}}× / Woche",
    "slotCount": "{{n}} Slot(s)",
    "skeletonHint": "Nur das Gerüst. Slots werden in der nächsten Phase gefüllt.",
    "sessionDefaultName": "Einheit {{n}}",
    "edit": "Bearbeiten",
    "editing": "Bearbeiten: {{name}}",
    "assign": "Zuweisen",
    "backToList": "Zurück zu den Programmen",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "errSave": "Programm konnte nicht gespeichert werden.",
    "metaLegend": "Programm",
    "status": "Status",
    "metaCyclesLive": "Strukturänderungen (Tage, Wochen) werden sofort übernommen",
    "ordinalSession": "{{n}}. Einheit",
    "sessionName": "Name der Einheit",
    "slotN": "Slot {{n}}",
    "addSlot": "Slot hinzufügen",
    "removeSlot": "Entfernen",
    "moveUp": "Nach oben verschieben",
    "moveDown": "Nach unten verschieben",
    "exercise": "Übung",
    "exercisePick": "Übung auswählen",
    "setsLegend": "Sätze",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "reps": "Wdh",
    "setNotesPlaceholder": "Notiz zum Satz (optional)",
    "set": "Satz",
    "intensityKind": "Intensität",
    "intensityNone": "Frei",
    "intensityPercent": "% des MAX",
    "intensityAbs": "kg (absolut)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Prozent",
    "intensity_absolute": "Gewicht (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "W{{n}}",
    "previewShow": "Vorschau",
    "previewHide": "Vorschau ausblenden",
    "previewMuscles": "Beanspruchte Muskeln",
    "previewSets": "{{n}} Sätze",
    "previewEmptySession": "Keine Slots in dieser Einheit.",
    "previewEmptyProgram": "Noch keine Slots. Öffnen Sie Bearbeiten, um welche hinzuzufügen.",
    "start": "Einheit starten",
    "startCancel": "Abbrechen",
    "startGo": "Starten",
    "starting": "Wird gestartet…",
    "startWeek": "Woche",
    "startSession": "Einheit",
    "progressNext": "Nächste: W{{w}} · Einheit {{s}}",
    "instructions": "Anweisungen",
    "instructionsPlaceholder": "Tempo, Pausendauer, technischer Fokus, RPE-Ziel.",
    "amrapLastSet": "AMRAP im letzten Satz",
    "maxAttempt": "1MAX-Versuch",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Angewendet über die {{n}} Wochen des Zyklus.",
    "catalogLoading": "Übungskatalog wird geladen…",
    "builderComingSoon": "Der Slot- und Progressions-Builder folgt in Phase 5.2. Vorerst legt das eine leere Hülle an, die Sie löschen oder später füllen können.",
    "errCycleWeeks": "Die Wochen müssen zwischen 1 und 12 liegen.",
    "errSessionsPerWeek": "Die Einheiten pro Woche müssen zwischen 1 und 7 liegen.",
    "errName": "Der Programmname ist erforderlich.",
    "errSchema": "Ungültige Programmdaten.",
    "errCreate": "Programm konnte nicht erstellt werden.",
    "errCode": {
      "sessionNameEmpty": "Jeder Trainingstag braucht einen Namen.",
      "slotNoExercise": "Wähle für jeden Slot eine Übung.",
      "slotNoSets": "Jede Übung braucht mindestens einen Satz.",
      "slotAllWeeksInactive": "Eine Übung ist in allen Wochen deaktiviert. Aktiviere eine Woche oder entferne sie.",
      "rowWidthMismatch": "Eine Satzzeile passt nicht zur Anzahl der Wochen. Öffne die Übung neu und versuche es erneut.",
      "invalidReps": "Prüfe die Wiederholungen: nutze eine Zahl wie 8, oder 8+ für AMRAP.",
      "groupKindMixed": "Ein Supersatz mischt Satztypen. Gib seinen Übungen denselben Typ.",
      "schemaInvalid": "Ungültige Programmdaten.",
      "noSession": "Es gibt kein Training zum Speichern.",
      "planNameEmpty": "Der Plan-Name ist erforderlich.",
      "planNoExercises": "Füge dem Plan mindestens eine Übung hinzu.",
      "invalidIntensityValue": "Prüfe den Intensitätswert: er muss eine Zahl sein.",
      "weightOutOfRange": "Dieses Gewicht liegt außerhalb des Bereichs.",
      "pctOutOfRange": "Der Prozentsatz muss zwischen 0 und 200 liegen.",
      "rpeOutOfRange": "RPE muss zwischen 1 und 10 liegen.",
      "rirOutOfRange": "RIR muss zwischen 0 und 10 liegen.",
      "unknownIntensityKind": "Unbekannter Intensitätstyp.",
      "invalidSeconds": "Prüfe die Sekunden: ein Satz auf Zeit braucht eine Dauer, in ganzen Sekunden bis 3600.",
      "invalid_email": "Diese E-Mail-Adresse sieht ungültig aus.",
      "email_not_found": "Kein Konto mit dieser E-Mail-Adresse gefunden.",
      "too_many_assignees": "Höchstens 20 Personen pro Programm.",
      "programNameEmpty": "Der Programmname ist erforderlich.",
      "sessionEmpty": "Jeder Trainingstag braucht mindestens eine Übung.",
      "sessionTooManyExercises": "Ein Trainingstag kann höchstens 20 Übungen haben.",
      "amrapWithTime": "Ein Satz auf Zeit kann nicht zugleich AMRAP sein. Entferne eines von beiden.",
      "client_outdated": "Aktualisiere die App, um dieses Programm zu speichern.",
      "invalidRepsRange": "Prüfe den Bereich: ein unteres und ein oberes Ende um das Ziel, wie 8-12 um 10."
    },
    "cardMenu": "Slot-Menü",
    "menuGroup": "Gruppe",
    "groupNone": "Keine Gruppe",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupCreate": "Erstellen",
    "groupNewSuperset": "Neuer Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Zirkel {{letter}}",
    "assignTo": "Athleten zuweisen",
    "assignToHelp": "Eine Zuweisung ist ein Vorschlag: Sie landet erst in der Bibliothek, wenn sie angenommen wird, und Angenommenes bleibt beim Entfernen. Trainerverbindung erforderlich.",
    "assignSelf": "Sie (Autor)",
    "addAssignee": "Hinzufügen",
    "removeAssignee": "Entfernen",
    "removeAssigneeConfirm": "Zugriff entfernen?",
    "removeAssigneeHint": "Verliert es dadurch aus der eigenen Bibliothek. Erneut tippen, um zu entfernen.",
    "pendingAssigneeCaption": "Ausstehend",
    "rosterSectionLabel": "Aus Ihrem Kader",
    "rosterEmpty": "Noch keine Athletinnen oder Athleten in Ihrem Kader.",
    "rosterAllAssigned": "Alle Athletinnen und Athleten in Ihrem Kader sind bereits zugewiesen.",
    "shareTo": "Teilen mit",
    "shareToHelp": "Teilen ist ein Angebot: Es erreicht die Bibliothek der Person nur, wenn sie annimmt, und was angenommen wurde, bleibt ihr auch, wenn Sie sie entfernen.",
    "shareSectionLabel": "Personen, mit denen Sie teilen können",
    "shareEmpty": "Sie haben noch niemanden, mit dem Sie teilen können.",
    "shareAllShared": "Alle, mit denen Sie teilen können, haben es bereits.",
    "emailSectionLabel": "Per E-Mail",
    "assigneePlaceholder": "athlet@beispiel.com",
    "invalidEmailFormat": "Das sieht nicht nach einer gültigen E-Mail-Adresse aus.",
    "follow": "Folgen",
    "unfollow": "Nicht mehr folgen",
    "followHint": "Diesem Programm folgen (erscheint unter Laufend)",
    "publish": "Veröffentlichen",
    "unpublish": "Zurück zum Entwurf",
    "publishAndFollow": "Veröffentlichen und folgen",
    "publishHint": "Dieses Programm zum Folgen verfügbar machen",
    "chipDraft": "Entwurf",
    "chipPublished": "Veröffentlicht",
    "chipFollowed": "Folge ich",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "VERL",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Sprache",
    "languageA11y": "Sprache zum Schreiben",
    "languageSwitchQuestion": "In welcher Sprache schreibst du?",
    "languageDeclareQuestion": "In welcher Sprache ist dieses Programm geschrieben?",
    "languageFootnote": "Übersetzungen sind optional. Ein Programm in einer Sprache ist vollständig.",
    "languageDeclareFootnote": "Es wird nichts übersetzt: das hält nur die Sprache fest.",
    "languageAuto": "Maschinelle Übersetzung",
    "languageNotYetWritten": "Noch keine Fassung auf {{lang}}. Der Text auf {{original}} bleibt erhalten.",
    "setBound": "Grenze",
    "boundReps": "Wdh",
    "boundTime": "Zeit",
    "boundOpen": "Offen",
    "workSeconds": "Arbeit (s)",
    "restSeconds": "Pause (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Zeit",
    "prescribeTimeA11y": "Arbeit und Pause in Sekunden vorgeben",
    "seconds": "Sekunden",
    "amrapNotWithTime": "Ein {{secs}}s-Satz kann kein AMRAP sein: ein Plan kann nicht fragen, wie viele du schaffst. Nimm das + oder die Zeit weg.",
    "workSecondsRequired": "Wie lange?",
    "descriptionAdd": "Beschreibung hinzufügen",
    "descriptionExpand": "Öffnet die Beschreibung zum Bearbeiten",
    "descriptionCollapse": "Beschreibung einklappen",
    "undo": "Rückgängig",
    "redo": "Wiederholen",
    "saveStatus": {
      "saving": "Wird gespeichert…",
      "unsaved": "Nicht gespeichert",
      "queued": "Offline",
      "saved": "Gespeichert"
    },
    "draftConflict": {
      "title": "Das Programm hat sich geändert",
      "body": "Es wurde woanders geändert, nachdem dein Entwurf begonnen wurde. Deinen Entwurf behalten oder die aktuelle Version verwenden? Es ändert sich nichts, bis du auf Speichern tippst.",
      "keepDraft": "Meinen Entwurf behalten",
      "useUpdated": "Aktuelle Version verwenden"
    },
    "savedElsewhere": {
      "body": "Es wurde woanders geändert, seit du es geöffnet hast. Nichts wurde gespeichert. Wenn du deinen Entwurf behältst, ersetzt er diese Version.",
      "statusNotApplied": "Deine Statusänderung wurde nicht übernommen."
    },
    "savedStaysOpen": "Gespeichert. Der Editor bleibt geöffnet.",
    "savedQueuedStaysOpen": "In der Warteschlange: wird gesendet, sobald das Netz zurück ist.",
    "newDraft": {
      "title": "Ein Entwurf in Arbeit",
      "body": "Ein am {{when}} auf diesem Gerät begonnener Entwurf wurde nie gespeichert. Fortsetzen oder neu beginnen und ihn verwerfen?",
      "bodyNoTime": "Ein auf diesem Gerät begonnener Entwurf wurde nie gespeichert. Fortsetzen oder neu beginnen und ihn verwerfen?",
      "resume": "Fortsetzen",
      "startOver": "Neu beginnen"
    },
    "repsRange": "Bereich",
    "repsRangeMin": "Wenigste Wdh",
    "repsRangeMax": "Meiste Wdh",
    "prescribeRangeA11y": "Einen Wiederholungsbereich für die Sätze vorgeben",
    "amrapStop": {
      "title": "Stopp bei RIR",
      "none": "Keine Regel",
      "technical": "Technik bricht",
      "rir": "RIR {{n}}",
      "a11yRir_one": "Mit {{count}} Wiederholung in Reserve stoppen",
      "a11yRir_other": "Mit {{count}} Wiederholungen in Reserve stoppen",
      "a11yTechnical": "Bei der ersten Wiederholung stoppen, bei der die Technik bricht",
      "groupSet": "Wo der AMRAP von Satz {{n}} stoppt"
    }
  },
  "me": {
    "targets": {
      "title": "Ziele",
      "historyByCoach": "Dein Coach",
      "errNotFound": "Deine Ziele wurden nicht gefunden. Geh zurück und versuch es erneut."
    }
  },
  "coach": {
    "title": "Coach und Athleten",
    "subtitle": "Athleten, die Sie trainieren, und Trainer, die Sie betreuen. Eine Einladung erfordert die Zustimmung beider Seiten, bevor Zuweisungen fließen können.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Athletin oder Athlet per E-Mail einladen",
    "invitePlaceholder": "athlet@beispiel.com",
    "inviteNotePlaceholder": "Notiz (optional)",
    "inviteSend": "Einladung senden",
    "inviteSending": "Wird gesendet…",
    "inviteSent": "Einladung versandt. Die Athletin oder der Athlet sieht sie beim nächsten Anmelden.",
    "athletesHeading": "Athleten, die ich trainiere",
    "coachesHeading": "Trainer, die mich betreuen",
    "athletesEmpty": "Noch keine Athleten. Senden Sie oben eine Einladung.",
    "pendingInLabel": "Wartet auf Ihre Antwort",
    "pendingOutLabel": "Wartet auf deren Antwort",
    "activeLabel": "Aktiv",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "cancel": "Einladung abbrechen",
    "revoke": "Widerrufen",
    "leave": "Coach verlassen",
    "busy": "Wird verarbeitet…",
    "loading": "Wird geladen…",
    "loadFailed": "Laden fehlgeschlagen. Neu laden, um es erneut zu versuchen.",
    "errCode": {
      "invalid_email": "Diese E-Mail-Adresse ist ungültig.",
      "email_not_found": "Kein verifiziertes Konto mit dieser E-Mail-Adresse.",
      "peer_required": "Geben Sie eine E-Mail-Adresse oder einen Sub an.",
      "edge_exists": "Eine Verbindung mit diesem Partner besteht bereits.",
      "userpool_not_configured": "Server falsch konfiguriert: User Pool nicht verfügbar.",
      "io_error": "Netzwerk- oder Serverfehler. Erneut versuchen.",
      "not_pending": "Diese Einladung steht nicht mehr aus.",
      "wrong_party": "Nur die Gegenseite kann diese Einladung annehmen.",
      "missing_claims": "Deine Sitzung ist abgelaufen. Melde dich erneut an.",
      "table_not_configured": "Server falsch konfiguriert: Tabelle nicht verfügbar.",
      "not_found": "Diese Einladung existiert nicht mehr."
    },
    "dashboard": {
      "title": "Team-Übersicht",
      "unnamedAthlete": "Athlet",
      "empty": "Noch keine Athleten",
      "emptySub": "Lade Athleten unter Coach & Athleten ein, um sie hier zu sehen.",
      "loading": "Lade dein Team…",
      "loadFailed": "Team konnte nicht geladen werden. Zum erneuten Versuch aktualisieren.",
      "noProgram": "Kein Programm",
      "kpiAssigned": "Athleten",
      "kpiActive": "Aktiv diese Woche",
      "kpiAttention": "Benötigen Aufmerksamkeit",
      "kpiAdherence": "Ø Einhaltung",
      "kpiSessions": "Einheiten diese Woche",
      "kpiNotLoaded": "Nicht geladen: {{count}}. Nur bei Athleten mitgezählt.",
      "adherence": "Einhaltung",
      "lastNever": "nie trainiert",
      "flagStale": "Trainiert nicht",
      "flagUnderTarget": "Unter Ziel",
      "flagOnTrack": "Im Plan",
      "flagNoProgram": "Kein Programm"
    },
    "detail": {
      "back": "Zurück zum Team",
      "maxesTitle": "Aktuelle MAX",
      "maxesEmpty": "Noch keine MAX erfasst",
      "rhythmSummary": "Ø {{avg}}/Woche über {{weeks}} Wochen · letzte Woche: {{last}}",
      "effortTitle": "Effort-Abdeckung",
      "effortLabel": "Sätze mit erfasstem RIR",
      "effortSummary": "{{tagged}} von {{counted}} gezählten Sätzen, Aufwärmsätze eingeschlossen",
      "effortEra": "Effort-Daten beginnen am {{date}} · {{count}} frühere Sätze werden nicht gezählt",
      "effortNone": "Noch kein Satz trägt einen Effort-Wert, daher haben die Zahlen zu harten Sätzen und Zielen keine Grundlage.",
      "effortError": "Effort-Daten konnten nicht geladen werden.",
      "maxesSeeAll": "Alle anzeigen (+{{count}})",
      "maxesShowFewer": "Weniger anzeigen",
      "assignProgram": "Programm zuweisen"
    },
    "targets": {
      "eyebrow": "Wochenziele",
      "edit": "Ziele bearbeiten",
      "degradedHint": "Dieser Athlet hat noch keine Wochenziele. Lege welche fest, um seine Woche an einem Ziel zu messen.",
      "noGrant": "Schreibgeschützt — der Athlet hat dir das Bearbeiten der Ziele nicht erlaubt.",
      "historyTitle": "Änderungsverlauf",
      "historyEmpty": "Noch keine Änderungen.",
      "historyByYou": "Du",
      "historyTruncated": "Zeige die letzten 1000 Änderungen.",
      "histGeneric": "Ziele aktualisiert",
      "histSet": "auf {{value}} gesetzt",
      "histRemoved": "entfernt",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Wird geladen…",
      "errLoad": "Diese Ziele konnten nicht geladen werden. Geh zurück und versuch es erneut.",
      "errStale": "Diese Ziele haben sich während deiner Bearbeitung geändert. Neu laden und erneut anwenden.",
      "errNoGrant": "Der Athlet hat dir das Bearbeiten der Ziele nicht erlaubt.",
      "errNotCoach": "Du bist nicht der Coach dieses Athleten.",
      "errMultiAssignee": "Dieses Programm wird von mehr als einem Athleten genutzt.",
      "errRetry": "Lädt noch, versuch es gleich noch einmal.",
      "errNotFound": "Dieses Programm existiert nicht mehr.",
      "errOffline": "Speichern fehlgeschlagen. Prüfe deine Verbindung und versuch es erneut."
    },
    "assignPicker": {
      "title": "An {{name}} zuweisen",
      "cancel": "Abbrechen",
      "rowA11y": "{{name}} zuweisen",
      "assignedTitle": "Gesendet",
      "assignedBody": "An {{name}} gesendet — wartet auf Annahme.",
      "alreadyTitle": "Bereits zugewiesen",
      "alreadyBody": "{{name}} hat das bereits.",
      "errAssign": "Zuweisung fehlgeschlagen. Bitte erneut versuchen."
    },
    "sessions": {
      "title": "Einheiten",
      "setsTitle": "Sätze",
      "noSets": "In dieser Einheit wurden keine Sätze erfasst.",
      "setA11y": "Satz {{n}}: {{summary}}",
      "loadFailed": "Die Einheiten konnten nicht geladen werden.",
      "unavailable": "Diese Einheit lässt sich nicht öffnen. Geh zurück und versuch es noch einmal."
    }
  },
  "plans": {
    "assign": "Zuweisen",
    "title": "Pläne",
    "help": "Entwerfen Sie eine Trainingseinheit für sich. Vorgaben in absoluten Kilogramm oder als Prozentsatz Ihres MAX, beim Start des Plans in kg umgerechnet.",
    "loading": "Pläne werden geladen…",
    "empty": "Noch keine Pläne. Legen Sie einen an, um eine Einheit vorzubereiten.",
    "todayPill": "Heute",
    "add": "Plan hinzufügen",
    "edit": "Bearbeiten",
    "start": "Starten",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Plan gespeichert.",
    "savedEdit": "Plan aktualisiert.",
    "deleted": "Plan gelöscht.",
    "delete": "Löschen",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Diesen Plan löschen?",
    "creatingTitle": "Neuer Plan",
    "editingTitle": "Plan bearbeiten",
    "name": "Name",
    "namePlaceholder": "z. B. Kniebeugen-Tag",
    "scheduledFor": "Geplant für (optional)",
    "pickDate": "Datum wählen",
    "pickDateHint": "Öffnet die Datumsauswahl",
    "clearDate": "Datum löschen",
    "noDate": "Nicht gesetzt",
    "notes": "Notizen (optional)",
    "rpeEnabledLabel": "RPE-Spalte im Logger anzeigen",
    "rpeEnabledHelp": "Wenn aktiv, öffnen aus diesem Plan gestartete Sessions mit sichtbarer RPE-Spalte. Die Athletin/der Athlet kann sie pro Session weiterhin umschalten.",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung wählen",
    "exerciseN": "Übung {{n}}",
    "removeExercise": "Übung entfernen",
    "addExercise": "Weitere Übung hinzufügen",
    "setsLegend": "Sätze",
    "targetReps": "Wdh.",
    "targetWeight": "Gewicht",
    "targetKind": "Einheit",
    "targetRpe": "RPE",
    "noMaxYet": "kein MAX",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "statusDraft": "Entwurf",
    "statusScheduled": "Geplant",
    "statusCompleted": "Abgeschlossen",
    "statusSkipped": "Übersprungen",
    "errNotSignedIn": "Sie müssen angemeldet sein.",
    "errNameRequired": "Geben Sie dem Plan einen Namen.",
    "errPickExercise": "Wählen Sie eine Übung aus dem Katalog.",
    "errNoSets": "Fügen Sie mindestens einen gültigen Satz hinzu.",
    "errGroupKindMixed": "Zwei Einträge teilen sich eine Gruppen-ID, sind aber als Superset und Zirkel markiert. Bitte einheitlich machen und neu speichern.",
    "errCode": {
      "invalid_email": "Diese E-Mail-Adresse sieht ungültig aus.",
      "email_not_found": "Kein Konto mit dieser E-Mail-Adresse gefunden.",
      "too_many_assignees": "Höchstens 20 Personen pro Programm."
    },
    "assignTo": "Athleten zuweisen",
    "assignToHelp": "Eine Zuweisung ist ein Vorschlag: Er landet erst in der Bibliothek, wenn er angenommen wird, und Angenommenes bleibt beim Entfernen. Trainerverbindung erforderlich.",
    "assignSelf": "Sie (Autor)",
    "addAssignee": "Hinzufügen",
    "removeAssignee": "Entfernen",
    "removeAssigneeConfirm": "Zugriff entfernen?",
    "removeAssigneeHint": "Verliert es dadurch aus der eigenen Bibliothek. Erneut tippen, um zu entfernen.",
    "pendingAssigneeCaption": "Ausstehend",
    "rosterSectionLabel": "Aus Ihrem Kader",
    "rosterEmpty": "Noch keine Athletinnen oder Athleten in Ihrem Kader.",
    "rosterAllAssigned": "Alle Athletinnen und Athleten in Ihrem Kader sind bereits zugewiesen.",
    "shareTo": "Teilen mit",
    "shareToHelp": "Teilen ist ein Angebot: Es erreicht die Bibliothek der Person nur, wenn sie annimmt, und was angenommen wurde, bleibt ihr auch, wenn Sie sie entfernen.",
    "shareSectionLabel": "Personen, mit denen Sie teilen können",
    "shareEmpty": "Sie haben noch niemanden, mit dem Sie teilen können.",
    "shareAllShared": "Alle, mit denen Sie teilen können, haben es bereits.",
    "emailSectionLabel": "Per E-Mail",
    "assigneePlaceholder": "name@beispiel.de",
    "invalidEmailFormat": "Das sieht nicht nach einer gültigen E-Mail-Adresse aus.",
    "exerciseNew": "Übung wählen",
    "setIndex": "Satz {{n}}",
    "cardMenu": "Kartenmenü",
    "menuGroup": "Gruppe",
    "menuMoveUp": "Nach oben",
    "menuMoveDown": "Nach unten",
    "groupNone": "Keine Gruppe",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupCreate": "Erstellen",
    "groupNewSuperset": "Neuer Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Zirkel {{letter}}",
    "details": "Details",
    "exercisesLabel": "Übungen",
    "editorEmpty": "Noch keine Übungen. Füge eine hinzu, um diesen Plan zu erstellen.",
    "selectExercisePrompt": "Wähle eine Übung, um ihre Sätze zu bearbeiten.",
    "addExerciseCta": "Übung hinzufügen",
    "removeExerciseConfirm": "Diese Übung entfernen?",
    "removeExerciseHint": "Einmal tippen zum Bestätigen, dann erneut tippen zum Entfernen.",
    "collapseExercise": "Übung einklappen",
    "supersetTag": "SUPERSATZ",
    "exerciseNoteLabel": "Übungsnotiz (optional)"
  },
  "templates": {
    "show": "Starter-Vorlagen durchsuchen",
    "hide": "Vorlagen ausblenden",
    "help": "Häufig verwendete Pläne und Programme als Vorlage. Klonen Sie eine in Ihr Konto — die Kopie gehört Ihnen, sie ändern oder löschen ohne die Vorlage zu berühren.",
    "loading": "Vorlagen werden geladen…",
    "empty": "Derzeit keine Vorlagen verfügbar.",
    "errLoad": "Vorlagen konnten nicht geladen werden.",
    "clone": "In mein Konto klonen",
    "cloning": "Wird geklont…",
    "cloned": "„{{name}}\" geklont.",
    "alreadyCloned": "Bereits geklont",
    "difficultyBeginner": "Anfänger",
    "difficultyIntermediate": "Mittel",
    "difficultyAdvanced": "Fortgeschritten",
    "planMeta": "{{n}} Übung(en)",
    "programMeta": "{{weeks}}-Wochen-Zyklus · {{sessions}}× / Woche"
  },
  "maxes": {
    "title": "Maxima",
    "countLabel_one": "{{count}} gesetzt",
    "countLabel_other": "{{count}} gesetzt",
    "help": "Das MAX ist, was Sie heute heben können, von Ihnen festgelegt. Programme verwenden es als Prozentbasis. Das geschätzte 1RM im Fortschritt dient nur zur Information.",
    "loading": "Maxima werden geladen…",
    "empty": "Noch keine Maxima eingetragen. Legen Sie eines an, um prozentbasiertes Training anzusteuern.",
    "add": "Maximum hinzufügen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "deleteAction": "MAX löschen",
    "deleting": "Wird gelöscht…",
    "deleted": "MAX gelöscht.",
    "deleteConfirm": "MAX für {{name}} löschen? Der Verlauf wird ebenfalls entfernt. Der nächste Seed aus dem Verlauf kann ihn aus den Trainings neu setzen.",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung auswählen",
    "value": "Wert",
    "source": "Quelle",
    "sourceManual": "Manuell eingegeben",
    "sourceTested": "Im Studio getestet",
    "sourceDerived": "Aus einem geloggten Satz abgeleitet",
    "sourceCalculated": "Aus Historie geschätzt",
    "sourceImported": "Importiert",
    "notes": "Notizen (optional)",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Maximum gespeichert.",
    "cancel": "Abbrechen",
    "errPickExercise": "Wählen Sie eine Übung.",
    "errInvalidValue": "Geben Sie einen Wert zwischen 0 und 2000 ein.",
    "seed": {
      "start": "Aus Verlauf vorschlagen",
      "loading": "Verlauf wird gelesen…",
      "reviewIntro": "{{count}} Übungen haben einen belastbaren Top-Satz im Verlauf. Wählen Sie aus, welche als MAX übernommen werden. Übungen mit vorhandenem MAX werden übersprungen.",
      "selectAll": "Alle auswählen",
      "selectNone": "Keine auswählen",
      "fromSet": "aus {{weight}} × {{reps}}",
      "cancel": "Abbrechen",
      "apply": "{{count}} MAX setzen",
      "applying": "Speichern: {{done}} / {{total}}",
      "applied": "{{count}} MAX aus dem Verlauf gesetzt.",
      "noneApplicable": "Nichts zu setzen. Entweder hat jede Übung bereits einen MAX, oder es wurde kein belastbarer Verlauf gefunden.",
      "close": "Schließen"
    }
  },
  "progress": {
    "coverageTitle": "Muskelabdeckung",
    "coverageSeeAll": "Alle Muskeln anzeigen (+{{count}})",
    "coverageShowFewer": "Weniger anzeigen",
    "coverageCompact": {
      "doneOfExpected": "{{done}} / {{expected}} bis heute",
      "doneOfExpectedA11y_one": "{{done}} von {{expected}} Satz bis heute",
      "doneOfExpectedA11y_other": "{{done}} von {{expected}} Sätzen bis heute",
      "behind": "{{n}} im Rückstand",
      "onPace": "im Tempo",
      "titleBehind_one": "{{count}} Satz hinter dem Tempo",
      "titleBehind_other": "{{count}} Sätze hinter dem Tempo",
      "titleOnPace": "Im Tempo",
      "subtitle": "harte Sätze bis heute gegenüber dem Tempo der Spanne"
    },
    "period": {
      "days": "{{days}} T",
      "painDays": "7 / {{days}} T"
    },
    "title": "Fortschritt",
    "show": "Anzeigen",
    "hide": "Ausblenden",
    "help": "Das MAX legen Sie selbst fest; das geschätzte 1RM nach Epley dient als Referenz. Das Volumen ist die Summe aus Gewicht mal Wiederholungen für die Einheit.",
    "e1rm": "Geschätztes 1RM",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "geschätztes 1RM gestrichelt",
    "volume": "Volumen",
    "sessions": "{{n}} Einheiten",
    "prFound": "Persönliche Bestleistung bei {{weight}}.",
    "prUpdating": "Wird aktualisiert…",
    "viewByExercise": "Pro Übung",
    "viewByTag": "Pro Tag",
    "noTags": "Noch keine getaggten Einheiten. Taggen Sie Übungen im Katalog, um das aggregierte Volumen hier zu sehen.",
    "totalVolume": "Gesamt {{weight}}",
    "recordsScope": "Bestleistungen",
    "recordsAllTime": "Allzeit",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Übungen filtern",
    "filterCount": "{{visible}} von {{total}}",
    "filterNoMatch": "Keine Übung passt zum Filter.",
    "coverageNoData": "Noch nichts zu bewerten — logge eine Einheit oder setze ein Wochenziel.",
    "volumeLandmark": {
      "source": {
        "rp": "Renaissance Periodization"
      },
      "citation": {
        "rp": "Veröffentlichte Praxis-Richtwerte. Die individuelle Varianz ist groß — deine eigenen Daten engen dieses Band ein."
      },
      "zone": {
        "belowMev": "unter MEV",
        "mevMav": "MEV–MAV",
        "mavMrv": "MAV–MRV",
        "aboveMrv": "über MRV",
        "noBand": "keine veröffentlichte Spanne"
      },
      "yourTarget": "dein Ziel {{v}}",
      "athleteTarget": "Ziel {{v}}",
      "sets_one": "{{n}} Satz",
      "sets_other": "{{n}} Sätze"
    },
    "chartGapShort": "+{{count}}T",
    "chartGapLong_one": "{{count}} Tag seit dem vorherigen Punkt",
    "chartGapLong_other": "{{count}} Tage seit dem vorherigen Punkt",
    "chartMorePoints_one": "+{{count}} weiterer Punkt",
    "chartMorePoints_other": "+{{count}} weitere Punkte",
    "chartWindowA11y": "{{from}} bis {{to}}",
    "chartSummaryA11y": "{{range}}, zuletzt {{last}}, {{window}}",
    "chartTapHint": "Auf einen Punkt tippen, um seinen Wert zu sehen",
    "chartCapped": "Es werden nur die neuesten Daten angezeigt. Ältere Daten sind nicht in diesem Diagramm.",
    "muscleState": {
      "thin": "Zu wenig Verlauf für ein Tempo: {{n}} von {{needed}} Einheiten",
      "none": "Noch keine harten Sätze erfasst",
      "a11yOver": "aktuelle Last {{pct}} % über dem 28-Tage-Tempo",
      "a11yUnder": "aktuelle Last {{pct}} % unter dem 28-Tage-Tempo",
      "a11yLevel": "aktuelle Last gleichauf mit dem 28-Tage-Tempo"
    },
    "gapProposal": {
      "toggle": "Lücke schließen",
      "toMev_one": "<num>{{n}}</num> Satz/Wo bis MEV",
      "toMev_other": "<num>{{n}}</num> Sätze/Wo bis MEV",
      "basis": "MEV {{mev}} − Ø {{avg}}/Wo = {{gap}}/Wo",
      "eachAlone": "Jede dieser Übungen schließt sie allein:",
      "alsoWorks": "trainiert auch {{muscles}}",
      "atPlace": "In {{place}}, ohne das, was du dort als fehlend markiert hast.",
      "noPlace": "Ganzer Katalog: kein Standardort festgelegt.",
      "wholeCatalog": "Ganzer Katalog: Wo der Athlet trainiert, wird nicht mit Coaches geteilt.",
      "noneAtPlace": "In {{place}} bleibt nichts: Jede Übung für diesen Muskel ist dort als fehlend markiert.",
      "noneInCatalog": "Keine Übung im Katalog trainiert diesen Muskel.",
      "shortHistory_one": "Für die Lücke braucht es 4 volle Wochen Verlauf: bisher {{n}}.",
      "shortHistory_other": "Für die Lücke braucht es 4 volle Wochen Verlauf: bisher {{n}}.",
      "a11yToggle": "{{muscle}}: Lücke schließen, {{gap}} Sätze pro Woche bis MEV",
      "buildToday": "Heutige Einheit aus diesen Lücken zusammenstellen"
    }
  },
  "cohort": {
    "compare": "Mit Vergleichsgruppe abgleichen (anonym)",
    "hide": "Vergleich ausblenden",
    "loading": "Vergleichsdaten werden geladen…",
    "empty": "Noch nicht genug Beiträge für einen Vergleich. Die Schwelle liegt bei zehn Personen in derselben Altersgruppe.",
    "contributors": "Basierend auf {{n}} anonymen Beiträgen mit angegebener Altersgruppe.",
    "yourGroup": "deine Gruppe"
  },
  "catalog": {
    "title": "Übungskatalog",
    "empty": "Noch keine Übungen.",
    "region": "Region",
    "region_lower": "Unterkörper",
    "region_posterior": "Hintere Kette",
    "region_chest": "Brust",
    "region_back": "Rücken",
    "region_shoulders": "Schultern",
    "region_arms": "Arme",
    "region_core": "Rumpf",
    "region_cardio": "Cardio",
    "region_other": "Sonstiges",
    "pattern": "Bewegungsmuster",
    "pattern_squat": "Kniebeuge",
    "pattern_hinge": "Hüftbeugung",
    "pattern_horizontal-push": "Horizontales Drücken",
    "pattern_vertical-push": "Vertikales Drücken",
    "pattern_horizontal-pull": "Horizontales Ziehen",
    "pattern_vertical-pull": "Vertikales Ziehen",
    "pattern_lunge": "Ausfallschritt",
    "pattern_carry": "Tragen",
    "pattern_core": "Rumpf",
    "pattern_isolation": "Isolation",
    "pattern_mobility": "Mobilität",
    "pattern_cardio": "Kardio",
    "pattern_other": "Sonstiges",
    "equipment": "Gerät",
    "equipment_barbell": "Langhantel",
    "equipment_dumbbell": "Kurzhantel",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Kabelzug",
    "equipment_machine": "Maschine",
    "equipment_bodyweight": "Eigengewicht",
    "equipment_band": "Band",
    "equipment_other": "Sonstiges",
    "tags": "Tags",
    "equipment_treadmill": "Laufband",
    "equipment_exercise-bike": "Heimtrainer",
    "equipment_elliptical": "Crosstrainer",
    "equipment_rower": "Rudergerät",
    "equipment_stair-climber": "Stepper",
    "equipment_jump-rope": "Springseil",
    "equipment_battle-ropes": "Battle Ropes",
    "equipment_sled": "Schlitten",
    "deletedExercise": "Gelöschte Übung"
  },
  "swap": {
    "title": "Übung tauschen",
    "currentLabel": "Aktuell",
    "searchPlaceholder": "Im Katalog suchen…",
    "showAll": "Alle Übungen anzeigen",
    "noMatches": "Keine Übung entspricht der Suche.",
    "noSuggestions": "Keine ähnlichen über Tags gefunden. Aktivieren Sie „Alle anzeigen“, um den vollständigen Katalog zu durchsuchen.",
    "close": "Schließen",
    "reasonTags": "Gemeinsame Tags ×{{count}}",
    "reasonPrimary": "Gemeinsame Muskeln ×{{count}}",
    "reasonDifferentEquipment": "Anderes Gerät",
    "suggestedSection": "Vorschläge",
    "allSection": "Alle Übungen",
    "whichMachine": "Welche Maschine?",
    "defaultMachine": "Standardmaschine",
    "machineLabel": "Maschine {{letter}}",
    "setMachine": "Maschine wählen",
    "machineChoices": "Bekannte Maschinen: {{count}}",
    "newMachine": "Neue Maschine",
    "bandSession": "Einheit",
    "bandCurrentExercise": "Diese Übung",
    "bandOtherExercises": "Zu einer anderen Übung wechseln",
    "equipmentKey": "Gerät",
    "currentConsequence": "Bereits erfasste Sätze bleiben: es ändert sich nur das Gerät, auf dem sie vermerkt sind.",
    "unavailableTitle": "Nicht hier?",
    "unavailableBody": "Wähle das Gerät für {{exercise}}, das es bei {{place}} nicht gibt. Gespeichert wird nur, was du auswählst.",
    "unavailableConfirm": "Speichern",
    "unavailableOpen": "Gerät hier nicht verfügbar",
    "unavailableOpenHint": "Fragt, welches Gerät dieser Übung fehlt.",
    "unavailableBadge": "Nicht hier",
    "unavailableRestore": "Hier wieder verfügbar",
    "unavailableErrorTitle": "Speichern fehlgeschlagen",
    "unavailableErrorBody": "Das Gerät gilt hier weiterhin als verfügbar.",
    "unavailableConfirmHint": "Wähle mindestens eines aus, um zu speichern.",
    "pinDefaultMachine": "Hier immer das Standardgerät verwenden",
    "pinMachine": "Hier immer {{machine}} verwenden",
    "pinHint": "Hier wird nicht mehr gefragt, welches Gerät für diese Übung.",
    "pinErrorTitle": "Speichern fehlgeschlagen",
    "pinErrorBody": "Das Standardgerät hier ist unverändert.",
    "unpinDefaultMachine": "Hier nicht mehr immer das Standardgerät verwenden",
    "unpinMachine": "Hier nicht mehr immer {{machine}} verwenden",
    "pinnedFootnoteDefault": "Hier wird immer das Standardgerät verwendet.",
    "pinnedFootnoteMachine": "Hier wird immer {{machine}} verwendet.",
    "unpinHint": "Hier wird wieder gefragt, welches Gerät für diese Übung."
  },
  "tabs": {
    "workout": "Training",
    "plan": "Plan",
    "progress": "Fortschritt",
    "profile": "Profil",
    "catalog": "Katalog",
    "admin": "Admin",
    "workoutEyebrow": "Heutige Einheit",
    "planEyebrow": "Programmierung",
    "progressEyebrow": "Diagramme und Berichte",
    "profileEyebrow": "Konto und Maxima",
    "catalogEyebrow": "Übungskatalog",
    "adminEyebrow": "Admin-Konsole",
    "progressEmpty": "Erfassen Sie zuerst eine Einheit — Diagramme erscheinen, sobald Daten vorliegen."
  },
  "shell": {
    "navAria": "Hauptnavigation"
  },
  "theme": {
    "aria": "Design",
    "light": "Hell",
    "dark": "Dunkel",
    "auto": "Auto"
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Brust",
        "biceps": "Bizeps",
        "triceps": "Trizeps",
        "forearm": "Unterarme",
        "front-deltoids": "Schultern",
        "back-deltoids": "Hintere Deltas",
        "trapezius": "Trapez",
        "upper-back": "Rücken",
        "lower-back": "Unterer Rücken",
        "abs": "Rumpf",
        "obliques": "Rumpf",
        "quadriceps": "Quadrizeps",
        "hamstring": "Beinbeuger",
        "gluteal": "Gesäß",
        "adductors": "Adduktoren",
        "abductors": "Abduktoren",
        "calves": "Waden",
        "tibialis": "Schienbein",
        "neck": "Nacken",
        "head": "Kopf"
      }
    },
    "tabs": {
      "workouts": "Workouts",
      "plan": "Start",
      "progress": "Fortschritt",
      "catalog": "Katalog",
      "profile": "Profil",
      "settings": "Einstellungen",
      "inbox": "Eingang",
      "athletes": "Athleten",
      "library": "Bibliothek",
      "me": "Ich"
    },
    "me": {
      "sectionTraining": "Training",
      "navTargets": "Ziele",
      "navTargetsSub": "Deine wöchentlichen Trainingsziele"
    },
    "settings": {
      "title": "Einstellungen",
      "exercisesSection": "Übungen",
      "navExercisesSub": "MAX, Katalog, Anstrengungsskala",
      "navCatalog": "Übungskatalog",
      "selectPrompt": "Wähle eine Einstellung, um sie zu öffnen.",
      "navCatalogSub": "Übungsbibliothek durchsuchen",
      "navEffort": "Anstrengungseinstellungen",
      "navEffortSub": "RIR / RPE Skala + Legende",
      "navLicenses": "Open-Source-Lizenzen",
      "navLicensesSub": "Bibliotheken, auf denen die App basiert",
      "sectionAccount": "Konto",
      "sectionTraining": "Training",
      "sectionBody": "Körper",
      "sectionPrefs": "Einstellungen",
      "sectionCoach": "Coach",
      "sectionAbout": "Über",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Workouts & Gesundheitsdaten von deinem Gerät synchronisieren"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "$t(brand.product)",
      "pillLabel": "Kalorienquellen",
      "projectionNote": "Enthält den Satz, den du gleich machst: eine Hochrechnung der ganzen Einheit, nicht bereits erfasste Arbeit.",
      "selected": "ausgewählt"
    },
    "hc": {
      "preferences": "Präferenzen",
      "caloriesWins": "Health Connect zählt für Kalorien",
      "caloriesWinsHelp": "Wenn beide vorliegen, die in Health Connect gemessenen Kalorien statt der Schätzung von $t(brand.product) anzeigen. Aus = Schätzung bevorzugen. Ohne Health-Connect-Wert wird immer die Schätzung verwendet.",
      "title": "Health Connect",
      "intro": "Importiere die Aktivität von Uhr und Handy in $t(brand.product). Spaziergänge, Wanderungen und Radtouren werden zu Workouts; Herzfrequenz und Kalorien ergänzen die Sessions, die du protokollierst. Aus, bis du verbindest.",
      "checking": "Prüfe…",
      "unavailable": "Health Connect ist auf diesem Gerät nicht verfügbar.",
      "updateRequired": "Aktualisiere die Health-Connect-App, um fortzufahren.",
      "notConnected": "Nicht verbunden.",
      "connect": "Health Connect verbinden",
      "connectHelp": "Du entscheidest, welche Daten $t(brand.product) lesen darf. Jederzeit in Health Connect änderbar.",
      "connected": "Verbunden",
      "reads": "Liest Workouts, Herzfrequenz und Kalorien.",
      "syncNow": "Jetzt synchronisieren",
      "neverSynced": "Noch nicht synchronisiert.",
      "lastSyncedAt": "Letzte Synchronisierung: {{when}}",
      "syncDelayNote": "Neue Aktivitäten brauchen manchmal ein paar Minuten, bis sie von deinem Gerät in Health Connect ankommen — ein kürzlicher Spaziergang oder eine Radtour erscheint womöglich erst bei einer späteren Synchronisierung. Diese Verzögerung ist normal.",
      "syncFullHistory": "Gesamten Verlauf synchronisieren",
      "syncingFullHistory": "Verlauf wird synchronisiert",
      "syncFullHistoryHelp": "Prüft deinen gesamten Verlauf erneut und füllt Lücken in Health Connect. Nutze das, wenn dort eine frühere Korrektur fehlt. Beliebig oft wiederholbar.",
      "resultSummary": "{{imported}} importiert · {{enriched}} ergänzt · {{skipped}} übersprungen",
      "error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "grantRefused": "Dein Konto hat diese Einwilligung nicht festgehalten, deshalb liest $t(brand.product) Health Connect nicht. Versuche später erneut, dich zu verbinden.",
      "revokeRefused": "Health Connect ist auf diesem Handy getrennt, aber dein Konto hat den Widerruf nicht festgehalten und zeigt noch deine Einwilligung. Versuche es später erneut.",
      "revokedElsewhere": "Du hast deine Einwilligung auf einem anderen Gerät widerrufen, deshalb ist Health Connect auf diesem Handy getrennt.",
      "manageInHc": "In Health Connect verwalten",
      "disconnect": "Trennen",
      "disconnectTitle": "Health Connect trennen?",
      "disconnectBody": "$t(brand.product) liest deine Health-Connect-Daten dann nicht mehr. Bereits importierte Workouts bleiben in deinem Verlauf.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Deine Daten",
      "privacyBody": "$t(brand.product) liest nur, was du in Health Connect erlaubst, und nur auf diesem Handy, nachdem du verbunden hast. Die Daten liegen in deinem privaten $t(brand.product)-Konto und werden nie geteilt oder verkauft. Trenne die Verbindung jederzeit, dann liest $t(brand.product) nichts mehr.",
      "explainerTitle": "Was $t(brand.product) liest, und warum",
      "explainerIntro": "Als Nächstes fragt dich Android. Du kannst alles, einen Teil oder nichts erlauben und es jederzeit in Health Connect ändern.",
      "explainerContinue": "Weiter zu Android",
      "explainerCancel": "Nicht jetzt",
      "consentGiven": "Einwilligung erteilt am {{when}}.",
      "consentWithdrawn": "Einwilligung erteilt am {{given}}, widerrufen am {{withdrawn}}.",
      "consentWithdrawnOnly": "Einwilligung widerrufen am {{withdrawn}}.",
      "consentBeforeRecord": "Einwilligung erteilt, bevor $t(brand.product) das Datum aufgezeichnet hat.",
      "consentCategories": "Was du erlaubt hast",
      "consentRecordNote": "Dieser Nachweis gehört zu deinem Konto und hält jede Einwilligung und jeden Widerruf mit Datum fest. Android erteilt die Berechtigung auf jedem Handy einzeln.",
      "explainerMore": "Weiter unten geht es weiter, scrolle, um alles zu lesen.",
      "deviceAllowed": "Auf diesem Handy: von Android erlaubt.",
      "deviceNotAllowed": "Auf diesem Handy: von Android nicht erlaubt.",
      "driftDeviceOff": "Dein Konto hat deine Einwilligung, aber Android erlaubt es auf diesem Handy nicht mehr. Erlaube es erneut, um hier zu synchronisieren.",
      "driftNoRecord": "Android erlaubt es auf diesem Handy, aber dein Konto hat keine aktuelle Einwilligung. Prüfe, was $t(brand.product) liest, und bestätige dann in der Abfrage von Android. Dein Konto hält sie mit dem heutigen Datum fest.",
      "driftUndated": "Deine Einwilligung hat noch kein Datum. Prüfe, was $t(brand.product) liest, und bestätige dann in der Abfrage von Android: Dein Konto hält sie mit dem heutigen Datum fest.",
      "allowOnPhone": "Auf diesem Handy erlauben",
      "confirmConsent": "Prüfen und bestätigen",
      "permOther": "Andere Berechtigung",
      "perm": {
        "readExerciseSession": {
          "name": "Trainingseinheiten",
          "use": "Ein Spaziergang, Lauf oder eine Radfahrt, die deine Uhr oder dein Handy aufzeichnet, erscheint als Training in deiner Timeline."
        },
        "readHeartRate": {
          "name": "Herzfrequenz",
          "use": "Durchschnitt und Spitze erscheinen bei jedem Training und fließen in die Kalorienschätzung ein."
        },
        "readActiveCaloriesBurned": {
          "name": "Aktive Kalorien",
          "use": "Die gemessenen Kalorien erscheinen bei jedem Training, neben der Schätzung."
        },
        "readDistance": {
          "name": "Distanz",
          "use": "Ergänzt die Distanz in den Cardio-Sätzen eines Trainings von deiner Uhr oder deinem Handy."
        },
        "readWeight": {
          "name": "Gewicht",
          "use": "Fließt in den Verlauf und die Kurve deines Körpergewichts unter Körper ein."
        },
        "readBodyFat": {
          "name": "Körperfett",
          "use": "Erscheint in der Kurve der Körperzusammensetzung unter Körper."
        },
        "readLeanBodyMass": {
          "name": "Magermasse",
          "use": "Erscheint in der Kurve der Körperzusammensetzung unter Körper."
        },
        "readNutrition": {
          "name": "Ernährung",
          "use": "Die Kohlenhydrate von heute erscheinen auf der Karte Metabolisch, neben deinem Glukosewert."
        },
        "readBloodGlucose": {
          "name": "Glukose",
          "use": "Deine Messwerte erscheinen auf der Karte Metabolisch, als Kurve und letzter Wert."
        },
        "writeBloodGlucose": {
          "name": "Glukose schreiben",
          "use": "Ein Glukosewert, den du in $t(brand.product) eingibst, wird auch in Health Connect gespeichert."
        },
        "writeWeight": {
          "name": "Gewicht schreiben",
          "use": "Eine Wägung, die du in $t(brand.product) eingibst, wird auch in Health Connect gespeichert."
        }
      },
      "bodyResult": "{{imported}} Körperwerte importiert · {{skipped}} übersprungen",
      "bodyNotGranted": "Körperdaten noch nicht erlaubt. Tippe auf Körperdaten erlauben.",
      "readsFull": "Liest Workouts, Herzfrequenz und Kalorien, Gewicht und Körperzusammensetzung, Glukose und Ernährung. Schreibt Glukose und Gewicht zurück in Health Connect.",
      "backfillTitle": "Verlauf ab Mai importieren?",
      "backfillBody": "Durchsucht deinen Health-Connect-Verlauf bis Mai und importiert, was fehlt. Mehrfach ausführbar: bereits importierte Einträge werden übersprungen.",
      "backfillNow": "Verlauf importieren",
      "grantExtra": "Gesundheitsdaten erlauben",
      "extraGrantBody": "Importiere auch Gewicht, Körperzusammensetzung, Glukose und Ernährung.",
      "metabolicResult": "{{glucose}} Glukose · {{nutrition}} Ernährung importiert",
      "metabolicNotGranted": "Glukose und Ernährung noch nicht erlaubt.",
      "writeGlucoseGrantBody": "$t(brand.product) erlauben, Glukose in Health Connect zu schreiben.",
      "grantWrite": "Schreiben erlauben",
      "syncGlucoseToHc": "Glukose in Health Connect schreiben"
    },
    "metabolic": {
      "title": "Metabolisch",
      "loading": "Lädt…",
      "empty": "Verbinde Health Connect und synchronisiere, um hier Glukose und Ernährung zu sehen.",
      "glucoseEmpty": "Keine Glukosewerte",
      "mgdl": "mg/dL",
      "targetBand": "Typischer Zielbereich {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Kohlenhydrate heute",
      "grams": "g",
      "glucoseTitle": "Glukose",
      "glucoseCurrent": "Zuletzt: {{value}} {{unit}}",
      "glucoseNone": "Erfasse einen Wert, um deine Glukose zu verfolgen.",
      "help": "Dein Blutzucker aus Health Connect, darunter die letzten Kohlenhydrate. Tippe auf einen Punkt im Diagramm, um Wert und Uhrzeit zu lesen."
    },
    "exercisesScreen": {
      "back": "Zurück"
    },
    "body": {
      "back": "Zurück",
      "title": "Körper",
      "navTitle": "Körper",
      "navSub": "Geschlecht, Alter, Figur",
      "navPainMapSub": "Markiere, wo es schmerzt",
      "trendsWebHint": "Körperzusammensetzungs-Diagramme sind in der mobilen App.",
      "sexLabel": "Geschlecht",
      "sexHelp": "Wird nur für die Körperfett-Schätzung verwendet. Die Figur der Muskelkarte ist eine separate Auswahl weiter unten.",
      "sex_male": "Mann",
      "sex_female": "Frau",
      "measurementsTitle": "Maße",
      "measurementsSub": "Gewicht, Umfänge, Körperfett-Schätzung",
      "measureTitle": "NEUE MESSUNG",
      "weight": "Gewicht",
      "field_heightCm": "Größe",
      "field_neckCm": "Hals",
      "field_chestCm": "Brust",
      "field_waistCm": "Taille",
      "field_hipsCm": "Hüfte",
      "field_bicepsLCm": "Bizeps (L)",
      "field_bicepsRCm": "Bizeps (R)",
      "field_forearmsLCm": "Unterarm (L)",
      "field_forearmsRCm": "Unterarm (R)",
      "field_thighsLCm": "Oberschenkel (L)",
      "field_thighsRCm": "Oberschenkel (R)",
      "field_calvesLCm": "Wade (L)",
      "field_calvesRCm": "Wade (R)",
      "measureSave": "Eingegebene Werte speichern",
      "measureHelpC": "Trage nur ein, was du gemessen hast. Leere Felder werden nicht gespeichert.",
      "useLastA11y": "Letzten Wert verwenden {{value}}",
      "saveFailedTitle": "Speichern fehlgeschlagen",
      "saveFailedBody": "Deine Messung wurde nicht gespeichert. Deine Werte bleiben erhalten — tippe zum erneuten Versuch auf Speichern.",
      "editTitle": "BEARBEITEN — {{date}}",
      "saveChanges": "Änderungen speichern",
      "editCancelA11y": "Bearbeiten abbrechen",
      "editRowA11y": "Messung {{date}} bearbeiten",
      "editHelp": "Ändere einen Wert oder lösche ihn, um ihn aus dem Verlauf zu entfernen.",
      "trendsLabel": "TRENDS",
      "trendsHint": "Werte wählen",
      "trendsExpandA11y": "Alle Werte anzeigen",
      "trendsCollapseA11y": "Werte einklappen",
      "trendsPick": "Wähle oben eine Messung, um ihren Verlauf zu sehen.",
      "metricComposition": "Zusammensetzung",
      "metricBodyFat": "Körperfett",
      "metricLeanMass": "Magermasse",
      "loadError": "Messungen konnten nicht geladen werden — prüfe deine Verbindung.",
      "navyTitle": "KÖRPERZUSAMMENSETZUNG (NAVY)",
      "navyNeedsEntry": "Speichere unten eine Messung, um den Körperfettanteil zu schätzen.",
      "navyNeedsSex": "Lege oben dein Geschlecht fest, um den Körperfettanteil zu schätzen.",
      "navyNeedsInputs": "Füge Größe, Hals und Taille (und Hüfte für die weibliche Formel) hinzu, um den Körperfettanteil zu schätzen.",
      "navyBodyFat": "Körperfett ≈ {{pct}} %",
      "navyLeanMass": "Magermasse ≈ {{mass}}",
      "navyDisclaimer": "US-Navy-Schätzung (~±3,5 %). Achte auf den Trend, nicht auf den Einzelwert.",
      "historyEmpty": "Noch keine Messungen. Speichere oben eine, um mit dem Tracking zu beginnen.",
      "historyTitle": "VERLAUF",
      "trendWeight": "GEWICHTSVERLAUF",
      "trendBodyFat": "KÖRPERFETT-VERLAUF",
      "deleteTitle": "Messung löschen?",
      "deleteEmptyTitle": "Diese Messung entfernen?",
      "deleteEmptyBody": "Alle Werte sind gelöscht, daher wird der Eintrag entfernt.",
      "deleteCancel": "Abbrechen",
      "deleteConfirm": "Löschen",
      "ageLabel": "Alter",
      "ageHelp": "Optional. Zum Löschen erneut tippen.",
      "dualCurveLegend": "Durchgezogen: Schätzung · Gestrichelt: Health Connect",
      "estimateSeriesName": "Schätzung",
      "bodyFatProvenance": "Der Körperfettanteil wird aus Taille und Hals berechnet.",
      "bodyFatProvenanceWithHips": "Der Körperfettanteil wird aus Taille, Hals und Hüfte berechnet.",
      "trendsHelp": "Ein Diagramm pro oben gewählter Messung. Tippe auf einen Punkt, um Wert und Datum zu lesen."
    },
    "effortSettings": {
      "back": "Zurück",
      "title": "Anstrengung",
      "scaleLabel": "Anstrengungsskala",
      "scaleHelp": "Welche Skala der Logger verwendet. RIR = Wiederholungen in Reserve; RPE = empfundene Anstrengung. RPE = 10 − RIR, also dieselbe Anstrengung auf zwei Skalen."
    },
    "plan": {
      "currentBlockError": "Der aktuelle Block konnte nicht gesetzt werden. Bitte erneut versuchen.",
      "currentBlockOn": "Aktueller Block — zum Lösen tippen",
      "currentBlockOff": "Als aktuellen Block festlegen",
      "currentBlockHint": "Heftet die Wochenziele dieses Programms an den Home-Zähler",
      "title": "Plan",
      "start": "Starten",
      "starting": "Wird geöffnet…",
      "programWeekSession": "Woche {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Zuletzt: W{{week}} · {{session}}",
      "programNextHeader": "Als Nächstes",
      "programStartCta": "▶ {{session}} starten",
      "programChangeLink": "Woche oder Session ändern ›",
      "carouselPosition": "Programm {{n}} von {{total}}",
      "carouselPrev": "Vorheriges Programm",
      "carouselNext": "Nächstes Programm",
      "programWeekLabel": "Woche",
      "singleCycle": "Einzelzyklus, jede Woche gleich",
      "programSessionLabel": "Einheit",
      "programWeekShort": "W{{n}}",
      "programDayShort": "T{{n}}",
      "sessionN": "Einheit {{n}}",
      "sessionNShort": "E{{n}}",
      "programConfirm": "W{{week}} · {{session}} starten",
      "cancel": "Abbrechen",
      "newWorkout": "Neues Workout",
      "programsHint": "Mehrwöchige Zyklen, die automatisch fortschreiten, sobald Sie Trainings loggen.",
      "planDeleteTitle": "Plan löschen?",
      "programDeleteTitle": "Programm löschen?",
      "programStatusError": "Programm konnte nicht aktualisiert werden. Erneut versuchen.",
      "view": "Ansehen",
      "hide": "Ausblenden",
      "programUnfollowHint": "Diesem Programm nicht mehr folgen (bleibt in Meine Programme)",
      "programNextInline": "Nächste: W{{week}} · {{session}}",
      "programStartA11y": "{{session}} starten",
      "startPlanA11y": "{{name}} starten"
    },
    "preview": {
      "muscles": "Muskeln",
      "noSets": "Keine Sätze vorgesehen",
      "alternates": "Alternativen: {{names}}",
      "gridTitle": "Intensität · Tag × Woche",
      "gridHint": "Tippe auf einen Tag, um die Übungen zu sehen.",
      "matrixTitle": "Intensität · pro Satz",
      "matrixHint": "Tippe auf eine Übung, um ihre Sätze zu sehen.",
      "restDay": "Ruhe / leicht",
      "intensity": {
        "work": "Arbeit",
        "moderate": "moderat",
        "heavy": "schwer",
        "max": "Max",
        "free": "frei"
      }
    },
    "catalog": {
      "title": "Katalog",
      "search": "Übungen suchen",
      "empty": "Keine passende Übung.",
      "back": "Zurück",
      "notFound": "Übung nicht gefunden.",
      "metaPrimaryMuscle": "Hauptmuskel",
      "metaPattern": "Pattern",
      "metaEquipment": "Ausrüstung",
      "metaP1RM": "Programmierbar",
      "metaP1RMYes": "Ja",
      "metaP1RMNo": "Nein",
      "metaDefaultBar": "Standard-Hantel",
      "metaBarLoading": "Beladung",
      "metaBarLoadingSingleSide": "Nur eine Seite",
      "aliasesLabel": "Auch bekannt als",
      "tagsLabel": "Tags",
      "historyLabel": "Aktuelle Trainings",
      "historyEmpty": "Keine vergangenen Trainings für diese Übung.",
      "historyError": "Verlauf konnte nicht geladen werden.",
      "historyBodyweight": "{{reps}} Wdh. mit Eigengewicht",
      "recordsLabel": "Rekorde",
      "recordsEmpty": "Noch keine Rekorde.",
      "selectPrompt": "Wähle eine Übung, um ihre Details zu sehen.",
      "recordsError": "Rekorde konnten nicht geladen werden.",
      "refreshing": "Wird aktualisiert…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Zurück",
      "search": "Übungen suchen",
      "empty": "Keine passende Übung.",
      "editCancel": "Abbrechen",
      "editSave": "Speichern",
      "errInvalid": "Bitte ein gültiges Gewicht eingeben.",
      "clearAction": "MAX entfernen",
      "clearTitle": "Diesen MAX entfernen?",
      "clearBody": "Wert und Verlauf bleiben auf dem Server erhalten, aber der MAX gilt als nicht gesetzt.",
      "clearCancel": "Abbrechen",
      "clearConfirm": "Entfernen",
      "selectPrompt": "Wähle eine Übung, um ihr MAX festzulegen.",
      "unitChipLabel": "Gewichtseinheit: {{unit}}",
      "unitKg": "Kilogramm",
      "unitLb": "Pfund",
      "unitChipHint": "Wechselt die Einheit und rechnet den Wert um",
      "notSet": "Nicht gesetzt",
      "loadFailed": "Laden fehlgeschlagen"
    },
    "login": {
      "title": "$t(brand.product)",
      "subtitle": "Bei deinem Konto anmelden",
      "submit": "Anmelden"
    },
    "workouts": {
      "title": "Workouts",
      "empty": "Noch keine Workouts erfasst.",
      "fallbackName": "Workout",
      "endOfList_one": "{{count}} Session, Ende der Liste.",
      "endOfList_other": "{{count}} Sessions, Ende der Liste.",
      "newButton": "Neu",
      "queueDismissCancel": "Abbrechen",
      "editUnsupportedTitle": "Bearbeiten auf Mobil noch nicht unterstützt",
      "editUnsupportedBody": "Dieses Workout enthält Übungstypen (P1RM, Loaded Carry), die der mobile Logger noch nicht bearbeiten kann. Öffne es in der Web-App.",
      "editUnsupportedAck": "OK",
      "repeat": "Workout wiederholen",
      "resumePillAction": "Fortsetzen",
      "resumePillFallback": "Workout läuft",
      "cancel": "Abbrechen",
      "loadOlder": "Ältere Monate laden",
      "selectPrompt": "Wähle ein Workout, um die Zusammenfassung zu sehen.",
      "loadError": "Diese Sitzung konnte nicht geladen werden.",
      "importedBadge": "Importiert"
    },
    "outboxDetail": {
      "errCorrectionTooBig": "Zu viele Sätze auf einmal geändert für den Server.",
      "errCorrectionBusy": "Der Server war mit diesem Training beschäftigt.",
      "errCorrectionConflict": "Dieses Training wurde auf einem anderen Gerät geändert.",
      "errCorrectionStale": "Dieses Training wurde nach Beginn der Korrektur erneut gespeichert.",
      "errCorrectionTimes": "Das Training endet, bevor es beginnt.",
      "errCorrectionGone": "Dieses Training wurde auf einem anderen Gerät gelöscht.",
      "errSetsUnknownExercise": "Der Server hat eine Übung dieses Trainings nicht erkannt.",
      "errSetsInvalidTag": "Der Server hat einen Tag an einem Satz dieses Trainings nicht akzeptiert.",
      "errSetsInvalid": "Der Server hat einige Sätze dieses Trainings als ungültig abgelehnt.",
      "errSetsNotSaved": "Nicht alle Sätze sind beim Server angekommen.",
      "close": "Schließen",
      "empty": "Nichts mehr zu senden.",
      "statusQueued": "In Warteschlange",
      "statusSending": "Wird gesendet",
      "statusFailed4xx": "Vom Server abgelehnt",
      "statusPermanentFail": "Aufgegeben",
      "attempts_one": "{{count}} Versuch",
      "attempts_other": "{{count}} Versuche",
      "dismissOne": "Verwerfen",
      "dismissOneTitle": "Dieses Workout verwerfen?",
      "dismissOneBody": "Das Workout vom {{date}} wird ohne Speichern entfernt.",
      "dismissCancel": "Abbrechen",
      "dismissConfirm": "Verwerfen",
      "retryAll": "Alle wiederholen",
      "queueWorkout": "Training",
      "queueWorkoutNote": "Trainingsnotiz",
      "queueMeasurement": "Messung",
      "queueMax": "Maximum",
      "queueProfile": "Profil",
      "queueHealth": "Gesundheitsdaten",
      "queueMetabolic": "Stoffwechseldaten",
      "queueRequest": "Änderung",
      "stuckTitle": "Nicht durchgegangene Speicherungen"
    },
    "progress": {
      "title": "Fortschritt",
      "windowAll": "Letzte Sessions",
      "window30d": "Letzte 30 Tage",
      "window7d": "Letzte 7 Tage",
      "lastSession": "Letzte Session",
      "frequencyTitle": "Wochenfrequenz",
      "frequencyHelp": "Einheiten pro Woche, die aktuelle rechts.",
      "rhythmThisWeek": "Diese Woche bisher: {{n}}",
      "rhythmAverageWeeks_one": "Durchschnitt über {{count}} volle Woche: {{avg}}",
      "rhythmAverageWeeks_other": "Durchschnitt über {{count}} volle Wochen: {{avg}}",
      "weekBars": {
        "thisWeek": "diese Woche bisher",
        "weekOf": "Woche vom {{date}}",
        "sessions": "Einheiten"
      },
      "weekStreakCurrent": "Aktuelle Serie",
      "weekStreakBest": "Beste Serie",
      "weekStreakWeeks_one": "Woche",
      "weekStreakWeeks_other": "Wochen",
      "weekStreakStatA11y_one": "{{label}}: {{count}} Woche",
      "weekStreakStatA11y_other": "{{label}}: {{count}} Wochen",
      "weekStreakWithThisWeek_one": "{{count}} Woche in Folge mit mindestens einer Einheit, diese Woche eingeschlossen.",
      "weekStreakWithThisWeek_other": "{{count}} Wochen in Folge mit mindestens einer Einheit, diese Woche eingeschlossen.",
      "weekStreakUpToLastWeek_one": "{{count}} Woche in Folge mit mindestens einer Einheit, bis letzte Woche. Diese Woche läuft noch.",
      "weekStreakUpToLastWeek_other": "{{count}} Wochen in Folge mit mindestens einer Einheit, bis letzte Woche. Diese Woche läuft noch.",
      "weekStreakNone": "Letzte Woche keine Einheit und diese Woche noch keine. Diese Woche läuft noch.",
      "weekStreakEmpty": "Noch keine Einheiten.",
      "weekStreakSessionsHelp": "Einheiten jeder Woche. Die umrandete Spalte ist diese Woche: Sie zählt schon.",
      "recordsTitle": "Rekorde",
      "recordsHelp": "Beste Wiederholungs-Records pro Übung. Neueste zuerst.",
      "recordsAllTime": "Gesamt",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Nach Übung filtern",
      "recordsNoMatch": "Keine Übung passt zum Filter.",
      "tagVolumeTitle": "Volumen nach Tag",
      "tagVolumeWeeksHelp": "Das Trainingsvolumen eines Muskels pro Woche. Wähle den Muskel.",
      "recordsEmpty": "Noch keine Rekorde — logge ein paar Sätze, um die Liste zu füllen.",
      "chartE1rm": "Geschätztes 1RM",
      "chartVolume": "Volumen",
      "chartLoadFailed": "Diagramm konnte nicht geladen werden.",
      "chartEmpty": "Keine gewichteten Sätze im jüngsten Zeitfenster.",
      "viewByExercise": "Nach Übung",
      "viewByTag": "Nach Tag",
      "noTags": "Kein Volumen auf einem Muskel in den letzten Wochen.",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "mit e1RM-Überlagerung",
      "prFound": "Rekord erkannt: {{weight}}",
      "prUpdating": "Aktualisiere…",
      "painSeverity": {
        "red": "rot",
        "yellow": "gelb",
        "green": "grün"
      },
      "balance": {
        "title": "Bewegungsbalance",
        "help": "Sätze und Volumen pro Bewegungsmuster über {{days}} Tage, sortiert nach Sätzen. Die kleine Zahl „X/7T“ zählt die letzten 7 dieser Tage und hilft, eine einzelne kürzliche Belastungsspitze (oder eine bewusste Reduktion) zu erkennen, die der längere Zeitraum verbirgt."
      },
      "empty": "Keine aktuelle Aktivität zum Vergleich",
      "pain": {
        "title": "Schmerz × Volumen",
        "help": "Für jeden in der Schmerzkarte markierten Muskel wird die jüngste Trainingsbelastung angezeigt. Roter Punkt = Schmerz als rot gemeldet (schwere Belastung vermeiden), gelb = Vorsicht, grün = beobachten. Die beiden Volumenwerte sind die Belastung der letzten 7 Tage und des ganzen Zeitraums von {{days}} Tagen auf diesen Muskel. Anhaltend hohe Belastung auf einem roten Muskel ist das risikoreichste Signal auf dieser Seite.",
        "noPain": "Keine Muskeln in der Schmerzkarte markiert",
        "sevRed": "Vermeiden",
        "sevYellow": "Vorsicht",
        "sevGreen": "Beobachten"
      },
      "trends": {
        "a11yUp": "Fortschritt",
        "a11yFlat": "Plateau",
        "a11yDown": "Rückgang",
        "title": "E1RM-Trends",
        "help": "Für jedes Bewegungsmuster (Kniebeuge, Hüftbeugung, Drücken, Ziehen, …) wird die Übung mit dem höchsten e1RM angezeigt, gezählt werden nur Übungen mit einem lesbaren Trend: mindestens {{points}} Punkte über mindestens {{spanDays}} Tage verteilt. Diagramm = e1RM-Werte über {{days}} Tage (auf einen Punkt tippen für Wert und Datum). Pfeil = Trend über diese Tage: ↗ Fortschritt, → Plateau, ↘ Rückgang. Ein trainiertes Muster, in dem keine Übung diese Schwelle erreicht, sagt das, statt eine Zahl zu zeigen. Eine Übung, die seit über {{freshDays}} Tagen nicht trainiert wurde, übergibt ihr Muster an die aktuell trainierte und bleibt dahinter im Diagramm.",
        "fewData": "Wenige Datenpunkte in {{days}} T",
        "noEligible": "Keine Übung mit mindestens {{points}} Punkten über {{spanDays}} Tage.",
        "notMeasurable": "Noch nicht messbar: kein {{name}}-Satz ging nahe ans Limit. Ein bis nahe ans Muskelversagen geführter Satz (ein AMRAP) würde die Kraft hier zeigen.",
        "machineNotMeasurable": "{{value}}, noch nicht messbar",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Die andere Maschine anzeigen.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Die {{count}} anderen Maschinen anzeigen.",
        "machineSessions_one": "{{count}} Einheit",
        "machineSessions_other": "{{count}} Einheiten",
        "compareCtaA11y": "Ändere die Übung, mit der {{pattern}} verglichen wird",
        "compareSeparator": "vs",
        "compareClearA11y": "Entferne deinen Vergleich für {{pattern}} und kehre zum vorgeschlagenen zurück",
        "comparedManualA11y": "{{current}} verglichen mit {{name}}, deine Wahl",
        "comparedWithA11y": "{{current}} verglichen mit {{name}}, die dieses Muster zuvor hielt"
      },
      "repsAtLoad": {
        "a11yUp": "steigend",
        "a11yFlat": "stabil",
        "a11yDown": "fallend",
        "title": "Wiederholungen bei festem Gewicht",
        "help": "Für Übungen, bei denen Sie dasselbe Gewicht wiederholen, zeigt dies die Wiederholungen bei diesem festen Gewicht über {{days}} Tage: der Kraftzuwachs, den das e1RM-Diagramm bei hohen Wiederholungszahlen und an Maschinen nicht sieht. Balken = Wiederholungen beim Gewicht, einer pro Einheit (tippen Sie auf einen Balken für das Datum). Pfeil = Trend: ↗ steigend, → stabil, ↘ fallend. Nur Sätze mit erfasster Anstrengung zählen, damit mehr Wiederholungen nicht einfach nur ein leichterer Tag sein können.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Wenige Datenpunkte in {{days}} T",
        "notMeasurable": "Noch nicht messbar: Ihre {{name}}-Sätze bei {{load}} haben keine erfasste Anstrengung, daher könnten mehr Wiederholungen einfach nur ein leichterer Tag sein. Ein bis nahe ans Muskelversagen geführter Satz — oder eine erfasste Anstrengung — würde hier Ihre Kraft zeigen."
      },
      "period": {
        "all": "gesamt"
      },
      "loadFailed": "Laden fehlgeschlagen",
      "density": {
        "title": "Dichte",
        "help": "Volumen geteilt durch Trainingsdauer, kg/min. Liest sich als „wie dicht war diese Einheit“: Ein Anstieg bedeutet dieselbe Last in weniger Zeit (bessere Kondition) oder mehr Last in derselben Zeit (mehr Kraft). Ein plötzlicher Rückgang ohne Programmänderung deutet häufig auf Ermüdung hin: Die Pausen haben sich verlängert, auch wenn dies nicht geplant war.",
        "empty": "Mindestens 3 zeitgemessene Einheiten erforderlich, um die Dichte darzustellen"
      },
      "frequency": {
        "title": "Vernachlässigte Übungen",
        "help": "Top 8 Übungen, sortiert nach Tagen seit der letzten Protokollierung, am stärksten vernachlässigte zuerst. Das Suffix X/{{days}}T zählt die Sätze der letzten {{days}} Tage. Eine lange Pause heißt: Entweder wurde die Übung bewusst gestrichen, oder das Programm ist abgedriftet. Nützlich, um Zusatzarbeit zu identifizieren, die unbemerkt verschwunden ist."
      },
      "intensityHeatmap": {
        "title": "Intensitäts-Heatmap",
        "help": "Pro-Übung-Raster der absolvierten Sätze, sortiert nach Wiederholungsbereich und Intensität (% des 1RM). Kraftbereich (85%+) unten rechts, Hypertrophie in der Mitte, Ausdauer oben links. Wähle eine Übung, um zu sehen, wo sich ihre Sätze ballen.",
        "exerciseLabel": "Übung",
        "choosePrompt": "Übung wählen",
        "noEligible": "Hinterlege ein 1RM für mindestens eine Übung, damit die Intensität berechnet werden kann.",
        "noMax": "Für diese Übung ist noch kein 1RM erfasst.",
        "totalSets": "{{n}} Sätze · 1RM {{max}}",
        "clear": "Keine"
      },
      "prTimeline": {
        "title": "PR-Zeitleiste",
        "help": "Maxima im Zeitverlauf, neueste zuerst. Getestet bedeutet ein bestätigter Einer-PR; jedes andere Label ist eine Startschätzung, kein getestetes Maximum.",
        "empty": "Noch keine Maxima erfasst.",
        "rowA11y": "{{name}}, {{value}}, {{date}}, {{source}}",
        "truncated_one": "Die letzten {{cap}} von {{count}} MAX",
        "truncated_other": "Die letzten {{cap}} von {{count}} MAX",
        "source": {
          "manual": "Manuell",
          "tested": "Getestet",
          "derived": "Abgeleitet",
          "calculated_seed": "Startwert",
          "imported": "Importiert",
          "unknown": "Unbekannt"
        },
        "helpPeriod": "Die in diesem Zeitraum gesetzten Maxima, neueste zuerst. Getestet bedeutet ein bestätigter Einer-PR; jedes andere Label ist eine Startschätzung, kein getestetes Maximum.",
        "emptyPeriod": "In diesem Zeitraum kein Maximum gesetzt."
      },
      "a11y": {
        "severityAlarm": "Alarm",
        "severityWarn": "Warnung",
        "severityInfo": "Info"
      },
      "config": {
        "title": "Fortschritt anpassen",
        "open": "Fortschritt anpassen",
        "saveError": "Das Layout von Fortschritt konnte nicht gespeichert werden. Bitte erneut versuchen.",
        "widget": {
          "rhythm": "Trainingsrhythmus",
          "prTimeline": "PR-Zeitleiste",
          "weekStreak": "Beständigkeitsserie"
        }
      },
      "coverageRefreshing": "Wird aktualisiert…",
      "report": {
        "open": "Bericht erstellen",
        "title": "Trainingsbericht",
        "titleOf": "Trainingsbericht: {{name}}",
        "period": "{{from}} bis {{to}}",
        "from": "Von",
        "to": "Bis",
        "pickA11y": "{{label}}: {{value}}. Datum ändern",
        "periodHint": "Jeder Zeitraum bis {{days}} Tage, auch in der Vergangenheit.",
        "chooseSections": "Abschnitte wählen",
        "shareImage": "Als Bild teilen",
        "advanced": "Erweiterter Bericht",
        "pdfExport": "Als PDF exportieren",
        "comparePeriods": "Zwei Zeiträume vergleichen",
        "sectionsTitle": "Abschnitte des Berichts",
        "advancedSections": "Erweiterte Abschnitte",
        "noSections": "Kein Abschnitt gewählt. Wähle die Abschnitte, um den Bericht zu sehen.",
        "sessions": "Einheiten im Zeitraum",
        "frequencyHelp": "Einheiten pro Woche über den Zeitraum.",
        "premiumHint": "Premium-Optionen gehören nicht zum Basisbericht.",
        "shareNeedsSection": "Wähle mindestens einen Abschnitt, um den Bericht zu teilen.",
        "pagesTruncated": "Der geteilte Bericht endet nach {{max}} Bildern. Wähle weniger Abschnitte, um den Rest zu teilen.",
        "preparing": "Bild {{page}} wird vorbereitet…",
        "pagesReady": "Die Bilder sind bereit zum Teilen.",
        "adjustedToday": "Ein Bericht endet spätestens heute: Das Datum wurde auf heute gesetzt.",
        "adjustedOther": "Das andere Datum wurde verschoben, damit der Zeitraum in der richtigen Reihenfolge bleibt.",
        "adjustedCapped": "Ein Bericht umfasst höchstens {{days}} Tage: Das andere Datum wurde verschoben.",
        "emptyPeriod": "Kein Training in diesem Zeitraum."
      },
      "coverageNotConfirmed": "Aktualisierung fehlgeschlagen — dies sind die letzten Zahlen, die wir haben"
    },
    "profile": {
      "title": "Profil",
      "navMaxes": "MAX",
      "navMaxesSub": "MAX je Übung setzen, bearbeiten und überprüfen.",
      "navCatalogSub": "Übungen, Rekorde und Verlauf durchsuchen.",
      "navRestTimer": "Timer",
      "navRestTimerSub": "Pausen- + Halte-Standards, Ton, pro Übung",
      "labelEmail": "E-MAIL",
      "labelApp": "APP-VERSION",
      "labelBackend": "BACKEND-VERSION",
      "labelPrivacy": "DATENSCHUTZ",
      "privacyHelp": "Alles als JSON exportieren oder das Konto endgültig löschen.",
      "legalLinkHint": "Öffnet sich im Browser",
      "exportButton": "Meine Daten exportieren",
      "deleteButton": "Mein Konto löschen",
      "deleteAlertTitle": "Konto löschen",
      "deleteAlertBody": "Dein Konto, deine Sessions, Pläne, Programme und MAX-Werte werden endgültig gelöscht. Löschungen sind nicht rückgängig zu machen.",
      "deleteAlertCancel": "Abbrechen",
      "deleteAlertConfirm": "Löschen",
      "signOut": "Abmelden",
      "exportShareTitle": "$t(brand.product)-Export {{date}}",
      "labelLanguage": "Sprache",
      "languageHelp": "Wähle die Sprache der App. Auf diesem Gerät gespeichert.",
      "languageCancel": "Schließen"
    },
    "summary": {
      "prBadge": "persönlicher Rekord"
    },
    "logger": {
      "autoName": {
        "region_lower": "Beine",
        "title": "{{label}}\u00a0-\u2060\u00a0{{date}}",
        "pair": "{{a}} & {{b}}",
        "upper": "Oberkörper",
        "lower": "Unterkörper",
        "fullBody": "Ganzkörper",
        "deload": "Deload",
        "mobility": "Mobility",
        "cardio": "Cardio"
      },
      "title": "Neues Workout",
      "cancel": "Abbrechen",
      "swapKindTitle": "Übungstyp ändern?",
      "swapKindBody": "Diese Übung wird anders erfasst, daher werden die hier bereits erfassten Sätze gelöscht.",
      "swapKindConfirm": "Ändern & löschen",
      "failConfirmTitle": "Gültige Reps",
      "failConfirmBody_one": "Ich speichere {{count}} saubere Wiederholung. Die fehlgeschlagene zählt nicht.",
      "failConfirmBody_other": "Ich speichere {{count}} saubere Wiederholungen. Die fehlgeschlagene zählt nicht.",
      "failConfirmHint": "Passe an, wenn du mehr oder weniger gemacht hast.",
      "failConfirmStepDown": "Eine saubere Wiederholung weniger",
      "failConfirmStepUp": "Eine saubere Wiederholung mehr",
      "failConfirmSave": "Speichern",
      "amrapConfirmTitle": "Bis zum Muskelversagen?",
      "amrapConfirmBody": "Antworte nur dann mit Ja, wenn die nächste Wiederholung nicht mehr gekommen wäre.",
      "amrapNeedsReps": "Trag die Wiederholungen ein, die du geschafft hast, um den Satz zu speichern.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: mindestens {{reps}} Wiederholungen, dann so viele wie möglich",
      "amrapConfirmAtFloor": "Du hast {{reps}} eingetragen, das Programm verlangte mindestens {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Ja, bis zum Versagen",
      "amrapConfirmNo": "Nein, da war noch was",
      "failBadge": "Gescheitert",
      "failBadgeA11y": "fehlgeschlagener Satz",
      "save": "Speichern",
      "remove": "Entfernen",
      "replace": "Ersetzen",
      "addExercise": "Übung hinzufügen",
      "addSet": "Satz hinzufügen",
      "addRound": "Runde hinzufügen",
      "pickerTitle": "Übung wählen",
      "pickerSearch": "Übungen suchen",
      "pickerResultsN_one": "{{count}} Ergebnis",
      "pickerResultsN_other": "{{count}} Ergebnisse",
      "pickerEmpty": "Keine Übung gefunden.",
      "pickerClearFilters": "Filter löschen",
      "pickerFilters": "Filter",
      "pickerFiltersN": "Filter ({{n}})",
      "empty": "Noch keine Übung. Füge eine hinzu, um loszulegen.",
      "setReps": "WDH",
      "amrapPrescribedA11y": "AMRAP: mindestens die vorgegebenen Wiederholungen, dann so viele wie möglich",
      "setPercentOfMax": "%",
      "prescribedLoadTip": "Die Last, die du vorgibst, in der Einheit des Programms. Kilo oder % vom Maximum legst du direkt darunter fest.",
      "setPercentOfMaxA11y": "Prozent vom Maximum",
      "stepAdd": "Erhöhen",
      "stepSubtract": "Verringern",
      "amrapChipPrescribe": "So viele Wiederholungen wie möglich vorgeben",
      "tipAmrapPrescribe": "Verlangt vom Athleten so viele Wiederholungen wie möglich in diesem Satz. Die Wiederholungszahl bleibt das Minimum.",
      "entryNoteEdit": "Übungsnotiz bearbeiten",
      "entryNoteAdd": "＋ Übungsnotiz",
      "setWeightBothSidesA11y": "Gewicht einer Seite, beide Seiten gezählt ({{unit}})",
      "setTypeWorking": "Normal",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-Rep",
      "setCommentLabel": "Satz-Kommentar",
      "unitLabel": "Einheit",
      "discardTitle": "Workout verwerfen?",
      "discardBody": "Die bisher erfassten Sätze gehen verloren.",
      "discardCancel": "Weiter",
      "discardConfirm": "Verwerfen",
      "discardEditTitle": "Änderungen verwerfen?",
      "discardEditBody": "Das gespeicherte Workout bleibt unverändert.",
      "discardEditCancel": "Weiter bearbeiten",
      "errNoEntries": "Füge mindestens eine Übung hinzu.",
      "errNoSets": "Jede Übung braucht mindestens einen Satz mit Wdh und Gewicht.",
      "errInvalid": "Das Workout lässt sich so nicht speichern.",
      "errSaveFailed": "Speichern fehlgeschlagen. Das Workout ist noch da: tippe noch einmal auf Speichern.",
      "errNotSignedIn": "Nicht angemeldet. Das Workout bleibt hier. Speichere es, wenn du wieder angemeldet bist.",
      "errSetsUnknownExercise": "Eine Übung in diesem Training wird nicht erkannt. Ändere sie und speichere erneut.",
      "errSetsInvalidTag": "Ein Tag an einem Satz wird nicht akzeptiert. Entferne ihn und speichere erneut.",
      "errSetsInvalid": "Einige Sätze sind ungültig. Prüfe Gewicht und Wiederholungen, dann speichere erneut.",
      "errSetsNotSaved": "Einige Sätze sind nicht beim Server angekommen. Versuche erneut zu speichern.",
      "errCorrectionTooBig": "Zu viele Sätze auf einmal geändert. Speichere weniger Änderungen, dann den Rest.",
      "errCorrectionBusy": "Das Training war belegt. Warte kurz und speichere erneut.",
      "errCorrectionConflict": "Das Training wurde auf einem anderen Gerät geändert. Schließe es, öffne es erneut und korrigiere es noch einmal.",
      "errCorrectionStale": "Das Training wurde erneut gespeichert, nachdem du es geöffnet hast. Schließe es, öffne es erneut und korrigiere es noch einmal.",
      "errCorrectionTimes": "Das Training endet, bevor es beginnt. Prüfe Start und Ende, dann speichern.",
      "errCorrectionImport": "Dieses Training kommt aus Health Connect und lässt sich hier nicht korrigieren. Korrigiere es in Health Connect.",
      "errCorrectionGone": "Dieses Training wurde auf einem anderen Gerät gelöscht. Die Korrektur ist nicht verloren: Du findest sie oben in Workouts, tippe auf Als neu speichern.",
      "errCorrectionGoneHere": "Dieses Training wurde auf einem anderen Gerät gelöscht. Die Korrektur ist nicht verloren: Tippe auf Als neu speichern, um sie als neues Training zu behalten.",
      "correctionToBell": "Die frühere Korrektur dieses Trainings wurde abgelehnt, und diese kam dazu. Sie ist nicht verloren: Du findest sie oben in Workouts, tippe auf Als neu speichern.",
      "setNumberHeader": "SATZ",
      "removeSetA11y": "Diesen Satz entfernen",
      "serverErrorTitle": "SERVER HAT DAS SPEICHERN ABGELEHNT",
      "serverErrorHint": "Passe das Workout an und versuche es erneut. Bei unklaren Meldungen teile sie mit deinem Coach.",
      "setExtra": "EXTRA",
      "setWeightTip": "Last pro Satz. Mit dem Einheiten-Chip je Zeile zwischen kg/lb wechseln.",
      "setExtraTip": "Unterstützung oder Zusatzlast beim Eigengewicht. Tippe «Unterstützt» für Band-/Maschinenhilfe (das Feld zeigt ein − und wird bernsteinfarben); Gürtel/Scheibe ist positiv.",
      "setExtraAssistA11y": "Extra, unterstützte Last beim Eigengewicht",
      "setExtraAssisted": "Unterstützt",
      "setWeightMixedTip": "Gemischte Gruppe: Hantel-/Stack-Last in Gewichtszeilen, ± Extra in Eigengewichtszeilen (Minus = Hilfe).",
      "editTitle": "Workout bearbeiten",
      "planTitle": "Plan",
      "programTitle": "Programm",
      "repeatTitle": "Workout wiederholen",
      "minimize": "Workout minimieren",
      "closeWorkout": "Workout schließen",
      "saveWorkout": "Workout speichern",
      "bilateral": "Bilateral",
      "unilateral": "Unilateral",
      "plates": "Scheiben",
      "numInvalid": "Ungültige Zahl",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Anstrengung 1–10",
      "setNoteLabel": "Notiz",
      "setNotePlaceholder": "Cue, Technik, Empfinden…",
      "totalsSets_one": "{{count}} Satz",
      "totalsSets_other": "{{count}} Sätze",
      "totalsReps_one": "{{count}} Wdh.",
      "totalsReps_other": "{{count}} Wdh.",
      "totalsTitle": "Workout-Summe",
      "totalsVolume": "Volumen",
      "totalsSetsShort": "Sätze",
      "totalsRepsShort": "Wdh.",
      "totalsByMuscle": "Belastung pro Muskel",
      "restRest": "Pause",
      "startRestManual": "Pause starten",
      "restSkip": "Überspringen",
      "restWord": "Pause",
      "restAddStep": "+{{n}} Sekunden",
      "restSubtractStep": "−{{n}} Sekunden",
      "restStartedA11y": "Pause gestartet, {{time}}.",
      "restEndedA11y": "Pause beendet.",
      "restInviteLabel": "Etwas länger pausieren?",
      "restInviteAdd": "+{{time}}",
      "restInviteAddA11y": "{{time}} zur Pause hinzufügen",
      "restInviteA11y": "Etwas länger pausieren? Du kannst {{time}} hinzufügen.",
      "setsCarriedOverA11y": "Sätze vom letzten Mal übernommen.",
      "restInviteTipTitle": "Warum länger pausieren?",
      "restInviteTipBody": "Dieser Satz endete am oder nahe am Muskelversagen. In Studien erhielten längere Pausen nach solchen Sätzen mehr Kraft für den nächsten Satz: etwa 3 Min., bei schweren Übungen bis zu 5. Wie lange du pausierst, entscheidest du.",
      "loadBarA11y": "Gewichtssteuerung",
      "restBarA11y": "Pausen-Timer",
      "restRemainingA11y": "{{time}} Pause übrig",
      "restEditA11y": "Standardpause für diese Übung festlegen",
      "restEditTitle": "Standardpause",
      "restEditBody": "Diese Pause als Standard für {{name}} speichern",
      "restEditSave": "Speichern",
      "restEditSaving": "Wird gespeichert…",
      "restEditError": "Standardpause konnte nicht gespeichert werden. Erneut versuchen.",
      "restEditCancel": "Abbrechen",
      "restEditSaveAsGlobal": "Als globalen Standard verwenden",
      "restStepMinus": "Um {{step}} Sekunden verringern",
      "restStepPlus": "Um {{step}} Sekunden erhöhen",
      "restPause": "Anhalten",
      "restResume": "Fortsetzen",
      "restExpiredTitle": "Pause vorbei",
      "holdExpiredTitle": "Zeit um",
      "restExpiredBody": "Weiter geht's.",
      "holdExpiredBody": "Tippe auf das Belastungsband, um den Satz zu speichern.",
      "boutExpiredTitle": "Intervall beendet",
      "boutExpiredBody": "Satz automatisch gespeichert.",
      "workStartedTitle": "Los",
      "cueLeadInWork": "Arbeit — {{n}} s",
      "cueLeadInRest": "Pause — {{n}} s",
      "cueChannel": {
        "tick": "Countdown-Signale",
        "work": "Arbeitsbeginn"
      },
      "boutAutoLoggedA11y": "Intervall beendet, {{time}} gespeichert.",
      "workoutFgsTitle": "Training läuft",
      "workoutFgsBodyNamed": "{{name}} · zum Fortsetzen tippen",
      "workoutFgsBody": "Zum Fortsetzen tippen",
      "descriptionToggle": "Beschreibung ein-/ausblenden",
      "notesToggle": "Notizen für dieses Training",
      "infoButton": "Info",
      "notesEmpty": "Keine Notizen für dieses Training",
      "notesProgramLabel": "Programm",
      "notesWorkoutLabel": "Dieses Training",
      "note": "Notiz",
      "rpeChip": "RPE",
      "historyChip": "Verlauf",
      "more": "Weitere Aktionen",
      "addGroup": "Einen Supersatz mit einer anderen Übung bilden",
      "cardioDuration": "Dauer",
      "cardioDurationPlaceholder": "Sekunden",
      "cardioDistance": "Distanz",
      "cardioWeight": "Gewicht",
      "cardioHr": "Ø Puls",
      "cardioCalories": "Kalorien",
      "cardioOptionalsShow": "Weitere Felder anzeigen",
      "cardioOptionalsHide": "Weitere Felder ausblenden",
      "dateEditor": "Datum & Dauer",
      "dateLabel": "Datum",
      "startTimeLabel": "Start",
      "endTimeLabel": "Ende",
      "durationLabel": "Dauer",
      "historyToggle": "Verlauf",
      "historyBest": "Beste",
      "historyCopy": "Kopieren",
      "historyBodyweight": "{{reps}} Wdh. Eigengew.",
      "historyEstimateHeader": "Schätzung aus einer ähnlichen Übung",
      "historyEstimatedFrom": "Von {{name}}",
      "historyNoEstimate": "Noch kein Verlauf und keine ähnliche Übung zum Schätzen.",
      "copyDialogTitle": "Einheit kopieren",
      "copyDialogBody": "Offene Sätze ersetzen oder zu den bestehenden hinzufügen?",
      "copyOverwrite": "Ersetzen",
      "copyAppend": "Hinzufügen",
      "resumeDiscard": "Verwerfen",
      "conflictTitle": "Training läuft",
      "conflictBody": "Sie protokollieren bereits ein Training. Weiter oder anzeigen, um es zu speichern oder zu verwerfen.",
      "nameLabel": "Workout-Name",
      "namePlaceholder": "Name: z. B. Push…",
      "editNameA11y": "Workout-Namen bearbeiten",
      "setStateA11y": "Satz {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "Einheit {{unit}}",
      "stepperPositive": "hinzufügen",
      "stepperNegative": "abziehen",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Leicht",
      "effortMeterHard": "Schwer",
      "effortWord": "Belastung",
      "holdSlotDone": "FERTIG",
      "holdSlotHeld": "GEHALTEN",
      "holdSlotDoneA11y": "{{time}} erledigt",
      "holdSlotFailedA11y": "{{time}}, nicht geschafft",
      "holdSlotHeldA11y": "{{time}} gehalten",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "Ziel",
      "effortQuestionRir": "Reps in Reserve?",
      "effortQuestionRpe": "Wie hart war es?",
      "effortQuestionHint": "Öffnet die Anstrengungsskala — wie sie funktioniert und wie man sie wechselt",
      "effortMeterHintLog": "Protokolliert den Satz auch als abgeschlossen",
      "effortMeterHintRunning": "Stoppt den Timer und speichert den Satz",
      "effortMeterHintEdit": "Aktualisiert die Anstrengung dieses Satzes",
      "effortMeterFailHintLog": "Protokolliert den Satz als gescheitert",
      "effortMeterFailHintEdit": "Wechselt den Satz zwischen abgeschlossen und gescheitert",
      "effortMeterTapCta": "Zum Speichern des Satzes tippen",
      "effortMeterStopCta": "Tippen zum Stoppen und Speichern",
      "effortNudgeOptOut": "Erinnerung deaktivieren",
      "effortNudgeOptOutHint": "Fragt vorher nach. Du kannst es in den Einstellungen wieder einschalten.",
      "effortNudgeOptOutConfirmTitle": "Diese Erinnerung deaktivieren?",
      "effortNudgeOptOutConfirmBody": "Jederzeit in den Einstellungen wieder aktivierbar.",
      "effortNudgeOptOutConfirmButton": "Deaktivieren",
      "effortMeterAmrapDone": "Fertig",
      "effortMeterAmrapHint": "Speichert den Satz bis zum Muskelversagen — keine Wiederholung übrig",
      "amrapChip": "So viele Wiederholungen wie möglich",
      "burnPlus": "Burn+",
      "burnPlusChip": "Burn+ Intensitätstechnik (Dropset / Myo-Rep)",
      "loadAxisTitle": "Was die Last bestimmt",
      "timedChip": "Zeitgesteuert",
      "noteChip": "Notiz",
      "noteClose": "Fertig",
      "effortLegendA11y": "Hilfe zur Anstrengungsskala",
      "rirLegendTitle": "RIR: Wiederholungen in Reserve",
      "rirLegendBody": "0 = keine Wiederholung übrig\n1 = 1 Wiederholung übrig\n2 = 2 Wiederholungen\n3 = guter Spielraum — zählt noch als Arbeitssatz\n4–5 = leichte Arbeit, zählt nicht\n6+ = Aufwärmen",
      "rpeLegendTitle": "RPE: empfundene Anstrengung",
      "rpeLegendBody": "10 = keine Wiederholung übrig\n9 = 1 Wiederholung übrig\n8 = 2 Wiederholungen\n7 = guter Spielraum — zählt noch als Arbeitssatz\n5–6 = leichte Arbeit, zählt nicht\n4 oder weniger = Aufwärmen",
      "timerStartCountdown": "Countdown starten",
      "timerStartCountup": "Stoppuhr starten",
      "timerSettings": "Timer-Standard für diese Übung",
      "holdHeaderHours": "Std",
      "holdHeaderMinutes": "Min",
      "holdHeaderSeconds": "Sek",
      "holdHours": "Stunden",
      "holdMinutes": "Minuten",
      "holdSeconds": "Sekunden",
      "holdSubTen": "-10 Sek.",
      "holdAddTen": "+10 Sek.",
      "holdCancel": "Abbrechen",
      "holdClockElapsedA11y": "{{time}} vergangen",
      "holdClockOvertimeA11y": "{{time}} über dem Ziel",
      "pausedReadoutA11y": "{{label}}, angehalten",
      "holdClockRemainingA11y": "noch {{time}}",
      "holdFlip": "Richtung wechseln",
      "holdExtraWeight": "Zusatz",
      "lateralityTipUni": "UNI · eine Seite erfassen; Volumen zählt beide (×2).",
      "lateralityTipBi": "BI · bilaterale Last; Volumen zählt einmal (×1).",
      "tabExercises": "Übungen",
      "tabSuperset": "Supersatz",
      "pickerAddN": "{{n}} hinzufügen",
      "pickerAlreadyInWorkout": "Schon in diesem Workout",
      "pickerAlreadyInBlock": "Schon in diesem Block",
      "pickerPin": "Zu Favoriten",
      "pickerUnpin": "Aus Favoriten entfernen",
      "noteReadA11y": "Übungsnotiz — antippen, um alles zu lesen",
      "prescriptionReadA11y": "Satzvorgabe — antippen, um alles zu lesen",
      "tipAmrap": "So viele Wiederholungen wie möglich — führe diesen Satz bis zum technischen Versagen.",
      "tipBurnPlus": "Intensitätstechniken — blende Dropset oder Myo-rep ein, um den Satz über das Versagen hinaus zu treiben.",
      "targetEyebrow": "Ziel",
      "historySetCount": "letzte {{n}} Sätze",
      "historyBlinkToggle": "Blinken, wenn eine Übung länger nicht gemacht wurde",
      "historyCopyLast": "Letzte Einheit kopieren",
      "historyLooking": "Übung wird gesucht…",
      "historyUnavailable": "Dein Verlauf ist gerade nicht erreichbar — das heißt nicht, dass es keinen gibt.",
      "historyBlinkOn": "Blinken an",
      "historyBlinkOff": "Blinken aus",
      "historyToggleAged": "Verlauf, zuletzt {{age}}",
      "maxEditNoneA11y": "Dein Maximum für diese Übung festlegen",
      "maxEditA11y": "Dein Maximum bearbeiten",
      "maxEditStaleA11y": "Dein Maximum bearbeiten, zuletzt {{age}}",
      "maxHeaderNone": "Noch keine MAX",
      "maxHeaderValue": "MAX {{weight}}",
      "maxHeaderStale": "MAX {{weight}} · {{age}}",
      "proposedWeightTipTestedMax": "Vorgeschlagen, damit dieser Satz {{effort}} erreicht — zurückgerechnet aus dem 1RM, das du getestet hast. Ein Ausgangspunkt, keine Vorgabe: ändere ihn.",
      "proposedWeightTipMax": "Vorgeschlagen, damit dieser Satz {{effort}} erreicht — zurückgerechnet aus deinem gespeicherten Maximum. Ein Ausgangspunkt, keine Vorgabe: ändere ihn.",
      "proposedWeightTipHistory": "Vorgeschlagen, damit dieser Satz {{effort}} erreicht — zurückgerechnet aus deinem letzten Satz bei dieser Übung. Ein Ausgangspunkt, keine Vorgabe: ändere ihn.",
      "historySectionComputed": "Woher dieses Gewicht kommt",
      "historyProposalSource_one": "Aus deiner letzten Einheit von {{name}}",
      "historyProposalSource_other": "Aus deinen letzten {{count}} Einheiten von {{name}}",
      "historyProposalAxisReps": "Mehr Wiederholungen, gleiches Gewicht",
      "historyProposalAxisLoad": "Mehr Gewicht, gleiche Wiederholungen",
      "historyProposalAxisTrade": "Tausch: mehr Gewicht, weniger Wiederholungen",
      "historyInUse": "in Gebrauch",
      "historyCopyWeightA11y": "Dieses Gewicht für den aktuellen Satz übernehmen",
      "historyCopySetA11y": "Diesen Satz auf den aktuellen übertragen",
      "historyNone": "Diese Übung hast du noch nicht protokolliert.",
      "historySourceTestedMax": "Um {{effort}} zu erreichen — aus dem getesteten 1RM",
      "historySourceMax": "Um {{effort}} zu erreichen — aus deinem erfassten Maximum",
      "historySourceLastSet": "Um {{effort}} zu erreichen — aus deinem letzten Satz hier",
      "historySourcePercent": "Ein Prozentsatz deines Maximums, vom Programm vorgegeben",
      "historySourcePrescribed": "Das im Programm eingetragene Gewicht",
      "historySourceLastWeight": "Das letzte Gewicht, das du hier wirklich benutzt hast",
      "historySourceManual": "Dieses hast du selbst eingetragen",
      "historySourcePercentOf": "{{pct}} % deines Maximums, vom Programm vorgegeben",
      "draftToday": {
        "status": "Entwurf · nicht gespeichert",
        "exercises_one": "{{count}} Übung",
        "exercises_other": "{{count}} Übungen",
        "scope": "Für die Muskeln unter dem Mindestvolumen, die du in den letzten {{hours}} Stunden nicht trainiert hast.",
        "scopeMav": "Für die Muskeln unter dem Mindestvolumen, dann die unter MAV, die du in den letzten {{hours}} Stunden nicht trainiert hast.",
        "scopeAnyway": "Erholung ignoriert: zuerst die Muskeln, deren Training am längsten her ist.",
        "reason_one": "<b>{{muscle}}</b>: {{n}} Satz bis zum Minimum diese Woche",
        "reason_other": "<b>{{muscle}}</b>: {{n}} Sätze bis zum Minimum diese Woche",
        "reasonMav_one": "<b>{{muscle}}</b>: {{n}} Satz unter MAV diese Woche",
        "reasonMav_other": "<b>{{muscle}}</b>: {{n}} Sätze unter MAV diese Woche",
        "lastTrained": "zuletzt {{age}}",
        "noHistory": "Nie gemacht · noch keine Wdh. oder kg",
        "reps": "Wdh.",
        "painVeto": "Ausgelassen, um {{parts}} zu schonen (Schmerzkarte): {{muscles}}.",
        "source": "Wdh.: dein bester Satz der letzten 8 Wochen. Kg: berechnet für 3 Wdh. in Reserve. Nichts wird gespeichert, bis du startest.",
        "discard": "Entwurf verwerfen",
        "timeA11y": "Verfügbare Zeit",
        "minutes": "{{n}} Min.",
        "estimate": "~{{n}} Min.",
        "shuffleRowA11y": "Eine andere Übung für {{muscle}}",
        "shuffleAllA11y": "Andere Übungen für jeden Muskel",
        "shuffleAll": "Alle neu mischen",
        "allSets_one": "gilt für alle {{n}} Sätze",
        "allSets_other": "gilt für alle {{n}} Sätze",
        "intensityChoice": "{{n}} %",
        "intensityA11y": "Intensität: Anteil des Wochenvolumens",
        "intensityChipA11y": "{{n}} % des Wochenvolumens",
        "intensityToday": "heute bei {{n}} %",
        "surprise": "Überrasch mich",
        "surpriseHint": "Zufällige Übungen statt der, die du am häufigsten machst",
        "anchorOwn": "Aus deinem besten Satz, {{date}} · {{age}}",
        "anchorSimilar": "Wdh. aus {{name}} · noch keine kg für diese Übung",
        "timeTitle": "Zeit (Min.)",
        "intensityTitle": "Intensität",
        "restTitle": "Erholung",
        "restChoice": "{{n}} Std.",
        "restA11y": "Erholung: ein in diesem Zeitraum trainierter Muskel wird nicht vorgeschlagen",
        "restChipA11y_one": "{{count}} Stunde",
        "restChipA11y_other": "{{count}} Stunden",
        "restingUntil": "{{muscles}}: Erholung bis {{day}}",
        "atMinimum": "Jeder Muskel hat sein Wochenminimum erreicht.",
        "buildAnyway": "Trotzdem zusammenstellen",
        "newWorkout": "Neues Training"
      },
      "pin": "Anheften",
      "pinned": "angeheftet",
      "hintTitle": "Tippen, um diese Übung zu ersetzen.",
      "hintHowTo": "So geht diese Übung.",
      "hintTarget": "Sätze dieser Woche pro Muskel.",
      "hintTrash": "Entfernt diese Übung aus dem Training.",
      "hintClock": "Frühere Sätze dieser Übung.",
      "hintSuperset": "Supersatz: mit einer anderen Übung kombinieren, Sätze abwechseln.",
      "hintSupersetCue": "Supersatz: tippen, um zur nächsten Übung zu wechseln.",
      "hintSupersetMenu": "Supersatz-Optionen: hinzufügen, umordnen, entfernen oder auflösen.",
      "hintWeek": "Tippen für die nächste Woche. Wische über das Raster, um zurückzugehen.",
      "hintTimed": "Zeitgesteuert: dieser Satz wird über eine Zeit gehalten, ohne Wiederholungen zu zählen.",
      "hintAssisted": "Unterstützt: Band oder Maschine nehmen Last ab. Wert wird negativ.",
      "hintNote": "Notiz: schreib einen Hinweis zu diesem Satz.",
      "hintDropsetRemove": "Zurück zu einem einzelnen Arbeitssatz.",
      "hintPinOn": "Angeheftet: bleibt nach der Pause im Fokus. Tippen zum Lösen.",
      "hintPinOff": "Anheften: hält diese Übung im Fokus, wenn die Pause endet.",
      "holdHintIntro": "Halte eine Taste gedrückt, um zu sehen, was sie tut.",
      "showHint": "Hinweis anzeigen",
      "pickerInDays": "An welchen Tagen",
      "pickerAddNInDays_one": "{{n}} an {{count}} Tag hinzufügen",
      "pickerAddNInDays_other": "{{n}} an {{count}} Tagen hinzufügen",
      "repsRangeA11y": "Wiederholungsbereich {{min}} bis {{max}}",
      "calibration": {
        "offer": "Kein MAX für dieses %. Heute kalibrieren?",
        "accept": "Kalibrieren",
        "decline": "Nicht heute",
        "toCalibrate": "Zu kalibrieren: noch kein MAX, also kein Gewichtsvorschlag.",
        "first": "Kalibrierung: Sätze à 5 Wiederholungen. Trag ein leichtes erstes Gewicht ein, Metria schlägt den Rest vor.",
        "ramp_one": "Kalibrierungssatz {{n}}: mehr Gewicht. Schluss bei {{effort}} oder nach {{count}} Satz.",
        "ramp_other": "Kalibrierungssatz {{n}}: mehr Gewicht. Schluss bei {{effort}} oder nach {{count}} Sätzen.",
        "done": "Kalibrierung fertig. Speichere, und der neue MAX wartet in den Benachrichtigungen."
      }
    },
    "coachEdges": {
      "empty": "Noch keine Coach-Verbindungen. Ein Coach kann Sie aus der Web-App einladen."
    },
    "recovery": {
      "banner": "Wiederhergestelltes Workout",
      "orphanedBanner": "Du hast dieses Workout korrigiert, aber es wurde auf einem anderen Gerät gelöscht. Tippe auf Als neu speichern, um deine Korrektur als neues Workout zu behalten.",
      "tooBigBanner": "Deine Korrektur hat zu viele Sätze auf einmal geändert, das Workout blieb unverändert. Tippe auf Als neu speichern, um deine Version als neues Workout zu behalten.",
      "conflictBanner": "Das Workout wurde vor deiner Korrektur auf einem anderen Gerät geändert und blieb unverändert. Tippe auf Als neu speichern, um deine Korrektur als neues Workout zu behalten.",
      "timesBanner": "Deine Korrektur endet, bevor sie beginnt, das Workout blieb unverändert. Tippe auf Als neu speichern, korrigiere die Zeiten und speichere.",
      "staleBanner": "Das Workout wurde nach Beginn der Korrektur erneut gespeichert. Es blieb unverändert. Tippe auf Als neu speichern, um deine Korrektur zu behalten.",
      "refusedBanner": "Der Server hat deine Korrektur abgelehnt, das Workout blieb unverändert. Tippe auf Als neu speichern, um deine Version als neues Workout zu behalten.",
      "saveAsNew": "Als neu speichern",
      "title": "Wiederhergestelltes Workout",
      "openBody": "Dieses Workout wurde unterbrochen und wiederhergestellt. Prüfe die Sätze und tippe auf Speichern, um es als neues Workout zu sichern.",
      "open": "Öffnen",
      "cancel": "Abbrechen",
      "liveBusy": "Du hast ein laufendes Workout. Speichere oder verwirf es, bevor du dieses wiederherstellst.",
      "discardTitle": "Wiederhergestelltes Workout verwerfen?",
      "discardBody": "Das wiederhergestellte Workout wird dauerhaft gelöscht.",
      "discardConfirm": "Verwerfen",
      "error": "Workout konnte nicht wiederhergestellt werden. Versuche es erneut.",
      "mergeTitle": "Workout zusammenführen",
      "mergePrompt": "Wähle ein Workout vom selben Tag zum Zusammenführen:",
      "noSameDay": "Kein Workout vom selben Tag zum Zusammenführen. Nutze „Als neu speichern\".",
      "nothingToMerge": "Keine abgeschlossenen Sätze zum Zusammenführen. Nutze „Als neu speichern\".",
      "supportPrefix": "Workout nach einem Absturz auf diesem Handy aufbewahrt, aus der Glocke gesendet. Entwurfs-JSON im Anhang."
    },
    "group": {
      "title": "Übung gruppieren",
      "close": "Schließen",
      "standalone": "Einzeln",
      "supersetSection": "SUPERSÄTZE",
      "circuitSection": "ZIRKEL",
      "supersetN": "Supersatz {{n}}",
      "circuitN": "Zirkel {{n}}",
      "newSuperset": "+ Neuer Supersatz",
      "newCircuit": "+ Neuer Zirkel"
    },
    "webview": {
      "close": "Schließen",
      "openExternal": "Im Browser öffnen",
      "errorTitle": "Die Seite konnte nicht geladen werden",
      "errorBody": "Tippe unten, um den System-Browser zu probieren.",
      "fallbackErrorTitle": "Browser konnte nicht geöffnet werden",
      "fallbackErrorBody": "Versuche es aus einem anderen Netzwerk."
    },
    "plates": {
      "title": "Scheibenrechner",
      "close": "Schließen",
      "apply": "Übernehmen",
      "targetLabel": "Ziel",
      "barLabel": "Stange ({{unit}})",
      "barOptionLabel": "Stange — {{weight}}",
      "barCustom": "Andere…",
      "barCustomLabel": "Eigenes Stangengewicht",
      "perSide": "Pro Seite: {{weight}}",
      "barOnly": "Nur Stange — keine Scheiben nötig.",
      "pairs_one": "{{count}} Paar",
      "pairs_other": "{{count}} Paare",
      "plates_one": "{{count}} Scheibe",
      "plates_other": "{{count}} Scheiben",
      "loadedSide": "Beladene Seite: {{weight}}",
      "singleSideHint": "Nur eine Seite: Die Scheiben kommen auf eine einzige Seite. Landmine, T-Bar, Schlitten und Hebel pro Arm werden so beladen.",
      "remainder": "Abweichung {{weight}} — der Bestand passt nicht genau.",
      "belowBar": "Ziel unterhalb des Stangengewichts.",
      "invalid": "Gib ein gültiges Gewicht ein.",
      "inventoryTitle": "Verfügbare Paare ({{unit}})",
      "pairsIncrement": "Ein Paar {{weight}} hinzufügen",
      "pairsDecrement": "Ein Paar {{weight}} entfernen",
      "signLabel": "EXTRA-VORZEICHEN",
      "signAdd": "+ Mit Zusatzgewicht",
      "signAssist": "− Unterstützt",
      "loadShapeLabel": "Wie geladen wird",
      "loadShapeTwoSides": "Zwei Seiten",
      "loadShapeOneSide": "Eine Seite",
      "loadShapeTwoSidesHint": "Paare",
      "loadShapeOneSideHint": "ein Stapel",
      "composeTitle": "Scheiben ({{unit}}) — zum Hinzufügen tippen",
      "composeEmpty": "Keine Scheiben eingerichtet — lege unten fest, welche Paare du hast.",
      "composeAddPair": "Ein Paar {{weight}} auf die Stange legen",
      "composeAddPlate": "Eine Scheibe {{weight}} auf die Stange legen",
      "composeRemovePair": "Ein Paar {{weight}} von der Stange nehmen",
      "composeRemovePlate": "Eine Scheibe {{weight}} von der Stange nehmen",
      "roundToLoadable": "Auf ein ladbares Gewicht runden",
      "calcOpen": "Taschenrechner",
      "calcResult": "Ergebnis: {{value}} {{unit}}",
      "calcClearKey": "C",
      "calcClear": "Löschen",
      "calcDecimal": "Komma",
      "calcOpPlus": "Plus",
      "calcOpMinus": "Minus",
      "calcOpTimes": "Mal",
      "calcOpDivide": "Geteilt durch",
      "calcDismiss": "Schließen",
      "calcCopy": "Ins Gewicht übernehmen",
      "calcCopyBlocked": "Rechne zuerst ein Gewicht über null aus."
    },
    "restTimerScreen": {
      "title": "Timer",
      "back": "Zurück"
    },
    "licenses": {
      "title": "Open-Source-Lizenzen",
      "back": "Zurück",
      "headlineIntro": "$t(brand.product) stützt sich auf eine kleine Gruppe von Bibliotheken, die das App-Erlebnis wesentlich prägen. Tippe eine Zeile an, um das Projekt zu öffnen — und erwäge, jene zu unterstützen, die du am häufigsten nutzt.",
      "coreSection": "Kernbibliotheken ({{count}})",
      "viewAllTitle": "Alle Pakete anzeigen",
      "viewAllSub": "Vollständige Namensnennung für die {{count}} im APK enthaltenen Pakete, nach Projekt gruppiert.",
      "allTitle": "Alle Pakete ({{count}})",
      "searchAll": "Name, Gruppe, Lizenz oder Autor suchen",
      "groupOther": "Sonstige Pakete",
      "empty": "Kein Paket entspricht der Suche.",
      "footer": "Erstellt am {{date}}",
      "openErrorTitle": "Link kann nicht geöffnet werden"
    },
    "share": {
      "newPR": "NEUER PR",
      "topLifts": "TOP ÜBUNGEN",
      "durationMinute": "Min.",
      "durationHour": "Std.",
      "durationMinuteShort": "m",
      "footerSets": "Sätze",
      "footerDensitySuffix": "/Min.",
      "fallbackLabel": "Gesamtvolumen",
      "timeLabel": "Gesamtzeit",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impuls",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Kalorien",
      "blockEffort": "Anstrengung",
      "blockDistance": "Distanz",
      "effortHr": "{{avg}} Ø · {{peak}} max bpm",
      "effortHrMax": "{{pct}}% HFmax",
      "shareTitle": "$t(brand.product) Trainingseinheit",
      "shareErrorTitle": "Teilen fehlgeschlagen",
      "headlineLabelPR": "NEUER E1RM",
      "headlineLabelDelta": "GROSSER SPRUNG +{{delta}}",
      "headlineLabelSolid": "SOLIDE EINHEIT",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} Sätze",
      "blockTopLifts": "Top-Übungen",
      "fromSet": "aus {{weight}} × {{reps}}",
      "blockVolume": "Volumen",
      "blockDuration": "Dauer",
      "blockDensity": "Dichte",
      "blockNotes": "Notizen",
      "barsTitle": "Belastung pro Muskel",
      "bodyTitle": "Beanspruchte Muskeln",
      "sharing": "Wird vorbereitet…",
      "shareCta": "Trainingskarte teilen",
      "done": "Fertig",
      "summaryTitle": "Training gespeichert",
      "maxProposed_one": "Neues MAX für {{exercises}} vorgeschlagen: Du findest es in deinen Benachrichtigungen.",
      "maxProposed_other": "Neue MAX für {{exercises}} vorgeschlagen: Du findest sie in deinen Benachrichtigungen."
    },
    "common": {
      "back": "Zurück",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "close": "Schließen"
    },
    "account": {
      "title": "Konto",
      "labelDiagnostics": "DIAGNOSE",
      "navSub": "Name, Passwort, Export, Löschen, Abmelden",
      "nameLabel": "NAME",
      "namePlaceholder": "Dein Name",
      "saved": "Gespeichert",
      "passwordLabel": "PASSWORT ÄNDERN",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort bestätigen",
      "passwordChanged": "Passwort geändert.",
      "passwordSubmit": "Passwort aktualisieren",
      "deleteNeedsConnection": "Zum Löschen des Kontos ist eine Verbindung nötig. Stelle die Verbindung wieder her und versuche es erneut — diese Anfrage wird nie für später gespeichert."
    },
    "prefs": {
      "title": "Einheiten & Anzeige",
      "navSub": "Einheiten, Sprache, Hinweise",
      "unitsLabel": "Einheiten",
      "unitsHelp": "Standard-Gewichtseinheit für neue Sätze. Du kannst sie im Logger weiterhin pro Zeile überschreiben.",
      "weekStartLabel": "Woche beginnt am",
      "weekStartHelp": "Der Tag, an dem deine Trainingswoche neu startet. Die wöchentlichen Muskelziele zählen ab diesem Tag.",
      "unitsKg": "Kilogramm (kg)",
      "unitsLb": "Pfund (lb)",
      "glucoseUnitsLabel": "Glukose-Einheiten",
      "glucoseUnitsHelp": "Wie Glukose angezeigt und eingegeben wird. So oder so gleich gespeichert.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Themenpalette",
      "themePaletteHelp": "Wähle die app-weite Farbpalette.",
      "themeModeLabel": "Erscheinungsbild",
      "themeModeHelp": "Der Systemeinstellung folgen oder hell bzw. dunkel erzwingen.",
      "themeMode": {
        "system": "System",
        "light": "Hell",
        "dark": "Dunkel"
      }
    },
    "timeline": {
      "setNumber": "Satz {{n}}",
      "fail": "Fehlversuch",
      "failTip": "Fehlversuch speichert den Satz als versucht, aber nicht geschafft. Er zählt trotzdem als erledigt (der Pausentimer startet), zeigt ✕ in der Timeline und fließt nicht in dein e1RM ein.",
      "failTipA11y": "Was bedeutet Fehlversuch?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% vom Best",
      "e1rmNewBest": "Best",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-Reps",
      "dropsetTag": "Drop",
      "myorepA11y": "Myo-Reps-Satz",
      "dropsetA11y": "Drop-Satz",
      "setVolumeA11y": "Satzvolumen {{value}} {{unit}}",
      "noBodyweight": "Noch kein Körpergewicht",
      "approachBadge": "Aufwärmen",
      "approachBadgeA11y": "Aufwärmsatz, zählt nicht als Arbeitssatz",
      "setSummaryBothSidesA11y": "{{reps}} Wiederholungen mit {{weight}} {{unit}} pro Seite, beide Seiten gezählt",
      "e1rmLegendA11y": "Was ist e1RM?",
      "e1rmTip": "e1RM ist dein geschätztes 1RM für den Satz (Epley, Wdh. ≤ 12). „% vom Best“ vergleicht ihn mit deinem besten e1RM der letzten Zeit — niedriger = Luft nach oben; ↑ Best = neuer geschätzter Rekord.",
      "durationLabel": "Dauer",
      "hourShort": "Std",
      "minShort": "Min",
      "secShort": "Sek",
      "started": "Einheit gestartet",
      "addSet": "Satz hinzufügen",
      "insertSetBefore": "Satz vor Satz {{n}} einfügen",
      "removeSet": "Satz entfernen",
      "prevSet": "Vorheriger Satz",
      "nextSet": "Nächster Satz",
      "allLogged": "Alle Sätze erfasst — tippe + für einen weiteren.",
      "rosterLabel": "Übungen",
      "rosterHint": "tippen zum Wechseln",
      "focusEmptyHasRoster": "Wähle oben eine Übung aus, um zu beginnen, oder füge eine neue hinzu.",
      "focusAllLogged": "Alle Sätze erfasst. Füge oben eine Übung hinzu, oder speichere unten.",
      "cueNextSet": "→ Satz {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Übungsliste ausklappen",
      "rosterCollapseA11y": "Übungsliste einklappen",
      "rosterState": {
        "done": "fertig",
        "inProgress": "läuft",
        "notDone": "offen"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} von {{count}})",
      "exerciseNote": "Übungsnotiz",
      "notePlaceholder": "Notiz zur Timeline hinzufügen…",
      "noteSend": "Notiz senden",
      "noteExpandA11y": "Notiz — zum vollständigen Lesen tippen",
      "noteDeleteA11y": "Notiz löschen",
      "uncompleteSetA11y": "Satz {{n}} von {{exercise}} entfernen — er ist wieder zu absolvieren",
      "dropsetActive": "Dropset — Runden unten bearbeiten.",
      "editingLogged": "Erfasster Satz {{n}} wird bearbeitet — Änderungen werden mit der Einheit gespeichert.",
      "addSetLocked": "Bearbeitung einer vergangenen Einheit: Sätze können nicht hinzugefügt werden. Korrigiere die Werte oder entferne einen Satz.",
      "createGroupLocked": "Bearbeitung einer vergangenen Einheit: Ein Supersatz kann nicht erstellt werden.",
      "splitGroupLocked": "Bearbeitung einer vergangenen Einheit: Ein Supersatz kann nicht aufgelöst werden.",
      "setTypeLocked": "Bearbeitung einer vergangenen Einheit: Der Satztyp (Dropset/Myorep) kann nicht geändert werden.",
      "addStepLocked": "Bearbeitung einer vergangenen Einheit: Es kann kein Dropset-Schritt hinzugefügt werden.",
      "setState": {
        "pending": "Satz {{n}} von {{total}}, offen",
        "done": "Satz {{n}} von {{total}}, erledigt",
        "pr": "Satz {{n}} von {{total}}, persönlicher Rekord",
        "failed": "Satz {{n}} von {{total}}, Fehlversuch"
      },
      "holdLabel": "Halten"
    },
    "home": {
      "targetsTopPatterns": "Top-Muster",
      "targetsSummary": "{{on}} von {{total}} im Ziel",
      "targetsHint": "Hefte ein Programm mit Wochenzielen an, um diese zu bewerten.",
      "targetsZoneOnTarget": "im Ziel",
      "targetsZoneOver": "über",
      "targetsZoneUnder": "im Aufbau",
      "targetsNoCoverage": "nicht abgedeckt",
      "targetsIncomplete": "unvollständig",
      "targetsIncompleteWhy": "Eine diese Woche erfasste Übung fehlt im Katalog, daher zählen ihre Sätze für keinen Muskel.",
      "targetsIncompleteNoBodyweight": "Eine Einheit dieser Woche wurde ohne dein Körpergewicht gespeichert, daher zählen ihre Eigengewichtssätze als null. Der Administrator berechnet sie neu: Du musst nichts tun.",
      "targetsIncompleteMayBeHigher": "Die tatsächliche Zahl kann höher sein.",
      "targetsIncompleteA11y": "Warum unvollständig",
      "targetsPrescribed": "Plan {{n}}",
      "targetsEmptyTitle": "Noch keine Ziele",
      "targetsEmptySub": "Lege fest, wie viel du jeden Muskel pro Woche trainieren willst. Dein Plan arbeitet darauf hin; die Home-Anzeige zeigt dir, wo du stehst.",
      "targetsEmptyCta": "Ziele festlegen",
      "weekEyebrow": "Diese Woche",
      "weeklySessions": "Workouts",
      "weeklyVolume": "Volumen",
      "weeklyA11y": "{{sessions}} Workouts, {{volume}} Volumen",
      "viewProgress": "Fortschritt ansehen",
      "badgesTitle": "Badges",
      "prPrev": "Vorheriger Rekord",
      "prNext": "Nächster Rekord",
      "prPosition": "Rekord {{n}} von {{total}}",
      "eyebrow": "HEUTE",
      "blankTitle": "Bereit zum Training?",
      "blankLoading": "Plan wird geladen…",
      "blankBody": "Derzeit kein aktives Programm. In der Bibliothek hat $t(brand.product) fertige Programme: mit einem Tipp folgst du einem. Oder starte ein leeres Workout.",
      "blankLibrary": "Fertige Programme ansehen",
      "newWorkout": "Neues Training",
      "programMeta": "{{program}} · Woche {{week}}",
      "morePreview": " +{{count}} weitere",
      "startToday": "▶ Einheit starten",
      "blankInstead": "Stattdessen ein leeres Training starten",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} Wdh. Eigengew.",
      "weightTitle": "Körpergewicht",
      "weightSaved": "Gespeichert ✓",
      "weightCurrent": "Zuletzt: {{weight}}",
      "weightNone": "Erfasse dein Gewicht, um Trends zu verfolgen.",
      "weightSave": "Speichern",
      "repeatWorkout": "Training wiederholen",
      "form": {
        "title": "Bereitschaft",
        "ready": "Bereit",
        "caution": "Vorsicht",
        "rest": "Ruhe",
        "reasonNoData": "Zeichne eine Einheit auf, um deine Bereitschaft zu verfolgen.",
        "reasonBalanced": "Deine Trainingsbelastung wirkt ausgewogen.",
        "reasonFreshStart": "Du steigst wieder ein — fang ruhig an und bau eine Basis auf.",
        "reasonShortRest": "Einheiten dicht hintereinander — achte auf die Erholung.",
        "reasonHighFrequency": "Eine Woche mit hohem Volumen — erwäge einen leichteren Tag.",
        "reasonLoadSpike": "Deine Belastung ist stark über deinen jüngsten Durchschnitt gestiegen.",
        "reasonLongGap": "Es ist eine Weile her — fang leicht an, um wieder hochzukommen."
      },
      "glucoseSave": "Speichern",
      "weightSaveA11y": "Körpergewicht speichern",
      "glucoseSaveA11y": "Glukosewert speichern",
      "config": {
        "title": "Startseite anpassen",
        "open": "Startseite anpassen",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "dragHint": "Ziehe eine Karte am Griff, um sie zu verschieben.",
        "inactiveEmpty": "Nichts ausgeblendet. Tippe auf ✕ bei einer Karte, um sie auszublenden.",
        "pinned": "Immer sichtbar",
        "hide": "{{name}} ausblenden",
        "show": "{{name}} einblenden",
        "reorder": "{{name}} verschieben",
        "reorderKeys": "{{name}} verschieben, Pfeiltasten verwenden",
        "reorderHint": "Zum Verschieben ziehen, oder die Aktionen nutzen, um nach oben oder unten zu verschieben.",
        "moveUp": "Nach oben",
        "moveDown": "Nach unten",
        "reset": "Standard wiederherstellen",
        "saveError": "Die Startseite konnte nicht gespeichert werden. Bitte erneut versuchen.",
        "widget": {
          "hero": "Heute",
          "readiness": "Bereitschaft",
          "weeklyTargets": "Diese Woche",
          "quickWeight": "Körpergewicht",
          "quickGlucose": "Glukose",
          "badges": "Badges",
          "coverage": "Muskelabdeckung",
          "e1rmTrends": "E1RM-Trends",
          "repsAtLoad": "Wiederholungen bei festem Gewicht",
          "movementBalance": "Bewegungsbalance",
          "painVolume": "Schmerz × Volumen",
          "intensityHeatmap": "Intensitäts-Heatmap",
          "exerciseFrequency": "Vernachlässigte Übungen",
          "painMap": "Schmerzkarte",
          "measurements": "Maße"
        },
        "columnMain": "Hauptspalte",
        "columnRail": "Seitenspalte",
        "columnEmpty": "Keine Karten in dieser Spalte."
      },
      "painMapEmpty": "Kein Schmerz markiert.",
      "painMapOpenHint": "Öffnet deine Schmerzkarte zum Bearbeiten."
    },
    "superset": {
      "startingWith": "Supersatz beginnen mit",
      "joinExisting": "Zu bestehendem",
      "pairInWorkout": "Kombinieren (in diesem Training)",
      "templates": "Gespeicherte Supersätze",
      "templateInsertHint": "Diesen Supersatz einfügen; lange drücken zum Löschen",
      "templateDeleteBody": "Diesen gespeicherten Supersatz entfernen?",
      "createCta": "Supersatz erstellen ({{n}})",
      "cueCycle": "{{group}}, Übung {{pos}} von {{total}}. Tippen, um zu {{next}} zu wechseln.",
      "cueStatic": "{{group}}, Übung {{pos}} von {{total}}",
      "menuOpen": "Supersatz-Optionen",
      "menuSaveTemplate": "Als Vorlage speichern",
      "menuAddExercise": "Übung hinzufügen",
      "menuMoveUp": "Nach oben",
      "menuMoveDown": "Nach unten",
      "menuRemoveMember": "Diese Übung entfernen",
      "menuSplit": "Supersatz auflösen",
      "namePlaceholder": "Supersatz-Name (optional)"
    },
    "premium": {
      "badge": "Premium",
      "lockedA11y": "{{name}}, Premium, nicht Teil des Basisberichts"
    },
    "widgetConfig": {
      "stateClosed": "Zu",
      "stateOpen": "Offen",
      "expand": "{{name}} ausklappen",
      "collapse": "{{name}} einklappen"
    },
    "bell": {
      "channelName": "Hinweise"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Pausen-Standardwerte",
      "globalLabel": "Globaler Standard",
      "globalUnset": "Nicht festgelegt — verwende {{n}}s",
      "customLabel": "Übungen mit individuellem Standard",
      "customEmpty": "Keine übungsspezifischen Werte. Öffne im Logger die Pausen-Anzeige und tippe ⚙, um einen festzulegen.",
      "customRemoveA11y": "Individuelle Pause für {{name}} entfernen",
      "clearGlobal": "Zurücksetzen"
    },
    "hints": {
      "title": "Hinweise",
      "label": "Hinweis-Tooltips anzeigen",
      "help": "Halte eine Taste im Logger gedrückt, um zu sehen, was sie tut, oder tippe auf eine Spaltenüberschrift. Ausschalten, um die Hinweise zu verbergen, die von selbst erscheinen."
    },
    "exerciseAgePulse": {
      "label": "Lange nicht geübte Übung markieren",
      "help": "Ein Blinken am Verlaufs-Chip, wenn du eine Übung länger nicht gemacht hast. Ausschalten, um das Alter ohne das Blinken zu behalten."
    },
    "effortNudge": {
      "label": "Anstrengungs-Erinnerung",
      "help": "Ein seltener, dezenter Impuls auf der Anstrengungsleiste, solange ein Satz auf das Loggen wartet."
    },
    "inWorkoutMeter": {
      "label": "Ziel-Meter im Workout",
      "help": "Ein Streifen oben auf der Übungskarte mit dem Wochenziel für die Muskeln, die du trainierst."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Timer-Ton",
      "soundHelp": "Wird abgespielt, wenn die Pause vorbei ist.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibriert, wenn die Pause vorbei ist.",
      "previewButton": "Anhören",
      "pickerTitle": "Ton wählen",
      "pickerCancel": "Abbrechen",
      "category": {
        "serious": "Standard",
        "fun": "Lustig"
      },
      "soundOptions": {
        "none": "Keiner",
        "chime_crisp": "Glöckchen",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Klangschale",
        "tada_fanfare": "Tadaa",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "{{min}}–{{max}} s eingeben",
      "globalTitle": "Globale Standards",
      "restGlobal": "Pausen-Timer",
      "holdGlobal": "Halte-Timer",
      "saveRow": "{{label}} speichern",
      "customLabel": "Werte pro Übung",
      "customEmpty": "Noch keine Werte pro Übung. Auf + Hinzufügen tippen.",
      "unset": "Nicht gesetzt — {{n}}s",
      "add": "+ Hinzufügen",
      "editRestA11y": "Pause für {{name}} bearbeiten",
      "editHoldA11y": "Halten für {{name}} bearbeiten",
      "editA11y": "Timer für {{name}} bearbeiten",
      "isDefault": "Standard",
      "equalsDefaultHint": "Ein Wert gleich dem globalen Standard wird nicht als Override gespeichert.",
      "remove": "Entfernen"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Wähle, wohin dieser Build schreibt",
      "pickLabel": "Meine Daten schreiben nach",
      "pickHelp": "Nur Dev-Build. Jedes Backend hält eigene Sitzung, eigene Warteschlangen und einen eigenen Trainingsentwurf — ein Wechsel rührt das andere nie an.",
      "stageProduction": "PRODUKTION",
      "stageLab": "LABOR",
      "liveLabel": "DU SCHREIBST NACH",
      "liveChecking": "Prüfung…",
      "liveUnknown": "Unbekannt — das Backend hat nicht geantwortet",
      "liveNotProduction": "Hier liegt nicht dein echtes Training.",
      "confirmTitle": "Backend wechseln?",
      "confirmBody": "Die App lädt gegen {{stage}} neu. Dort ist eventuell eine neue Anmeldung nötig, und zwischengespeicherte Listen werden verworfen.",
      "confirmCta": "Wechseln",
      "blockedByQueue": "Nicht gewechselt: einige Schreibvorgänge sind noch nicht raus. Geh wieder online und lass die Warteschlangen leerlaufen."
    },
    "animations": {
      "cellularLabel": "Animationen auch ohne WLAN laden",
      "cellularHelp": "Standardmäßig aus. Die Animationen sind ohnehin da: das hier erlaubt der App nur, sie über mobile Daten im Voraus zu holen, etwa 20 bis 30 MB für ein Programm."
    },
    "crashReports": {
      "label": "Absturzberichte senden",
      "help": "Nach einem Absturz meldet der nächste Start unserem Server Fehler, Codestelle, Speicher sowie App- und Android-Version. Nie Trainings, Notizen, Gewichte oder Gesundheitsdaten."
    }
  },
  "web": {
    "preauth": {
      "tagline": "Krafttraining, das sich nach deiner Anstrengung richtet, danach wie du gerade drauf bist und nach der Ausrüstung, die du wirklich hast.",
      "status": "In Entwicklung. Registrierung geschlossen.",
      "contactLabel": "Zugang oder Informationen"
    },
    "crash": {
      "body": "Die App ist auf einen unerwarteten Fehler gestoßen. Deine gespeicherten Daten sind sicher — lade neu, um fortzufahren.",
      "reload": "Neu laden",
      "retryBody": "Die App ist auf einen unerwarteten Fehler gestoßen. Deine gespeicherten Daten sind sicher — versuche es erneut, und wenn dieser Bildschirm wiederkommt, schick uns die Meldung unten.",
      "retry": "Erneut versuchen"
    },
    "postSession": {
      "headlineLabelPR": "NEUER E1RM",
      "headlineLabelDelta": "GROSSER SPRUNG +{{delta}}",
      "headlineLabelSolid": "SOLIDE EINHEIT",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} Sätze",
      "blockE1rm": "E1RM",
      "fromSet": "aus {{weight}} × {{reps}}",
      "blockVolume": "Volumen",
      "blockDuration": "Dauer",
      "blockDensity": "Dichte",
      "barsTitle": "Belastung pro Muskel",
      "bodyTitle": "Beanspruchte Muskeln",
      "sharing": "Wird vorbereitet…",
      "shareCta": "Trainingskarte teilen"
    }
  },
  "muscle": {
    "quadriceps": "Quadrizeps",
    "hamstrings": "Hintere Oberschenkel",
    "glutes": "Gesäßmuskeln",
    "adductors": "Adduktoren",
    "abductors": "Abduktoren",
    "calves": "Waden",
    "core": "Rumpf",
    "obliques": "Schräge Bauchmuskeln",
    "erectors": "Unterer Rücken",
    "pectoralis": "Brust",
    "anterior-delts": "Vorderer Deltamuskel",
    "lateral-delts": "Seitlicher Deltamuskel",
    "triceps": "Trizeps",
    "lats": "Latissimus",
    "rhomboids": "Rautenmuskeln",
    "rear-delts": "Hinterer Deltamuskel",
    "traps": "Trapezmuskel",
    "biceps": "Bizeps",
    "forearms": "Unterarme"
  },
  "experience": {
    "menuLabel": "Aktives Profil",
    "athlete": "Athlet",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Übung",
    "targetKeyExercise": "Übung",
    "targetRefAvg": "~{{n}}/Wo. Ø",
    "targetRefNone": "Keine Daten in den letzten 4 Wochen",
    "targetRefProgram": "Programm gibt ~{{n}}/Wo. vor",
    "targetUseAvg": "Durchschnitt nehmen",
    "targetUseProgram": "Programmwert nehmen",
    "projectionTitle": "Zielverteilung",
    "projectionWeek": "Woche {{n}}",
    "projectionContext": "Vom Programm in Woche {{n}} vorgeschriebene Sätze / Last.",
    "projectionTarget": "Ziel",
    "projectionWeekTotal": "Woche",
    "projectionRamp": "Zyklus",
    "projectionWeekShort": "W{{n}}",
    "projectionEmpty": "Nicht geplant",
    "targetsTitle": "Wochenziele",
    "targetsEmptyTitle": "Keine Wochenziele",
    "targetsEmptySub": "Füge eines hinzu, um die Level-Anzeige zu aktivieren.",
    "targetAdd": "Ziel hinzufügen",
    "targetRemove": "Ziel {{name}} entfernen",
    "targetCollapse": "Einklappen",
    "targetAxis": "Achse",
    "targetAxisMuscle": "Muskel",
    "targetMetric": "Metrik",
    "targetMetricHardSets": "Harte Sätze",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Wdh.",
    "targetKeyMuscle": "Muskel",
    "targetValue": "Wochenziel",
    "targetUnitHardSets": "harte Sätze",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "Wdh.",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "noch nicht in der Anzeige",
    "targetNotScoredNote": "Dieser Zieltyp zählt noch nicht in der Level-Anzeige.",
    "targetBandLabel": "Toleranz",
    "targetBandAsym": "−{{lo}} % / +{{hi}} %",
    "targetBandBelow": "Prozent unter dem Ziel",
    "targetBandAbove": "Prozent über dem Ziel",
    "targetBandRange": "Unten 0–99 %, oben 0 % oder mehr.",
    "compose": "Zusammenstellen",
    "preview": "Vorschau",
    "addExercises": "Übungen hinzufügen",
    "editingBlockDay": "Bearbeitung von T{{d}} — Aktualisieren wirkt auf diesen Tag (weitere Tage antippen, um sie dort ebenfalls anzuwenden)",
    "editingRampDay": "Wochen-Ramp an T{{d}} — Aktualisieren wirkt auf die gewählten Wochen, nur dieser Tag",
    "segments": "Segmente",
    "rampSwitchHint": "Erst aktualisieren oder abbrechen, dann das Segment wechseln",
    "setupHint": "Lege die Startform fest — Tage kannst du später im Editor hinzufügen oder entfernen und die Wochen ändern.",
    "repsHint": "Reps „5+“ = AMRAP: mindestens 5, dann so viele wie möglich.",
    "repsHintA11y": "Wie Wiederholungen geschrieben werden",
    "addingWeek": "Neue Woche W{{n}} — Aktualisieren fügt sie dieser Übung hinzu",
    "cloneWeek": "Woche klonen…",
    "cloneWeekFrom": "Von",
    "cloneWeekApply": "Klonen",
    "cloneWeekConflict": "{{name}} hat in W{{week}} (D{{day}}) bereits Inhalt",
    "cloneWeekEmpty": "Nichts zu klonen — gefüllte Quellwoche und mindestens ein Ziel wählen",
    "editingWeekDay": "Nur W{{n}} an T{{d}} wird bearbeitet — Aktualisieren löst sie aus dem Segment",
    "perWeek": "Pro Woche",
    "dupExercise": "{{name}} ist in D{{day}} in den gewählten Wochen bereits vorhanden",
    "days": "Tage",
    "weeks": "Wochen",
    "setNote": "Satz-Notiz",
    "removeExercise": "Übung entfernen",
    "replaceExercise": "Übung ersetzen",
    "clone": "Klonen",
    "remove": "Entfernen",
    "removeConfirm": "Bestätigen? ({{n}} Zellen)",
    "verbatim": "Erweiterter Slot (Multi-Variante) — bleibt unverändert, hier nicht bearbeitbar",
    "metaWeeks_one": "{{count}} Woche",
    "metaWeeks_other": "{{count}} Wochen",
    "tabPlan": "Plan",
    "importPlanHint": "Die Übungen kommen in den bearbeiteten Tag, in jede Woche des Zyklus.",
    "importPlanEmpty": "Noch keine gespeicherten Pläne.",
    "importPlanMeta_one": "{{count}} Übung",
    "importPlanMeta_other": "{{count}} Übungen",
    "importPlanAction_one": "{{name}} zu diesem Tag hinzufügen ({{meta}}), in der einzigen Woche des Zyklus",
    "importPlanAction_other": "{{name}} zu diesem Tag hinzufügen ({{meta}}), in allen {{count}} Wochen des Zyklus",
    "removeSlotConfirmTitle_one": "Aus dieser Woche entfernen?",
    "removeSlotConfirmTitle_other": "Aus allen {{count}} Wochen entfernen?",
    "removeSlotConfirm_one": "{{name}} aus diesem Tag entfernen? Die Vorgabe dieser Woche wird gelöscht.",
    "removeSlotConfirm_other": "{{name}} aus diesem Tag entfernen? Das löscht die Vorgaben aller {{count}} Wochen, nicht nur der angezeigten.",
    "metaDays_one": "{{count}} Trainingstag",
    "metaDays_other": "{{count}} Trainingstage",
    "gridToggle": "Intensitätsraster",
    "addDay": "Tag hinzufügen",
    "removeDay": "Tag D{{n}} entfernen",
    "removeDayConfirm": "Bestätigen — Tag D{{n}} entfernen?",
    "dayEmpty": "Noch keine Übungen an diesem Tag. Füge eine hinzu, um ihn aufzubauen.",
    "prescribeDayEmpty": "Noch keine Übungen an diesem Tag.",
    "prescribeFocusEmpty": "Wähle oben eine Übung, um ihre Sätze vorzugeben.",
    "prescribeViewMatrix": "Matrix",
    "prescribeViewEditor": "Editor",
    "prescribeViewGroup": "Ansicht wechseln",
    "checkEmptyCell": "W{{w}}·D{{d}} hat keine Übungen",
    "checkPctNoMax": "{{name}} nutzt %MAX ohne gespeichertes MAX",
    "exerciseNote": "Notiz zur Übung",
    "exerciseNotePlaceholder": "Notiz zu dieser Übung (beim Loggen sichtbar)",
    "panelHint": "Übung antippen zum Bearbeiten, Klonen oder Entfernen",
    "warnLine_one": "{{count}} Hinweis",
    "warnLine_other": "{{count}} Hinweise",
    "adjacencyWarnLine_one": "{{count}} Hinweis zur Muskelerholung",
    "adjacencyWarnLine_other": "{{count}} Hinweise zur Muskelerholung",
    "adjacencyWarnItem": "{{muscle}} an aufeinanderfolgenden Tagen trainiert ({{count}}×)",
    "publishChecklist": "Offene Hinweise (Veröffentlichen ist trotzdem möglich)",
    "publishClean": "Keine offenen Hinweise.",
    "weekShort": "Woche",
    "placed": "aktiv",
    "notPlaced": "inaktiv",
    "placementHint": "Eine Zelle gedrückt halten, um {{exercise}} dort zu setzen oder zu entfernen.",
    "addWeek": "Leere Woche hinzufügen",
    "removeWeek": "Woche entfernen",
    "holdDayToRemoveHint": "Einen Tag gedrückt halten, um ihn zu entfernen",
    "holdWeekToRemoveHint": "Eine Woche gedrückt halten, um sie zu entfernen",
    "holdAddWeekToCloneHint": "W ＋ gedrückt halten, um diese Woche zu wiederholen",
    "holdCellToPlaceHint": "Eine Zelle gedrückt halten, um die Übung dort einzusetzen",
    "cloneWeekAction": "Eine Woche hinzufügen, die diese wiederholt",
    "removeWeekConfirm": "Bestätigen — diese Woche und ihre Sätze entfernen",
    "coverageTitle": "Abdeckung — harte Sätze/Woche",
    "coverageHint": "Durchschnitt über den ganzen Zyklus. Eine Null zeigt sich hier, bevor du trainierst.",
    "rosterNotThisWeek": "nicht in dieser Woche",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} ist an {{cursor}} nicht eingeplant.",
    "prescribeLockedNewFields": "{{exercise}} hat Sätze je Runde, einen Wiederholungsbereich oder gemischte Lastachsen. Hier nur lesbar: auf dem Telefon bearbeiten.",
    "prescribePlaceHere": "Auf {{cursor}} setzen",
    "placementAddHere": "{{exercise}} hier einsetzen",
    "placementRemoveHere": "{{exercise}} hier entfernen",
    "weekCue": "Woche {{pos}} von {{total}}. Tippen für die nächste Woche.",
    "weekCuePrev": "Vorherige Woche",
    "targetRefThisWeek": "diese Wo. bisher {{n}}",
    "setNoteChip": "Notiz",
    "setNoteChipA11y": "Notiz zu einem Satz dieser Runde schreiben",
    "weekMenuHint": "Öffnet das Rundenmenü",
    "weekMenuHoldHint": "Tippen für das Rundenmenü. Halten, um die Runde zu entfernen.",
    "setNoteChipLocked": "Sichtbar, solange ein Satz eine Notiz hat",
    "importProgramBack": "Zurück zu den Programmen",
    "importProgramDayHint": "Seine Übungen kommen ans Ende des Tages, den du bearbeitest. Überzählige Runden fallen weg, fehlende bleiben leer.",
    "importProgramDayAction": "{{day}} aus {{program}} zu diesem Tag hinzufügen ({{meta}})",
    "importProgramEmpty": "Noch keine anderen Programme.",
    "importProgramOpen": "{{name}} ({{meta}}): einen Tag wählen",
    "importProgramDays_one": "{{count}} Tag",
    "importProgramDays_other": "{{count}} Tage",
    "importProgramRounds_one": "{{count}} Runde",
    "importProgramRounds_other": "{{count}} Runden"
  },
  "gym": {
    "setPlace": "Wo?",
    "whichPlace": "Wo trainierst du?",
    "newPlace": "Ort hinzufügen",
    "fallback": "Standard",
    "chipA11y": "Trainingsort",
    "footnote": "Sortiert, was du zuerst siehst. Geht nie an einen Coach.",
    "namePlaceTitle": "Diesen Ort benennen",
    "namePlaceHint": "Name des Ortes",
    "namePlaceSave": "Diesen Ort verwenden",
    "pinPlace": "{{place}} als Standard-Ort festlegen",
    "unpinPlace": "{{place}} als Standard-Ort entfernen",
    "pinHint": "Merkt sich diesen als den Ort, an dem du meistens trainierst.",
    "unpinHint": "Vergisst deinen Standard-Ort.",
    "pinErrorTitle": "Nicht gespeichert",
    "pinErrorBody": "Dein Standard-Ort bleibt unverändert."
  },
  "inbox": {
    "emptyTitle": "Posteingang",
    "emptyBody": "Nichts wartet gerade auf eine Antwort.",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "acknowledge": "Verstanden",
    "feedback": {
      "statusChanged": {
        "title": "Deine Meldung",
        "body": "Deine Meldung wurde als {{status}} markiert."
      }
    },
    "sessionCorrection": {
      "orphaned": {
        "title": "Korrektur wartet auf einem anderen Handy",
        "body": "Du hast ein Workout korrigiert, aber es wurde auf einem anderen Gerät gelöscht. Deine Korrektur ist noch auf dem Handy, auf dem du sie gespeichert hast: Öffne dort die Benachrichtigungen (die Glocke) und tippe auf Als neu speichern."
      }
    },
    "maxBump": {
      "raise": {
        "title": "Neues MAX",
        "body": "{{exercise}}: Dein Training zeigt ein neues MAX von {{suggestedKg}}."
      },
      "lower": {
        "title": "Dein MAX ist evtl. gesunken",
        "body": "{{exercise}}: Dein Training zeigt {{suggestedKg}}. Dein MAX ist {{currentKg}}, gesetzt {{weeks}}."
      },
      "confirm": "Bestätigen",
      "lowerTo": "Senken auf {{suggestedKg}}",
      "skip": "Überspringen",
      "keep": "{{currentKg}} behalten",
      "badDay": "Schlechter Tag",
      "thisWeek": "diese Woche",
      "weeksAgo_one": "vor {{count}} Woche",
      "weeksAgo_other": "vor {{count}} Wochen",
      "badDayHint": "Behält dein MAX und meldet sich für diese Übung erst wieder, wenn der Rückgang erneut auftritt."
    },
    "bodyweight": {
      "missing": {
        "title": "Dein Körpergewicht fehlt",
        "body": "Eigengewichtsübungen brauchen dein Gewicht, um Last und Volumen zu berechnen. Trage es unter Ich → Maße ein.",
        "cta": "Gewicht eintragen",
        "dismiss": "Nicht mehr erinnern"
      }
    },
    "coachEdge": {
      "invitedByCoach": {
        "title": "Coaching-Einladung",
        "body": "Ein Coach hat dich als Athlet:in eingeladen."
      },
      "invitedByAthlete": {
        "title": "Coaching-Anfrage",
        "body": "Ein:e Athlet:in hat dich als Coach eingeladen."
      }
    },
    "assignment": {
      "program": {
        "title": "Neues Programm",
        "body": "{{from}} möchte dir {{itemName}} zuweisen.",
        "bodySelf": "Du hast dir {{itemName}} als Coach geschickt — unten kannst du annehmen oder ablehnen."
      },
      "plan": {
        "title": "Neues Workout",
        "body": "{{from}} möchte dir {{itemName}} zuweisen.",
        "bodySelf": "Du hast dir {{itemName}} als Coach geschickt — unten kannst du annehmen oder ablehnen."
      },
      "accepted": {
        "title": "Zuweisung angenommen",
        "body": "{{itemName}} wurde angenommen."
      },
      "rejected": {
        "title": "Zuweisung abgelehnt",
        "body": "{{itemName}} wurde abgelehnt."
      }
    },
    "followedProgram": {
      "updated": {
        "title": "Programm aktualisiert",
        "body": "{{itemName}} wurde von seinem Autor geändert."
      },
      "removed": {
        "title": "Programm nicht mehr geteilt",
        "body": "Du hast keinen Zugriff mehr auf {{itemName}}."
      },
      "gone": {
        "title": "Programm gelöscht",
        "body": "{{itemName}} wurde von seinem Autor gelöscht."
      }
    },
    "followedPlan": {
      "updated": {
        "title": "Plan aktualisiert",
        "body": "{{itemName}} wurde von seinem Autor geändert."
      },
      "removed": {
        "title": "Plan nicht mehr geteilt",
        "body": "Du hast keinen Zugriff mehr auf {{itemName}}."
      },
      "gone": {
        "title": "Plan gelöscht",
        "body": "{{itemName}} wurde von seinem Autor gelöscht."
      }
    },
    "actionError": "Das hat nicht funktioniert. Versuch's noch mal.",
    "actionErrorItemGone": "Dieses Angebot ist nicht mehr verfügbar. Tippe auf Ablehnen, um die Karte zu entfernen.",
    "bell": {
      "label": "Hinweise",
      "title": "Benachrichtigungen",
      "close": "Benachrichtigungen schließen",
      "a11y_one": "{{count}} Benachrichtigung",
      "a11y_other": "{{count}} Benachrichtigungen"
    },
    "actionErrorNoLongerAssigned": "Der Absender hat es zurückgezogen. Tippe auf Ablehnen, um die Karte zu entfernen.",
    "actionErrorWrongParty": "Nur die eingeladene Person kann antworten.",
    "actionErrorFanout": "Es konnte nicht zu deiner Bibliothek hinzugefügt werden. Versuch's noch mal.",
    "loadError": "Benachrichtigungen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "local": {
      "eyebrow": "Dieses Handy",
      "action": {
        "open": "Öffnen",
        "hide": "Ausblenden",
        "retry": "Erneut versuchen",
        "details": "Details",
        "retrying": "Neuer Versuch…",
        "resume": "Fortsetzen",
        "discard": "Verwerfen",
        "merge": "Zusammenführen",
        "sendSupport": "An den Support senden",
        "sending": "Wird gesendet…"
      },
      "hcNoConsent": {
        "title": "Health Connect getrennt",
        "body": "Dein Konto hat keine Einwilligung für Health Connect, deshalb importiert dieses Handy nichts mehr. Was es schon gelesen hat, wartet hier, bis du dich wieder verbindest."
      },
      "hcRefusalTitle": {
        "granted": "Einwilligung nicht festgehalten",
        "revoked": "Widerruf nicht festgehalten",
        "revokedElsewhere": "Health Connect getrennt"
      },
      "hcDriftTitle": {
        "deviceOff": "Health Connect auf diesem Handy nicht erlaubt",
        "undated": "Bestätige deine Einwilligung für Health Connect",
        "noRecord": "Bestätige deine Einwilligung für Health Connect"
      },
      "hcUpdate": {
        "title": "Health Connect aktualisieren",
        "body": "$t(brand.product) kann Health Connect erst lesen, wenn du die App aktualisierst."
      },
      "stuckWrites": {
        "title_one": "{{count}} Speicherung ist nicht durchgegangen",
        "title_other": "{{count}} Speicherungen sind nicht durchgegangen",
        "body": "Dieses Handy hat es schon von selbst erneut versucht. Versuch es jetzt noch einmal, oder öffne die Details, um zu sehen, was nicht durchgegangen ist.",
        "bodyStill": "Gerade erneut versucht, ohne Erfolg. Öffne die Details, um zu sehen, was der Server jeweils geantwortet hat."
      },
      "draftResume": {
        "title": "Workout nicht gespeichert",
        "body": "Die App wurde während deines Workouts vom {{date}} geschlossen, es ist noch auf diesem Handy. Zum Verwerfen nutze Verwerfen in den Benachrichtigungen. Tippe, um fortzusetzen.",
        "discardTitle": "Dieses Workout verwerfen?",
        "discardBody": "Die Sätze, die du am {{date}} eingetragen hast, wurden nie gespeichert. Verwerfen löscht sie endgültig von diesem Handy."
      },
      "workoutRecovery": {
        "title": "Workout vom {{date}} noch nicht gespeichert",
        "titleCorrection": "Korrektur vom {{date}} nicht gespeichert",
        "body": "Die App wurde geschlossen, bevor dieses Workout gespeichert war, und dieses Handy hat es behalten. Erledigte Sätze: {{done}} von {{total}}. Speichere es als neues Workout, führe es mit einem vom selben Tag zusammen oder verwirf es.",
        "bodySent": "An den Support gesendet. Das Workout bleibt auf diesem Handy, bis du es speicherst, zusammenführst oder verwirfst."
      }
    },
    "actionErrorOffline": "Dafür brauchst du eine Verbindung. Verbinde dich neu und versuche es noch einmal."
  },
  "editorV3": {
    "addExerciseToRound": "{{name}} zu W{{n}} hinzufügen",
    "addToRound": "Zu W{{n}} hinzufügen",
    "alignTrimHint": "Entfernt die überzähligen Sätze am Ende. Rückgängig in der Meldung holt sie zurück.",
    "backToDay": "Zurück zu {{day}}",
    "clear": "Tag leeren",
    "clearBody_one": "{{count}} Übung wird entfernt.",
    "clearBody_other": "{{count}} Übungen werden entfernt.",
    "clearTitle": "{{day}} leeren?",
    "copyName": "{{name}} (Kopie)",
    "copyOnto": "Kopieren auf…",
    "copyOntoBody_one": "{{day}} hat {{count}} Übung. Eine Kopie von {{from}} ersetzt sie.",
    "copyOntoBody_other": "{{day}} hat {{count}} Übungen. Eine Kopie von {{from}} ersetzt sie.",
    "copyOntoFootnote": "Der gewählte Tag verliert seinen jetzigen Inhalt.",
    "copyOntoQuestion": "{{day}} auf welchen Tag kopieren?",
    "copyOntoTitle": "{{day}} ersetzen?",
    "copyRoundBody_one": "{{round}} hat {{count}} Übung über alle Tage. Eine Kopie von {{from}} ersetzt sie.",
    "copyRoundBody_other": "{{round}} hat {{count}} Übungen über alle Tage. Eine Kopie von {{from}} ersetzt sie.",
    "copyRoundFootnote": "Die gewählte Runde verliert ihren Inhalt, an jedem Tag.",
    "copyRoundQuestion": "{{round}} auf welche Runde kopieren?",
    "copyRoundTitle": "{{round}} ersetzen?",
    "dayChipA11y": "Tag {{n}} {{name}}",
    "dayCleared": "{{day}} geleert",
    "dayCopied": "Auf {{day}} kopiert",
    "dayDuplicated": "Tag dupliziert",
    "dayEmpty": "Noch keine Übungen in {{day}}.",
    "dayMenuA11y": "{{day}}, Tagesmenü",
    "dayName": "Name des Tages",
    "dayRemoved": "{{day}} entfernt",
    "daysA11y": "Tage",
    "dissolveSuperset": "Supersatz auflösen",
    "duplicateDay": "Tag duplizieren",
    "duplicateRound": "Runde duplizieren",
    "exerciseMenuA11y": "{{name}}, Menü",
    "exerciseRemoved": "{{name}} entfernt",
    "exerciseTipA11y": "Über {{name}}",
    "historyLoad": "wie letztes Mal",
    "lensA11y": "Tag anzeigen nach",
    "lensExercises": "Übungen",
    "lensRound": "Pro Runde",
    "moveDayEarlier": "Nach vorne",
    "moveDayLater": "Nach hinten",
    "moveRoundEarlier": "Nach vorne",
    "moveRoundLater": "Nach hinten",
    "notInRound": "Nicht in dieser Runde",
    "offRoundOnlyInDay": "Die einzige Übung dieses Tages in W{{n}}",
    "offRoundOnlyRound": "Sie kommt in keiner anderen Runde vor",
    "remove": "Entfernen",
    "removeDay": "Tag entfernen",
    "removeDayBody_one": "Der Tag geht mit seiner Übung.",
    "removeDayBody_other": "Der Tag geht mit seinen {{count}} Übungen.",
    "removeDayEmptyBody": "Der Tag ist leer.",
    "removeDayTitle": "{{day}} entfernen?",
    "removeExerciseBody": "Sie verlässt diesen Tag in allen Runden.",
    "removeExerciseTitle": "{{name}} entfernen?",
    "removeFromRound": "Aus W{{n}} entfernen",
    "removeRound": "W{{n}} entfernen",
    "removeRoundBody": "Seine Sätze verschwinden aus jedem Tag. Die Runden danach rücken einen Platz vor.",
    "removeRoundTitle": "W{{n}} entfernen?",
    "removedFromRound": "{{name}} aus W{{n}} entfernt",
    "renameDay": "Umbenennen",
    "renameSuperset": "Supersatz umbenennen",
    "renameTitle": "{{day}} umbenennen",
    "replace": "Ersetzen",
    "replaceExercise": "Übung ersetzen",
    "roundA11y": "Runde {{n}}: {{line}}",
    "roundChipA11y": "Runde {{n}}",
    "roundCopied": "Auf {{round}} kopiert",
    "roundDuplicated": "W{{n}} dupliziert",
    "roundLastInDay": "{{name}} ist die einzige Übung dieses Tages in W{{n}}. Entferne stattdessen die Übung oder die Runde.",
    "roundLastOfExercise": "W{{n}} ist die einzige Runde mit {{name}}. Entferne stattdessen die Übung.",
    "roundScope": "Wiederholungen, Last und Sekunden ändern sich nur in dieser Runde. Achse, Zeitgrenze und Sätze ändern sich in allen Runden.",
    "roundScopeLens": "Wiederholungen, Last, Sekunden und Sätze ändern sich nur in dieser Runde. Achse und Zeitgrenze ändern sich in allen Runden.",
    "alignPadEachRound": "+ In jeder Runde auf die längste erweitern",
    "alignTrimEachRound": "− In jeder Runde auf die kürzeste kürzen",
    "setsTrimmedEachRound": "Supersatz erstellt, Sätze in jeder Runde auf die kürzeste gekürzt",
    "roundSetAdded": "W{{n}}: ein Satz mehr",
    "roundSetRemoved": "W{{n}}: ein Satz weniger",
    "roundSetCount_one": "W{{n}}: {{count}} Satz",
    "roundSetCount_other": "W{{n}}: {{count}} Sätze",
    "roundOnlySet": "W{{n}} hat nur noch einen Satz. Nimm stattdessen die Übung aus der Runde.",
    "roundMixedBound": "W{{n}} unverändert: ein Zeitsatz und ein Wiederholungssatz würden die Plätze tauschen.",
    "setRangeA11y": "{{lo}} bis {{hi}} Sätze à",
    "roundsA11y": "Runden",
    "secondsUnit": "s",
    "setsTrimmed": "Supersatz erstellt, Sätze auf {{n}} gekürzt",
    "supersetN": "Supersatz {{n}}",
    "supersetName": "Name des Supersatzes",
    "supersetNameHint": "Leer lassen, um wieder die Nummer zu zeigen.",
    "supersetWithNext": "Supersatz mit der nächsten Übung",
    "variants": "Wechselt mit {{names}}. Hier noch nicht bearbeitbar.",
    "problems_one": "{{count}} Problem",
    "problems_other": "{{count}} Probleme",
    "problemPrev": "Vorheriges Problem, {{n}} von {{total}}",
    "problemNext": "Nächstes Problem, {{n}} von {{total}}",
    "problemGoA11y": "Problem {{n}} von {{total}}, {{where}}: {{message}}. Dorthin gehen",
    "select": "Auswählen",
    "selectDone": "Fertig",
    "selectA11y": "Übungen in {{day}} auswählen",
    "selectDoneA11y": "Auswahl in {{day}} beenden",
    "copyToOtherDays": "In andere Tage kopieren",
    "copyTo": "Kopieren in…",
    "copyToDaysQuestion": "{{what}} in welche Tage kopieren?",
    "copyToDaysFootnote": "Jeder Tag bekommt seine eigene Kopie, am Ende. Ein Superset kommt ganz.",
    "copyToDaysNone": "Kopieren",
    "copyToDaysConfirm_one": "In {{count}} Tag kopieren",
    "copyToDaysConfirm_other": "In {{count}} Tage kopieren",
    "copiedToDays": "In {{days}} kopiert.",
    "addedOneToDays": "{{name}} zu {{days}} hinzugefügt.",
    "addedManyToDays_one": "{{count}} Übung zu {{days}} hinzugefügt.",
    "addedManyToDays_other": "{{count}} Übungen zu {{days}} hinzugefügt.",
    "addedAgain_one": "{{days}} hatte sie schon: jetzt ist sie zweimal da.",
    "addedAgain_other": "{{days}} hatte einige schon: jetzt sind sie zweimal da.",
    "valuesFromRole": "Werte aus der Rolle des Tages.",
    "removeSelectedTitle_one": "{{count}} Übung entfernen?",
    "removeSelectedTitle_other": "{{count}} Übungen entfernen?",
    "removeSelectedBody_one": "Sie verlässt diesen Tag in allen Runden.",
    "removeSelectedBody_other": "Sie verlassen diesen Tag in allen Runden.",
    "selectedRemoved_one": "{{count}} Übung entfernt",
    "selectedRemoved_other": "{{count}} Übungen entfernt",
    "nExercises_one": "{{count}} Übung",
    "nExercises_other": "{{count}} Übungen",
    "selectedCount_one": "{{count}} ausgewählt",
    "selectedCount_other": "{{count}} ausgewählt",
    "programDayImported": "{{day}} aus {{program}} hinzugefügt.",
    "roundsDropped_one": "{{rounds}} weggelassen: dieses Programm hat weniger Runden.",
    "roundsDropped_other": "{{rounds}} weggelassen: dieses Programm hat weniger Runden.",
    "daysFull_one": "{{days}} hätte mehr als {{max}} Übungen: dort wird nichts hinzugefügt.",
    "daysFull_other": "{{days}} hätten mehr als {{max}} Übungen: dort wird nichts hinzugefügt.",
    "importNothing": "Nichts hinzugefügt: {{day}} hat keine Übung in den Runden dieses Programms.",
    "roundTypeMenu": "Rundentyp…",
    "roundTypeQuestion": "Was für eine Runde ist {{round}}?",
    "roundTypeNormal": "Normal",
    "roundTypeDeload": "Entlastung",
    "roundTypeTest": "Test",
    "roundTypedA11y": "Runde {{n}}, {{type}}: {{line}}",
    "roundChipTypedA11y": "Runde {{n}}, {{type}}",
    "roundTypeSet": "W{{n}} {{type}}. Gilt für: das ganze Programm.",
    "roundRemovedByRules": "W{{n}} entfernt. Von Hand geschriebene Zellen danach rücken mit ihrer Runde.",
    "roundTypeFootnoteRules": "Der Typ gilt für das ganze Programm. Jede Übung bekommt die Wirkung aus ihrer Regel.",
    "rule": {
      "name": {
        "constant": "Konstant",
        "effortRamp": "Belastungsrampe",
        "tetrad": "Tetrade, Test und Entlastung",
        "perSet": "Pro Satz",
        "linear": "Linear",
        "repsThenLoad": "Wiederholungen, dann Last",
        "triple": "Dreifache Progression",
        "timed": "Auf Zeit",
        "history": "Letztes Mal",
        "waves": "Wellen",
        "blocks": "In Blöcken",
        "pyramid": "Pyramide",
        "repsUp": "Steigende Wiederholungen",
        "topBackoff": "Top-Satz und Back-off"
      },
      "preset": {
        "linearKg": "Lineare Steigerung (kg)"
      },
      "manual": "Werte von Hand",
      "manualBody": "Keine Regel erkannt. Jede Zelle lässt sich von Hand ändern.",
      "title": "Regel · {{name}}",
      "perRound": "{{step}} pro Runde",
      "upTo": "{{what}} bis {{cap}}",
      "ramp_one": "von {{from}} auf {{to}} in {{count}} Runde",
      "ramp_other": "von {{from}} auf {{to}} in {{count}} Runden",
      "cycle": "im Wechsel {{values}}",
      "blocks_one": "{{count}} Block, der neu beginnt",
      "blocks_other": "{{count}} Blöcke, jeder beginnt neu",
      "threshold": "Wiederholungen {{min}} bis {{max}} in Schritten von {{step}}",
      "thenSets": "dann Sätze bis {{n}}",
      "thenLoad": "dann {{step}}",
      "repsStep": "{{step}} Wiederholungen",
      "amrapInTest": "letzter Satz AMRAP in der Testrunde",
      "testLast": "Testrunde {{step}} im letzten Satz",
      "testTop": "Testrunde {{step}} in den schwersten Sätzen",
      "test": "Testrunde {{step}}",
      "deloadPct": "Entlastung bei {{pct}} %",
      "deload": "Entlastung {{step}}",
      "deloadEffort": "Entlastung bei {{value}}",
      "deloadSets_one": "{{count}} Satz weniger in der Entlastung",
      "deloadSets_other": "{{count}} Sätze weniger in der Entlastung",
      "same": "in jeder Runde gleich",
      "applied": "Regel geändert. Gilt für: die Runden, die ihr folgen.",
      "appliedMany_one": "Regel auf {{count}} Übung angewandt. Gilt für: die Runden, die ihr folgen.",
      "appliedMany_other": "Regel auf {{count}} Übungen angewandt. Gilt für: die Runden, die ihr folgen.",
      "rowRealigned": "Zeile wieder an der Regel ausgerichtet.",
      "roundRealigned": "{{round}} wieder an der Regel ausgerichtet.",
      "blockAdded": "{{from}} bis {{to}} hinzugefügt.",
      "byHand": "{{round}} Satz {{set}}: von Hand geschrieben. Gilt für: nur hier.",
      "followsAgain": "Folgt wieder der Regel.",
      "handCount_one": "{{count}} Zelle von Hand",
      "handCount_other": "{{count}} Zellen von Hand",
      "handDone_one": "{{count}} von Hand in den erledigten Runden",
      "handDone_other": "{{count}} von Hand in den erledigten Runden",
      "realign": "Neu ausrichten",
      "realignHint": "Jede Zelle zurück auf die Regel",
      "change": "Regel ändern",
      "byHandMark": "von Hand",
      "realignRound": "{{round}} an der Regel ausrichten",
      "typedStays": "Ein hier eingegebener Wert bleibt deiner: Die Regel überschreibt ihn nicht.",
      "addBlock_one": "{{count}} Runde",
      "addBlock_other": "{{count}} Runden",
      "blockAdd_one": "{{count}} Runde hinzufügen",
      "blockAdd_other": "{{count}} Runden hinzufügen",
      "blockTitle": "{{from}}-{{to}} hinzufügen",
      "blockShape": "Eine Tetrade mehr: zwei normale Runden, eine Testrunde, eine Entlastungsrunde.",
      "blockCarry": "Zeilen mit Last und Wiederholungen machen dort weiter, wo sie waren.",
      "blockEffort": "Zeilen nach Anstrengung wiederholen ihre Form. Die Last steigt mit dem in der Testrunde gemessenen MAX.",
      "blockFocus": "Die neuen Runden folgen dem Modell mit diesem Schwerpunkt. Die Runden davor bleiben, wie sie sind.",
      "sheetTitle": "Regel",
      "sheetTitleMany_one": "Regel für {{count}} Übung",
      "sheetTitleMany_other": "Regel für {{count}} Übungen",
      "apply": "Anwenden",
      "presets": "Vorlagen",
      "changes": "ändert sich",
      "roundsChange_one": "{{count}} Runde ändert sich.",
      "roundsChange_other": "{{count}} Runden ändern sich.",
      "alsoTitle": "Auch anwenden auf:",
      "alsoSame": "Gleiche Übung, andere Tage",
      "alsoOthers": "Andere Übungen",
      "alsoShowAll": "Alle anzeigen",
      "alsoShowLess": "Weniger anzeigen",
      "alsoEach": "Jede Übung behält ihre eigenen Startwerte.",
      "lostTest": "Kein AMRAP in der Testrunde.",
      "lostTestMany": "Kein AMRAP in der Testrunde für: {{names}}.",
      "lostDeload": "Keine Entlastung.",
      "lostDeloadMany": "Keine Entlastung für: {{names}}.",
      "stallNever": "Das Gewicht steigt in diesen Runden nie.",
      "stallAt": "Das Gewicht steigt in diesen Runden nicht. Erste Steigerung: {{round}}.",
      "noRoundChanges": "Keine Runde ändert sich.",
      "handStays_one": "Die {{count}} Zelle von Hand bleibt.",
      "handStays_other": "Die {{count}} Zellen von Hand bleiben.",
      "supersetFollows": "Der Supersatz bekommt dieselbe Satzzahl.",
      "undoable": "Rückgängig holt es zurück.",
      "waveLess": "Ein Wert weniger im Zyklus",
      "waveMore": "Ein Wert mehr im Zyklus",
      "selectionAction": "Regel",
      "field": {
        "sets": "Sätze",
        "reps": "Wiederholungen",
        "effort": "Anstrengung",
        "step": "Schritt pro Runde",
        "cap": "Obergrenze",
        "load": "Ab",
        "deloadPct": "Entlastung",
        "repsMin": "Wdh. min",
        "repsMax": "Wdh. max",
        "repsStep": "Wdh.-Schritt",
        "loadStep": "Dann",
        "seconds": "Sekunden",
        "efforts": "Anstrengungen im Zyklus",
        "setsMax": "Sätze bis",
        "repsSetStep": "Wdh. pro Satz",
        "loadSetStep": "Last pro Satz",
        "backoffSets": "Back-off-Sätze",
        "topEffort": "Belastung Top-Satz",
        "backoffEffort": "Belastung Back-off",
        "off": "Keine"
      },
      "backoff": "Back-off-Sätze {{step}}",
      "eachSet": "jeder Satz {{steps}}",
      "handAxisResets_one": "{{count}} von Hand eingetragener Wert wird ersetzt: Die neue Regel nutzt eine andere Einheit.",
      "handAxisResets_other": "{{count}} von Hand eingetragene Werte werden ersetzt: Die neue Regel nutzt eine andere Einheit.",
      "lockedStay": "Erledigt bis {{round}}: diese Runden bleiben, wie sie sind.",
      "reference": "Ref. ≈ {{load}}",
      "pickPreset": "Keine Vorlage schreibt diese Regel. Wähle eine, um sie zu ersetzen.",
      "pickPresetManual": "Keine Regel erkannt. Wähle eine Vorlage, um die von Hand eingegebenen Werte zu ersetzen.",
      "blockFull": "Ein Programm hat höchstens {{max}} Runden: Für eine weitere Tetrade ist kein Platz."
    },
    "tetrad": {
      "scratchTitle": "Von vorn",
      "scratchBody": "Ein leerer Tag und vier Runden.",
      "rounds": "Runden",
      "roundsA11y_one": "{{count}} Runde",
      "roundsA11y_other": "{{count}} Runden",
      "perWeek": "Einheiten pro Woche",
      "perWeekA11y_one": "{{count}} Einheit pro Woche",
      "perWeekA11y_other": "{{count}} Einheiten pro Woche",
      "dayEmpty": "Keine Übung: Der Tag braucht mindestens eine.",
      "removeExercise": "{{name}} herausnehmen",
      "back": "Zurück",
      "needName": "Gib dem Programm zuerst einen Namen.",
      "needDay": "Jeder Tag braucht mindestens eine Übung: Nimm eine wieder auf.",
      "putBack": "{{name}} wieder aufnehmen",
      "takenOut": "entfernt"
    },
    "model": {
      "fromModel": "Aus einem Modell",
      "fromModelBody": "Das Modell schreibt die Tage und die Runden. Du wählst das Niveau, die Zeit pro Einheit und die Übungen.",
      "fromTemplate": "Aus einer Vorlage",
      "fromTemplateBody": "Eine Kopie eines öffentlichen Programms, nach Belieben zu ändern.",
      "noModel": "Noch kein Modell.",
      "noTemplate": "Noch keine Vorlage.",
      "loading": "Wird geladen…",
      "loadError": "Laden fehlgeschlagen. Tippe, um es erneut zu versuchen.",
      "level": "Niveau",
      "minutes": "Minuten pro Einheit",
      "minutesA11y_one": "{{count}} Minute",
      "minutesA11y_other": "{{count}} Minuten",
      "minutes45": "Keine optionalen Übungen, und ein Satz weniger bei den Zusatzübungen.",
      "minutes60": "Keine optionalen Übungen.",
      "minutes75": "Alle Übungen des Modells.",
      "focus": "Schwerpunkt",
      "focusStrength": "Kraft",
      "focusMass": "Masse",
      "focusStrengthHint": "Wenige Wiederholungen bei den Grundübungen, lange Pausen. Der Entlastungstag bleibt leicht.",
      "focusMassHint": "Mehr Sätze und Wiederholungen, kürzere Pausen. Der Entlastungstag wird zum Volumentag.",
      "rotateHint_one": "Der Tag wiederholt sich: Eine Runde dauert {{length}} Tage.",
      "rotateHint_other": "Die {{count}} Tage wechseln sich ab: Eine Runde dauert {{length}} Tage.",
      "blocksHint_one": "Das Modell läuft einmal.",
      "blocksHint_other": "Das Modell läuft {{count}}-mal: Jedes Mal beginnt es eine Stufe höher.",
      "swapA11y_one": "{{name}}. Gegen die Alternative tauschen",
      "swapA11y_other": "{{name}}. Gegen eine von {{count}} Alternativen tauschen",
      "alternatives": "Alternativen",
      "alternativesCount_one": "{{count}} Alternative",
      "alternativesCount_other": "{{count}} Alternativen",
      "mine": "Meine Modelle",
      "builtIn": "Vorgegeben",
      "noMine": "Noch keins. Tippe in der Bibliothek bei einem deiner Programme auf „Als Modell speichern“.",
      "deleteTitle": "Dieses Modell löschen?",
      "deleteBody": "„{{name}}“ wird gelöscht. Programme, die daraus entstanden sind, bleiben.",
      "deleteError": "Das Modell konnte nicht gelöscht werden. Versuch es noch einmal.",
      "deleting": "Wird gelöscht…"
    },
    "roundLocked": "W{{n}} ist schon erledigt: sie bleibt, wie sie ist.",
    "lock": {
      "unlock": "Entsperren",
      "unlockA11y": "Die erledigten Runden entsperren",
      "title": "Erledigte Runden entsperren?",
      "body": "Erledigte Einheiten lesen ihre Vorgabe aus dem Programm: Änderst du {{rounds}}, ändert sich, was im Verlauf als vorgegeben steht. Sie bleiben entsperrt, bis du den Editor schließt.",
      "done": "erledigt",
      "doneA11y": "erledigt, schreibgeschützt",
      "offDone": "Nicht in dieser Runde, und sie ist schon erledigt: oben entsperren, um die Übung hinzuzufügen.",
      "readOnly": "{{round}} ist erledigt: schreibgeschützt. Oben im Editor entsperren.",
      "range": "{{from}}-{{to}}"
    },
    "grid": {
      "structure": "Aufbau",
      "exercise": "Übung",
      "lensEffort": "Anstrengung",
      "lensReps": "Wiederholungen",
      "lensLoad": "Last",
      "lensSets": "Sätze",
      "dayPeak": "Spitze",
      "dayPeakA11y": "Spitze: {{band}}",
      "setsFieldA11y": "{{name}}, {{round}}: Sätze in dieser Runde",
      "setsNote": "Gib die Sätze einer Runde ein: die Änderung gilt nur für diese Runde, im ganzen Supersatz.",
      "lensA11y": "Im Raster zeigen",
      "roundHeadA11y": "{{round}}, Rundenmenü",
      "cellA11y": "{{name}}, {{round}}: {{line}}",
      "note": "Eine Ansicht nach der anderen. „Last“ zeigt das eingetragene Gewicht, oder ≈ die Last aus deinem MAX für eine Zeile nach Anstrengung. Tippe auf ein Feld, um es rechts zu öffnen. Geschrieben wird hier nur in der Ansicht „Sätze“: Wiederholungen, Last und Anstrengung änderst du im Bereich rechts.",
      "pickExercise": "Wähle eine Übung im Raster, um sie hier zu sehen.",
      "keysNote": "Tasten: Pfeile bewegen, Umschalt mit Pfeil oder Klick wählt einen Block, Esc bricht ab. Enter öffnet die Übung; in „Sätze“ schreibt Enter oder eine Ziffer. Strg+C kopiert und Strg+V fügt ein (Cmd am Mac). In „Sätze“ füllt Strg+D nach unten und Strg+R nach rechts, statt der Befehle des Browsers. Zieh das Quadrat an der Ecke des Blocks, um zu füllen.",
      "effortOfMax": "{{load}} · ≈{{pct}} %",
      "why": {
        "setsOnly": "nur die Ansicht Sätze lässt sich beschreiben",
        "off": "die Übung ist nicht in dieser Runde",
        "locked": "die Runde ist schon erledigt",
        "parse": "kein Wert für diese Ansicht",
        "lastSet": "eine Runde behält mindestens einen Satz",
        "mixedBound": "ein Satz auf Zeit und ein Satz auf Wiederholungen würden die Plätze tauschen"
      },
      "nothingWritten": "Nichts eingetragen: {{why}}.",
      "cellsWritten_one": "{{count}} Feld eingetragen, nur in seiner Runde.",
      "cellsWritten_other": "{{count}} Felder eingetragen, jedes nur in seiner Runde.",
      "cellsSkipped_one": "{{count}} blieb, wie es war: {{why}}.",
      "cellsSkipped_other": "{{count}} blieben, wie sie waren: {{why}}.",
      "cellsCopied_one": "{{count}} Feld kopiert.",
      "cellsCopied_other": "{{count}} Felder kopiert.",
      "cellsSelected_one": "{{count}} Feld ausgewählt",
      "cellsSelected_other": "{{count}} Felder ausgewählt",
      "selectA11y": "Felder in {{day}} auswählen",
      "selectDoneA11y": "Feldauswahl in {{day}} beenden",
      "menu": {
        "actions": "Aktionen",
        "title": "Ausgewählte Felder",
        "copy": "Kopieren",
        "paste": "Einfügen",
        "fillDown": "Nach unten füllen",
        "fillRight": "Nach rechts füllen",
        "noClipboardRead": "dieser Browser lässt die Seite die Zwischenablage nicht lesen",
        "needsRows": "mehr als eine Zeile auswählen",
        "needsCols": "mehr als eine Runde auswählen",
        "clipboardRefused": "Der Browser hat die Zwischenablage nicht erlaubt."
      },
      "act": {
        "select": "Hier mit der Auswahl beginnen",
        "extend": "Auswahl bis hierher erweitern",
        "copy": "Auswahl kopieren",
        "paste": "Auf der Auswahl einfügen",
        "fillDown": "Auswahl nach unten füllen",
        "fillRight": "Auswahl nach rechts füllen"
      },
      "tapToStart": "Tippen Sie auf ein Feld, um zu beginnen"
    }
  },
  "simulator": {
    "title": "Simulation",
    "subtitle": "das Programm wie geschrieben, ohne Verlauf",
    "summaryOut_one": "{{count}} Muskel außerhalb des Bands",
    "summaryOut_other": "{{count}} Muskeln außerhalb des Bands",
    "summaryInBand": "Jeder trainierte Muskel liegt im Band",
    "summaryMinutes": "~{{n}} Min. pro Einheit",
    "roundIsNotWeek_one": "Eine Runde dieses Zyklus hat {{count}} Einheit, und er verlangt {{week}} pro Woche: Jedes „pro Woche“ hier meint eine Runde.",
    "roundIsNotWeek_other": "Eine Runde dieses Zyklus hat {{count}} Einheiten, und er verlangt {{week}} pro Woche: Jedes „pro Woche“ hier meint eine Runde.",
    "musclesTitle": "Harte Sätze pro Woche, Schnitt des Zyklus",
    "perWeekDays_one": "{{sets}} / Wo · {{days}} Tag",
    "perWeekDays_other": "{{sets}} / Wo · {{days}} Tage",
    "perWeekDaysA11y": "{{sets}} harte Sätze pro Woche, an {{days}} Tagen",
    "perWeekIndirect": "{{sets}} / Wo · nur indirekt",
    "perWeekIndirectA11y": "{{sets}} harte Sätze pro Woche, alle indirekt",
    "direction": {
      "unlikelyToGrow": "wahrscheinlich zu wenig für Wachstum",
      "likelyToGrow": "im Bereich, in dem Muskeln wachsen",
      "diminishingReturns": "mehr Sätze, kaum mehr Ertrag"
    },
    "weeksBelow": "unter MEV in {{weeks}}",
    "weeksAbove": "über MRV in {{weeks}}",
    "assumed": "{{n}} davon ohne RPE oder RIR, als hart gezählt",
    "notTrained": "Nicht trainiert: {{names}}",
    "assumedTotal_one": "{{assumed}} von {{count}} hartem Satz hat weder RPE, RIR noch Stoppregel: Er zählt als hart (RIR {{rir}} oder weniger).",
    "assumedTotal_other": "{{assumed}} von {{count}} harten Sätzen haben weder RPE, RIR noch Stoppregel: Sie zählen als hart (RIR {{rir}} oder weniger).",
    "patternsTitle": "Tage pro Woche je Bewegung",
    "days_one": "{{n}} Tag",
    "days_other": "{{n}} Tage",
    "repsTitle": "Sätze nach Wiederholungen",
    "repsRow_one": "{{count}} Wiederholung",
    "repsRow_other": "{{count}} Wiederholungen",
    "repsAmrap_one": "davon {{count}} AMRAP-Minimum",
    "repsAmrap_other": "davon {{count}} AMRAP-Minima",
    "repsTimed_one": "{{count}} Satz auf Zeit",
    "repsTimed_other": "{{count}} Sätze auf Zeit",
    "repsOpen_one": "{{count}} offener Satz, Wiederholungen im Training notiert",
    "repsOpen_other": "{{count}} offene Sätze, Wiederholungen im Training notiert",
    "effortTitle": "Sätze nach Anstrengung",
    "untargeted": "Ohne Anstrengungsziel, Last: {{axis}}",
    "axis": {
      "absolute": "ein festes Gewicht",
      "percentage": "ein % vom Max",
      "history": "die letzte Einheit",
      "none": "nicht angegeben"
    },
    "staticTitle": "Zeilen, die in jeder Runde gleich bleiben",
    "staticNone": "Keine: Jede Zeile ändert sich im Zyklus.",
    "staticRow_one": "{{day}} · {{exercise}}: gleich in {{count}} Runde",
    "staticRow_other": "{{day}} · {{exercise}}: gleich in {{count}} Runden",
    "staticByEffortRows_one": "{{count}} Zeile mit Last nach Anstrengung: Das Gewicht kann noch steigen",
    "staticByEffortRows_other": "{{count}} Zeilen mit Last nach Anstrengung: Das Gewicht kann noch steigen",
    "staticNoFixed": "Keine hat ein festes Gewicht.",
    "durationTitle": "Dauer der Einheit, geschätzt",
    "minutes": "{{n}} Min.",
    "minutesRange": "{{min}} bis {{max}} Min.",
    "untimed_one": "{{count}} Satz ohne Zeit: Die Pause zählt, die Arbeit nicht",
    "untimed_other": "{{count}} Sätze ohne Zeit: Die Pause zählt, die Arbeit nicht",
    "amrapTitle": "AMRAP-Sätze",
    "amrapRow": "{{week}} · {{day}} · {{exercise}}, Satz {{set}}: mindestens {{reps}}",
    "amrapNoStop": "keine Stoppregel geschrieben",
    "source": {
      "acsm": "ACSM 2009, moderates Tempo"
    },
    "assumptions": "Richtungen, keine Prognosen: das Programm wie geschrieben, bei einem Athleten ohne Verlauf. Harter Satz: RIR {{rir}} oder weniger. Band: {{band}}. Eine Wiederholung: {{secs}} s ({{source}}). Pause nicht angegeben: {{rest}} s, {{superset}} s im Supersatz. Entlastungsrunden werden nicht am Band gemessen.",
    "unknown_one": "{{count}} Übung ist nicht im Katalog und zählt nicht: {{names}}",
    "unknown_other": "{{count}} Übungen sind nicht im Katalog und zählen nicht: {{names}}"
  }
}
